import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import {
    cellyticsAnalysisDataUrl,
    cellyticsAnalysisSet,
    cellyticsCurrentAnalysisSetId,
    cellyticsDefaultAnalysisSet,
    cellyticsRecommendedCaseId,
} from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const PRESENTATION_BODY_CLASS = "report-presentation-mode";
const DRAWING_COLOR = "#ef4444";
const DRAWING_LINE_WIDTH = 5;
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};
const EMPTY_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
const IMAGE_PRELOAD_TIMEOUT_MS = 4500;
const INTEGRATED_REPORT_DATA_URL = "/assets/cellytics/260622/report-data.json?v=260625-page-optimized";
const REPORT_PDF_DOWNLOAD_VERSION = "260826-slides-only-v2";
const REPORT_PDF_DOWNLOADS: { [setId: string]: { url: string; filename: string } } = {
    "260604": {
        url: `/assets/cellytics/reports/cellytics-nk-260604-report.pdf?v=${REPORT_PDF_DOWNLOAD_VERSION}`,
        filename: "cellytics-nk-260604-report.pdf",
    },
    "260622": {
        url: `/assets/cellytics/reports/cellytics-nk-260622-report.pdf?v=${REPORT_PDF_DOWNLOAD_VERSION}`,
        filename: "cellytics-nk-260622-report.pdf",
    },
};
const JSON_FETCH_CACHE: { [url: string]: Promise<any> } = {};
type DrawingPoint = { x: number; y: number };
type DrawingStroke = DrawingPoint[];
const INTEGRATED_REPORT_SET_IDS = ["260612", "260619"];
const INTEGRATED_REPORT_METRICS = [
    { key: "PPD", label: "PPD", digits: 2 },
    { key: "WSM_SD", label: "WSM-sd", digits: 3 },
    { key: "CSP", label: "CSP", digits: 2 },
];
const INTEGRATED_PRIMARY_METRICS = [
    ...INTEGRATED_REPORT_METRICS,
    { key: "I3", label: "I3", digits: 1, derived: true },
];
const INTEGRATED_PARAMETER_TABLE_METRICS = [
    { key: "CMV", label: "CMV", digits: 2 },
    { key: "PPD", label: "PPD", digits: 2 },
    { key: "MMD", label: "MMD", digits: 2 },
    { key: "MMD_SD", label: "MMD_STD", digits: 2 },
    { key: "WCM", label: "WCM", digits: 2 },
    { key: "WCM_SD", label: "WCM_STD", digits: 2 },
    { key: "WSM", label: "WSM", digits: 2 },
    { key: "WSM_SD", label: "WSM_STD", digits: 2 },
    { key: "CSP", label: "CSP", digits: 2 },
    { key: "I3", label: "I3", digits: 1, derived: true },
];
const INTEGRATED_RESULT_SECTIONS = {
    threshold: {
        setId: "260612",
        slideIndex: 90,
        kicker: "260612 data analysis",
        title: "260612 데이터 분석 결과: 원본 / Blur / MMD std",
        note: "260612 데이터만 사용해 원본, Blur, MMD std 12.6, MMD std 13.5 조건을 비교합니다.",
        cases: ["original", "blur", "mmd_threshold_12_6", "mmd_filter"],
        descriptions: {
            original: "전처리 전 원본 분석 결과입니다.",
            blur: "2x2 box blur 적용 후 결과입니다.",
            mmd_threshold_12_6: "원본 기준 MMD_STD 12.6 초과 cell을 제외한 결과입니다.",
            mmd_filter: "원본 기준 MMD_STD 13.5 초과 cell을 제외한 결과입니다.",
        } as any,
    },
    blurMmd: {
        setId: "260612",
        slideIndex: 91,
        kicker: "260612 data analysis",
        title: "260612 데이터 분석 결과: 원본 / MMD std / Blur+MMD std",
        note: "원본, MMD std 13.5, Blur 후 MMD std 12.6 조건을 같은 방식으로 비교합니다.",
        cases: ["original", "mmd_filter", "blur_mmd_threshold_12_6"],
        descriptions: {
            original: "전처리 전 원본 분석 결과입니다.",
            mmd_filter: "원본 기준 MMD_STD 13.5 초과 cell을 제외한 결과입니다.",
            blur_mmd_threshold_12_6: "Blur 결과에서 MMD_STD 12.6 초과 cell을 제외한 집계 결과입니다.",
        } as any,
    },
    "260619Single": {
        setId: "260619",
        slideIndex: 92,
        kicker: "260619 data analysis",
        title: "260619 데이터 분석 결과: 원본 / Background / Blur / MMD std",
        note: "260619 데이터만 사용해 원본, Background, Blur, MMD std 12.6, MMD std 13.5 조건을 비교합니다.",
        cases: ["original", "background", "blur", "mmd_threshold_12_6", "mmd_filter"],
        descriptions: {
            original: "전처리 전 원본 분석 결과입니다.",
            background: "autoled 밝기장을 기준으로 background subtraction을 적용한 결과입니다.",
            blur: "2x2 box blur 적용 후 결과입니다.",
            mmd_threshold_12_6: "원본 기준 MMD_STD 12.6 초과 cell을 제외한 결과입니다.",
            mmd_filter: "원본 기준 MMD_STD 13.5 초과 cell을 제외한 결과입니다.",
        } as any,
    },
    "260619Combination": {
        setId: "260619",
        slideIndex: 93,
        kicker: "260619 data analysis",
        title: "260619 데이터 분석 결과: 원본 / BG+Blur+MMD / BG+MMD",
        note: "260619 데이터만 사용해 원본, Background+Blur+MMD std 13.5, Background+MMD std 13.5 조건을 비교합니다.",
        cases: ["original", "background_blur_mmd_filter", "background_mmd_filter"],
        descriptions: {
            original: "전처리 전 원본 분석 결과입니다.",
            background_blur_mmd_filter: "Background 보정, 2x2 box blur, MMD_STD 13.5 filtering을 모두 적용한 결과입니다.",
            background_mmd_filter: "Background 보정 후 MMD_STD 13.5 filtering을 적용한 결과입니다.",
        } as any,
    },
} as any;
const INTEGRATED_SAMPLE_RESULT_SECTIONS: any = {
    "260612": {
        setId: "260612",
        slideIndex: 2,
        kicker: "260612 sample CSP review",
        title: "260612 샘플별 CSP 그래프",
        note: "샘플 버튼과 전처리 과정을 선택해 A/B/C/D 이미지, vehicle/ASC CSP box plot, CMV~CSP 및 I3 값을 확인합니다.",
        cases: ["original", "blur", "mmd_filter", "blur_mmd_filter"],
    },
    "260619": {
        setId: "260619",
        slideIndex: 3,
        kicker: "260619 sample CSP review",
        title: "260619 샘플별 CSP 그래프",
        note: "Background, Blur, MMD std 13.5 및 2개/3개 조합 전처리 결과를 샘플별로 비교합니다.",
        cases: [
            "original",
            "background",
            "blur",
            "mmd_filter",
            "background_blur",
            "background_mmd_filter",
            "blur_mmd_filter",
            "background_blur_mmd_filter",
        ],
    },
};
const INTEGRATED_PIPELINE_STEPS = [
    {
        index: "01",
        caseId: "background",
        title: "BG",
        label: "Background subtraction",
        description: "저주파 밝기장을 추정해 배경 광원 편차를 제거하고 PPD/CSP 기준을 맞춥니다.",
        tone: "emerald",
    },
    {
        index: "02",
        caseId: "blur",
        title: "Blur",
        label: "Noise reduction",
        description: "2x2 box blur로 고주파 노이즈를 낮춰 WSM-sd 흔들림을 완화합니다.",
        tone: "blue",
    },
    {
        index: "03",
        caseId: "mmd_filter",
        title: "MMD-STD filtering",
        label: "Outlier filtering",
        description: "MMD_STD threshold를 넘는 cell을 제외해 불안정 신호 영향을 줄입니다.",
        tone: "rose",
    },
    {
        index: "결과",
        caseId: "background_blur_mmd_filter",
        title: "BG + Blur + MMD",
        label: "최종 조합 결과",
        description: "autoled가 있는 데이터에서 적용 가능한 전체 전처리 조합입니다.",
        tone: "slate",
    },
];
const INTEGRATED_DATASET_SECTIONS = [
    {
        setId: "260619",
        slideIndex: 3,
        index: "04",
        label: "260619 데이터",
        badge: "autoled 있음",
        kicker: "260619 dataset section",
        title: "260619 데이터 전처리 비교",
        note: "autoled 기반 BG 조건을 포함해 260619 결과만 별도로 비교합니다.",
        finalCaseId: "background_blur_mmd_filter",
        comparisons: [
            {
                id: "260619-bg",
                tabLabel: "원본 vs BG",
                title: "원본 vs BG 적용 후",
                note: "autoled 폴더 기반 밝기 보정 전후 비교입니다.",
                baseCaseId: "original",
                targetCaseId: "background",
                steps: ["autoled 밝기장 기준 BG 적용", "원본 대비 PPD, WSM-sd, CSP, I3 변화 확인"],
            },
            {
                id: "260619-blur",
                tabLabel: "원본 vs Blur",
                title: "원본 vs Blur 적용 후",
                note: "260619 데이터만 사용해 Blur 처리 효과를 비교합니다.",
                baseCaseId: "original",
                targetCaseId: "blur",
                steps: ["원본 crop에 2x2 box blur 적용", "고주파 노이즈 완화 후 지표 변화 확인"],
            },
            {
                id: "260619-mmd",
                tabLabel: "원본 vs MMD",
                title: "원본 vs MMD filtering 후",
                note: "MMD_STD 13.5 기준 filtering 전후 비교입니다.",
                baseCaseId: "original",
                targetCaseId: "mmd_filter",
                steps: ["원본 cell별 MMD_STD 산출", "13.5 초과 cell 제외 후 지표 재집계"],
            },
            {
                id: "260619-bg-mmd",
                tabLabel: "원본 vs BG+MMD",
                title: "원본 vs BG+MMD 후",
                note: "BG 적용 후 MMD filtering까지 수행한 조건입니다.",
                baseCaseId: "original",
                targetCaseId: "background_mmd_filter",
                steps: ["BG 적용 결과를 기준으로 MMD filtering 수행", "원본 대비 CSP/I3 변화 확인"],
            },
            {
                id: "260619-bg-blur-mmd",
                tabLabel: "원본 vs BG+Blur+MMD",
                title: "원본 vs BG+Blur+MMD 후",
                note: "260619에서 적용 가능한 전체 전처리 조합입니다.",
                baseCaseId: "original",
                targetCaseId: "background_blur_mmd_filter",
                steps: ["BG, Blur, MMD filtering 순서로 적용", "최종 조합의 PPD, WSM-sd, CSP, I3 변화 확인"],
            },
            {
                id: "260619-threshold",
                tabLabel: "MMD 12.6 vs 13.5",
                title: "MMD threshold 12.6 vs 13.5",
                note: "260619 threshold sweep 결과에서 12.6과 13.5를 비교합니다.",
                baseCaseId: "mmd_threshold_12_6",
                targetCaseId: "mmd_filter",
                steps: ["threshold 12.6 조건 집계", "현재 기준 13.5 조건과 지표 변화율 비교"],
            },
        ],
    },
    {
        setId: "260612",
        slideIndex: 4,
        index: "05",
        label: "260612 데이터",
        badge: "autoled 없음",
        kicker: "260612 dataset section",
        title: "260612 데이터 전처리 비교",
        note: "autoled가 없어 BG 비교를 제외하고 260612 결과만 별도로 비교합니다.",
        finalCaseId: "blur_mmd_filter",
        comparisons: [
            {
                id: "260612-blur",
                tabLabel: "원본 vs Blur",
                title: "원본 vs Blur 적용 후",
                note: "260612 데이터만 사용해 Blur 처리 효과를 비교합니다.",
                baseCaseId: "original",
                targetCaseId: "blur",
                steps: ["원본 crop에 2x2 box blur 적용", "고주파 노이즈 완화 후 지표 변화 확인"],
            },
            {
                id: "260612-mmd",
                tabLabel: "원본 vs MMD",
                title: "원본 vs MMD filtering 후",
                note: "MMD_STD 13.5 기준 filtering 전후 비교입니다.",
                baseCaseId: "original",
                targetCaseId: "mmd_filter",
                steps: ["원본 cell별 MMD_STD 산출", "13.5 초과 cell 제외 후 지표 재집계"],
            },
            {
                id: "260612-blur-mmd",
                tabLabel: "원본 vs Blur+MMD",
                title: "원본 vs Blur+MMD 후",
                note: "260612에서 사용 가능한 최종 전처리 조합입니다.",
                baseCaseId: "original",
                targetCaseId: "blur_mmd_filter",
                steps: ["BG 없이 Blur 적용", "Blur 결과에 MMD filtering을 적용해 원본과 비교"],
            },
            {
                id: "260612-threshold",
                tabLabel: "MMD 12.6 vs 13.5",
                title: "MMD threshold 12.6 vs 13.5",
                note: "260612 전체 이미지를 12.6 기준으로 재분석한 threshold 결과를 기존 13.5 MMD filtering과 비교합니다.",
                baseCaseId: "mmd_threshold_12_6",
                targetCaseId: "mmd_filter",
                steps: ["threshold 12.6 분석 이미지와 지표 생성", "기존 13.5 MMD filtering 결과와 비교"],
            },
        ],
    },
];
const INTEGRATED_REPORT_CASES = [
    { id: "original", label: "원본", shortLabel: "원본" },
    { id: "background", label: "밝기 보정", shortLabel: "BG" },
    { id: "blur", label: "Blur", shortLabel: "Blur" },
    { id: "mmd_threshold_12_6", label: "MMD std 12.6", shortLabel: "MMD 12.6", threshold: 12.6 },
    { id: "mmd_filter", label: "MMD std 13.5", shortLabel: "MMD 13.5" },
    { id: "blur_mmd_threshold_12_6", label: "Blur + MMD std 12.6", shortLabel: "Blur+MMD 12.6", threshold: 12.6, baseCaseId: "blur", fallbackCaseId: "blur_mmd_filter" },
    { id: "background_blur", label: "BG + Blur", shortLabel: "BG+Blur" },
    { id: "background_mmd_filter", label: "BG + MMD", shortLabel: "BG+MMD" },
    { id: "background_blur_mmd_filter", label: "BG + Blur + MMD", shortLabel: "BG+Blur+MMD" },
    { id: "blur_mmd_filter", label: "Blur + MMD", shortLabel: "Blur+MMD" },
];
const INTEGRATED_COMPARISONS = INTEGRATED_DATASET_SECTIONS.flatMap((section: any) => {
    return section.comparisons.map((comparison: any) => ({
        ...comparison,
        setId: section.setId,
        setIds: [section.setId],
        datasetLabel: section.label,
    }));
});
const INTEGRATED_COHORTS = [
    { key: "normal:vehicle", diagnosis: "normal", assay: "vehicle", label: "정상 ve", color: "#047857" },
    { key: "normal:asc", diagnosis: "normal", assay: "asc", label: "정상 ASC", color: "#0f766e" },
    { key: "patient:vehicle", diagnosis: "patient", assay: "vehicle", label: "환자 ve", color: "#be123c" },
    { key: "patient:asc", diagnosis: "patient", assay: "asc", label: "환자 ASC", color: "#e11d48" },
];
const INTEGRATED_FINAL_CASE_BY_SET: { [key: string]: string } = {
    "260619": "background_blur_mmd_filter",
    "260612": "blur_mmd_filter",
};
const FIXED_METRIC_AXIS_MAX: { [key: string]: number } = {
    CMV: 200,
    PPD: 150,
    MMD: 150,
    MMD_SD: 15,
    WCM: 12,
    WCM_SD: 1.5,
    WSM: 25,
    WSM_SD: 2,
    CSP: 250,
    I3: 200,
};
const INTEGRATED_AXIS_TICK_COUNT = 5;

function fetchJsonCached(url: string) {
    if (!JSON_FETCH_CACHE[url]) {
        JSON_FETCH_CACHE[url] = fetch(url, { cache: "force-cache" })
            .then(async (response: Response) => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.json();
            })
            .catch((error: any) => {
                delete JSON_FETCH_CACHE[url];
                throw error;
            });
    }
    return JSON_FETCH_CACHE[url];
}

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
:host {
  display: block;
  height: 100%;
  background: #020617;
  color: #111827;
}

.presentation-root {
  display: grid;
  position: relative;
  grid-template-rows: auto minmax(0, 1fr);
  justify-items: center;
  gap: 14px;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #020617;
  padding: 14px;
}

:host-context(.report-presentation-mode) .presentation-root,
.presentation-root.is-presentation-mode,
.presentation-root:fullscreen {
  position: fixed;
  z-index: 2147483647;
  inset: 0;
  grid-template-rows: minmax(0, 1fr);
  gap: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
}

.presentation-root:-webkit-full-screen {
  grid-template-rows: minmax(0, 1fr);
  gap: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
}

.report-toolbar {
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 18px;
  width: min(100%, 1920px);
  min-height: 54px;
  border: 1px solid rgba(132, 204, 22, 0.24);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.9);
  padding: 10px 12px 10px 16px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
}

:host-context(.report-presentation-mode) .report-toolbar,
.presentation-root.is-presentation-mode .report-toolbar,
.presentation-root:fullscreen .report-toolbar,
.presentation-root:-webkit-full-screen .report-toolbar {
  display: none;
}

.report-toolbar-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.report-toolbar-kicker,
.report-toolbar-title {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-toolbar-kicker {
  color: #a3e635;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.report-toolbar-title {
  color: #f8fafc;
  font-size: 13px;
  font-weight: 800;
}

.report-toolbar-gap {
  min-width: 32px;
  flex: 1;
  border-top: 1px solid rgba(132, 204, 22, 0.26);
}

.present-mode-button {
  display: inline-flex;
  min-width: 138px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid #bef264;
  border-radius: 8px;
  background: #a3e635;
  color: #172554;
  font-size: 13px;
  font-weight: 950;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(190, 242, 100, 0.28), 0 0 22px rgba(163, 230, 53, 0.46);
}

.present-mode-button:hover {
  background: #bef264;
}

.present-mode-button:focus-visible {
  outline: 3px solid rgba(190, 242, 100, 0.42);
  outline-offset: 2px;
}

.pdf-download-button {
  display: inline-flex;
  min-width: 138px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(94, 234, 212, 0.72);
  border-radius: 8px;
  background: rgba(20, 184, 166, 0.18);
  color: #ccfbf1;
  font-size: 13px;
  font-weight: 950;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.pdf-download-button:hover:not(:disabled) {
  border-color: #5eead4;
  background: rgba(20, 184, 166, 0.3);
}

.pdf-download-button:disabled {
  cursor: wait;
  opacity: 0.68;
}

.pdf-download-button:focus-visible {
  outline: 3px solid rgba(94, 234, 212, 0.34);
  outline-offset: 2px;
}

.presentation-stage {
  position: relative;
  isolation: isolate;
  width: min(100%, (100vh - 96px) * 1.7778, 1920px);
  max-width: 1920px;
  max-height: calc(100vh - 96px);
  aspect-ratio: 16/9;
  margin: 0;
}

:host-context(.report-presentation-mode) .presentation-stage,
.presentation-root.is-presentation-mode .presentation-stage,
.presentation-root:fullscreen .presentation-stage,
.presentation-root:-webkit-full-screen .presentation-stage {
  width: min(100vw, 177.7778vh, 1920px);
  height: min(100vh, 56.25vw, 1080px);
  max-height: 1080px;
}

.presentation-drawing-canvas {
  position: absolute;
  z-index: 4;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  touch-action: none;
}

.presentation-drawing-canvas.is-enabled {
  cursor: crosshair;
  pointer-events: auto;
}

.presentation-drawing-toolbar {
  position: absolute;
  z-index: 5;
  top: 16px;
  right: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.presentation-drawing-toggle {
  display: inline-flex;
  min-width: 112px;
  height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.78);
  color: #fee2e2;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
}

.presentation-drawing-toggle:hover,
.presentation-drawing-toggle.is-active {
  border-color: #ef4444;
  background: #ef4444;
  color: #ffffff;
}

.presentation-drawing-toggle:focus-visible {
  outline: 3px solid rgba(248, 113, 113, 0.36);
  outline-offset: 2px;
}

.drawing-toggle-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
  border-radius: 50%;
  background: currentColor;
}

.presentation-slide {
  display: grid;
  position: absolute;
  z-index: 1;
  inset: 0;
  grid-template-rows: 112px minmax(0, 1fr) 34px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #ffffff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.34);
  opacity: 1;
  transform: translate3d(0, 0, 0);
  transition: opacity 240ms ease, transform 240ms ease, visibility 240ms ease;
  visibility: visible;
  --report-table-font-size: clamp(10px, 0.72vw, 13px);
}

.presentation-slide.is-active {
  z-index: 2;
}

.presentation-slide.is-hidden {
  display: grid;
  pointer-events: none;
  opacity: 0;
  transform: translate3d(18px, 0, 0);
  visibility: hidden;
}

.slide-header {
  padding: 30px 44px 0;
}

.slide-kicker {
  margin: 0;
  font-size: 12px;
  font-weight: 800;
  color: #64748b;
  letter-spacing: 0;
  text-transform: uppercase;
}

.slide-heading {
  margin: 6px 0 0;
  font-size: clamp(24px, 2.15vw, 40px);
  font-weight: 800;
  line-height: 1.14;
  color: #0f172a;
}

.slide-body {
  min-height: 0;
  padding: 20px 44px;
}

.slide-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 44px 20px;
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
}

.cover-slide {
  grid-template-rows: minmax(0, 1fr) 34px;
  background: #f8fafc;
}

.cover-body {
  display: grid;
  min-height: 0;
  grid-template-rows: minmax(0, 1fr) auto;
  justify-items: center;
  gap: 34px;
  padding: 92px 70px 26px;
}

.cover-copy {
  display: flex;
  min-height: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.cover-kicker {
  margin: 0;
  font-size: 13px;
  font-weight: 900;
  color: #0f766e;
  letter-spacing: 0;
  text-transform: uppercase;
}

.cover-title {
  margin: 12px 0 0;
  max-width: 100%;
  font-size: clamp(44px, 4.2vw, 78px);
  font-weight: 900;
  line-height: 1.04;
  color: #0f172a;
  white-space: nowrap;
}

.cover-author-panel {
  display: flex;
  min-height: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  align-self: end;
  max-width: min(720px, 100%);
  padding: 0;
  text-align: center;
}

.cover-author-label {
  margin: 0;
  font-size: 10px;
  font-weight: 900;
  color: #0f766e;
  letter-spacing: 0;
  text-transform: uppercase;
}

.cover-author-name {
  margin: 8px 0 0;
  color: #0f172a;
  font-size: clamp(20px, 1.8vw, 32px);
  font-weight: 900;
  line-height: 1.1;
}

.cover-author-lines {
  display: grid;
  gap: 5px;
  margin-top: 12px;
  padding-top: 0;
}

.cover-author-lines p {
  margin: 0;
  color: #334155;
  font-size: clamp(11px, 0.86vw, 15px);
  font-weight: 750;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.cover-footer {
  justify-content: flex-end;
}

.csp-explanation-layout {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  gap: 16px;
}

.csp-main-panel,
.csp-image-panel,
.rationale-card {
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.csp-main-panel {
  display: grid;
  grid-template-rows: auto auto;
  align-content: center;
  gap: 14px;
  padding: 18px;
}

.csp-equation {
  display: grid;
  grid-template-columns: repeat(5, auto);
  align-items: center;
  justify-content: start;
  gap: 12px;
  border: 1px solid #99f6e4;
  border-radius: 8px;
  background: #f0fdfa;
  padding: 14px 18px;
  color: #134e4a;
  font-size: clamp(22px, 1.85vw, 36px);
  font-weight: 900;
}

.csp-factor-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: stretch;
  gap: 12px;
}

.csp-factor-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 15px;
}

.csp-factor-card.warning {
  border-color: #fecaca;
  background: #fef2f2;
}

.factor-label {
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  color: #0f766e;
}

.csp-factor-card.warning .factor-label {
  color: #b91c1c;
}

.csp-factor-card h3,
.rationale-copy h3 {
  margin: 8px 0 0;
  font-size: clamp(18px, 1.25vw, 25px);
  font-weight: 900;
  line-height: 1.2;
  color: #0f172a;
}

.csp-factor-card p:last-child,
.rationale-copy p {
  margin: 10px 0 0;
  font-size: clamp(12px, 0.88vw, 16px);
  font-weight: 600;
  line-height: 1.5;
  color: #475569;
}

.csp-image-panel {
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  border: 0;
  background: transparent;
}

.rationale-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.rationale-card {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}

.rationale-copy {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 16px;
}

.rationale-images {
  display: grid;
  min-height: 0;
  gap: 10px;
  padding: 12px;
}

.rationale-images.split {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.rationale-images button {
  position: relative;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f1f5f9;
  cursor: pointer;
}

.rationale-images img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rationale-images span {
  position: absolute;
  right: 8px;
  bottom: 8px;
  left: 8px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  padding: 6px 8px;
  color: #0f172a;
  font-size: 10px;
  font-weight: 900;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preprocessing-slide .slide-heading {
  font-size: 38px;
}

.preprocessing-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: auto 282px;
  align-content: start;
  gap: 10px;
}

.preprocess-method-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;
  gap: 14px;
  padding-top: 10px;
}

.preprocess-method-card {
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto auto auto;
  align-content: start;
  gap: 7px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}

.preprocess-method-card.emerald {
  border-color: #a7f3d0;
  background: #ecfdf5;
}

.preprocess-method-card.blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.preprocess-method-card.rose {
  border-color: #fecdd3;
  background: #fff1f2;
}

.preprocess-method-header {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}

.preprocess-method-number {
  display: inline-flex;
  width: 38px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #0f172a;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
}

.preprocess-trigger {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.2;
}

.preprocess-method-card h3 {
  margin: 5px 0 0;
  color: #0f172a;
  font-size: 23px;
  font-weight: 900;
  line-height: 1.14;
}

.preprocess-method-copy {
  margin: 0;
  color: #334155;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.4;
}

.preprocess-evidence-row {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 8px;
}

.preprocess-evidence-image {
  position: relative;
  min-width: 0;
  min-height: 0;
  aspect-ratio: 980/735;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 7px;
  background: #ffffff;
  padding: 0;
  cursor: pointer;
}

.preprocess-evidence-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f8fafc;
}

.preprocess-evidence-image span {
  position: absolute;
  right: 6px;
  bottom: 6px;
  left: 6px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.92);
  padding: 5px 6px;
  color: #0f172a;
  font-size: 10px;
  font-weight: 950;
  line-height: 1.1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mmd-threshold-callout {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(225, 29, 72, 0.28);
  border-radius: 7px;
  background: #ffffff;
  color: #be123c;
  font-size: 24px;
  font-weight: 950;
  line-height: 1;
  text-align: center;
}

.preprocess-flow {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  align-self: end;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
  padding: 7px;
}

.preprocess-flow span {
  display: inline-flex;
  min-width: 0;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  overflow-wrap: anywhere;
  border-radius: 6px;
  background: #ffffff;
  padding: 6px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.2;
  text-align: center;
}

.preprocess-flow .preprocess-arrow {
  min-height: auto;
  background: transparent;
  padding: 0;
  color: #64748b;
  font-size: 15px;
}

.preprocess-conclusion-panel {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(250px, 0.36fr) minmax(0, 1fr);
  gap: 14px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px;
}

.preprocess-conclusion-lead {
  display: flex;
  min-height: 0;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  background: #0f172a;
  padding: 16px;
}

.preprocess-conclusion-kicker {
  margin: 0;
  color: #a3e635;
  font-size: 14px;
  font-weight: 950;
  line-height: 1;
}

.preprocess-conclusion-lead h3 {
  margin: 8px 0 0;
  color: #ffffff;
  font-size: 22px;
  font-weight: 900;
  line-height: 1.22;
}

.preprocess-conclusion-lead p:last-child {
  margin: 10px 0 0;
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 750;
  line-height: 1.35;
}

.preprocess-conclusion-list {
  display: grid;
  min-height: 0;
  align-content: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: preprocess-conclusion;
}

.preprocess-conclusion-list li {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 12px;
  color: #334155;
  font-size: 15px;
  font-weight: 760;
  line-height: 1.3;
}

.preprocess-conclusion-list li::before {
  counter-increment: preprocess-conclusion;
  content: counter(preprocess-conclusion);
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e2e8f0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 950;
  line-height: 1;
}

.grid-2,
.grid-3,
.grid-4 {
  display: grid;
  gap: 16px;
  min-height: 0;
}

.grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.column {
  display: flex;
  min-height: 0;
  flex-direction: column;
  gap: 14px;
}

.panel {
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.panel.soft {
  background: #f8fafc;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e2e8f0;
  padding: 9px 13px;
}

.panel-title {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.panel-note {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.blur-stat-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.stat-tile {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
}

.stat-label {
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
}

.stat-value {
  margin: 5px 0 0;
  font-size: clamp(20px, 2vw, 34px);
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
}

.stat-value.small {
  font-size: clamp(17px, 1.35vw, 24px);
}

.step-card {
  min-height: 0;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 15px;
  background: #f8fafc;
}

.step-card.emerald {
  border-color: #a7f3d0;
  background: #ecfdf5;
}

.step-card.blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.step-card.rose {
  border-color: #fecdd3;
  background: #fff1f2;
}

.pipeline-workspace,
.background-slide-layout,
.bg-result-layout {
  display: grid;
  min-height: 0;
  gap: 14px;
}

.pipeline-workspace {
  grid-template-rows: 154px 38px minmax(0, 1fr);
}

.pipeline-slide .slide-heading {
  font-size: clamp(30px, 2.45vw, 46px);
}

.pipeline-slide .pipeline-workspace {
  grid-template-rows: 162px 38px minmax(0, 1fr);
}

.pipeline-slide .pipeline-card {
  padding: 13px 14px;
}

.pipeline-slide .pipeline-card .step-title {
  font-size: 18px;
}

.pipeline-slide .pipeline-card .step-label {
  font-size: 12px;
}

.pipeline-slide .pipeline-card .step-description {
  margin-top: 7px;
  font-size: 12px;
  line-height: 1.38;
}

.pipeline-slide .step-number {
  min-width: 36px;
  height: 30px;
  font-size: 12px;
}

.pipeline-slide .panel-title {
  font-size: 15px;
}

.pipeline-slide .panel-note,
.pipeline-slide .chart-legend {
  font-size: 12px;
}

.pipeline-card-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.sample-result-switcher {
  display: flex;
  min-height: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 6px 8px 6px 12px;
}

.sample-result-switcher-label {
  flex-shrink: 0;
  color: #334155;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.sample-result-buttons {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.sample-result-button {
  display: inline-flex;
  width: 42px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
  cursor: pointer;
}

.sample-result-button:hover {
  border-color: #334155;
  background: #ffffff;
  color: #0f172a;
}

.sample-result-button.is-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #ffffff;
}

.sample-result-button:focus-visible {
  outline: 3px solid rgba(15, 23, 42, 0.22);
  outline-offset: 2px;
}

.pipeline-card {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 13px;
  text-align: left;
  cursor: pointer;
}

.pipeline-card.emerald {
  border-color: #a7f3d0;
  background: #ecfdf5;
}

.pipeline-card.blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.pipeline-card.rose {
  border-color: #fecdd3;
  background: #fff1f2;
}

.pipeline-card.amber {
  border-color: #fde68a;
  background: #fffbeb;
}

.pipeline-card.is-active {
  border-color: #0f172a;
  box-shadow: inset 0 0 0 2px #0f172a;
}

.pipeline-card .step-title {
  font-size: 16px;
}

.pipeline-card .step-description {
  margin-top: 7px;
  font-size: 11px;
  line-height: 1.38;
}

.pipeline-detail-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(330px, 0.32fr);
  gap: 14px;
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 28px;
  border-radius: 6px;
  background: #0f172a;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
}

.step-title {
  margin: 10px 0 0;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.step-label {
  margin: 2px 0 0;
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
}

.step-description {
  margin: 10px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: #475569;
}

.image-panel {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  text-align: left;
}

.image-panel button,
button.image-panel {
  cursor: pointer;
}

.image-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 11px;
  font-size: 12px;
  font-weight: 800;
  color: #334155;
}

.image-label span:last-child {
  font-size: 10px;
  color: #94a3b8;
}

.image-box {
  display: flex;
  min-height: 0;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
}

.image-box img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f1f5f9;
}

.table-wrap {
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.compact-table .data-table {
  font-size: var(--report-table-font-size);
}

.compact-table .data-table th,
.compact-table .data-table td {
  padding: 5px 7px;
}

.selected-pipeline-table {
  display: flex;
  flex-direction: column;
}

.selected-pipeline-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 9px 10px;
}

.selected-pipeline-table .data-table {
  flex: 1;
}

.pipeline-slide .selected-pipeline-table .data-table {
  font-size: var(--report-table-font-size);
}

.selected-pipeline-table .data-table th,
.selected-pipeline-table .data-table td {
  padding: 6px 7px;
}

.pipeline-slide .selected-pipeline-table .data-table th,
.pipeline-slide .selected-pipeline-table .data-table td {
  padding: 7px 8px;
}

.selected-pipeline-table .i3-table-row td {
  border-top: 2px solid #cbd5e1;
  background: #f8fafc;
  font-weight: 900;
}

.table-sub-value {
  margin-top: 2px;
  font-size: 9px;
  font-weight: 800;
  color: inherit;
}

.pipeline-slide .table-sub-value {
  font-size: 10px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--report-table-font-size);
  line-height: 1.14;
}

.data-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 800;
}

.data-table th,
.data-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 6px 8px;
  text-align: right;
  white-space: nowrap;
}

.data-table th:first-child,
.data-table td:first-child {
  text-align: left;
}

.data-table tr:last-child td {
  border-bottom: 0;
}

.metric-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.metric-row {
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #f8fafc;
  padding: 9px;
}

.metric-row-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  font-weight: 800;
  color: #0f172a;
}

.metric-caption {
  margin-top: 3px;
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
}

.bar-track {
  margin-top: 7px;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.bar-fill {
  height: 100%;
  border-radius: 999px;
}

.chart-panel,
.parameter-chart-panel {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.chart-panel-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 10px 12px;
}

.chart-panel-header.tight {
  padding: 8px 10px;
}

.chart-legend {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.legend-item::before {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  background: #64748b;
  content: "";
}

.legend-item.target::before {
  background: #0f766e;
}

.legend-item.box-blur::before {
  background: #2563eb;
}

.legend-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  padding: 4px 6px;
  color: #475569;
  white-space: nowrap;
}

.legend-pill::before {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 2px;
  background: #64748b;
  content: "";
}

.legend-pill.emerald::before {
  background: #059669;
}

.legend-pill.blue::before {
  background: #2563eb;
}

.legend-pill.rose::before {
  background: #e11d48;
}

.legend-pill.slate::before {
  background: #334155;
}

.legend-pill.is-active {
  border-color: #0f172a;
  color: #0f172a;
}

.pipeline-column-chart {
  display: block;
  min-height: 0;
  flex: 1;
  padding: 10px 12px 12px;
}

.metric-column-grid {
  display: grid;
  height: 100%;
  min-height: 0;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.metric-column-card {
  display: grid;
  min-height: 0;
  grid-template-rows: 18px minmax(0, 1fr);
  gap: 5px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #ffffff;
  padding: 7px;
}

.pipeline-slide .metric-column-card {
  grid-template-rows: 22px minmax(0, 1fr);
  gap: 6px;
}

.metric-column-header {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.metric-column-title,
.metric-column-delta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metric-column-title {
  font-size: 11px;
  font-weight: 800;
  color: #0f172a;
}

.pipeline-slide .metric-column-title {
  font-size: 12px;
}

.metric-column-delta {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 800;
}

.pipeline-slide .metric-column-delta {
  font-size: 11px;
}

.metric-column-plot {
  display: grid;
  min-height: 0;
  grid-template-columns: 34px minmax(0, 1fr);
}

.metric-y-axis {
  display: flex;
  min-height: 0;
  flex-direction: column;
  justify-content: space-between;
  padding: 1px 5px 18px 0;
  font-size: 8px;
  font-weight: 700;
  color: #64748b;
  text-align: right;
}

.pipeline-slide .metric-y-axis {
  font-size: 9px;
}

.metric-plot-frame {
  display: grid;
  min-height: 0;
  grid-template-rows: minmax(0, 1fr) 18px;
}

.metric-bar-plane {
  position: relative;
  min-height: 0;
  border-bottom: 1px solid #94a3b8;
  border-left: 1px solid #94a3b8;
  background: linear-gradient(to bottom, rgba(203, 213, 225, 0.75) 1px, transparent 1px) 0 0/100% 50%, #f8fafc;
}

.metric-bar-grid {
  position: absolute;
  inset: 7px 8px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: end;
  gap: 12px;
}

.metric-bar-slot {
  position: relative;
  height: 100%;
  min-width: 0;
}

.metric-column-bar {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: min(38px, 72%);
  min-height: 2px;
  transform: translateX(-50%);
  border-radius: 5px 5px 1px 1px;
}

.metric-column-bar.original {
  background: #64748b;
}

.metric-column-bar.target {
  background: #0f766e;
}

.metric-column-bar.box-blur {
  background: #2563eb;
}

.metric-column-bar.comparison-a {
  background: #0f766e;
}

.metric-column-bar.comparison-b {
  background: #2563eb;
}

.metric-x-axis {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 2px 8px 0;
  font-size: 9px;
  font-weight: 800;
  line-height: 16px;
  color: #475569;
  text-align: center;
}

.pipeline-slide .metric-x-axis {
  font-size: 10px;
}

.metric-x-axis span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pipeline-column-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
}

.pipeline-column-group {
  display: grid;
  min-height: 0;
  grid-template-rows: 18px minmax(0, 1fr) 18px 14px;
  gap: 4px;
}

.column-change,
.column-label,
.column-values,
.column-scale-note {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.column-change {
  font-size: 10px;
  font-weight: 800;
  line-height: 18px;
  text-align: center;
}

.column-track {
  position: relative;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: linear-gradient(to bottom, rgba(226, 232, 240, 0.6) 1px, transparent 1px) 0 0/100% 25%, #f8fafc;
}

.column-zero {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 0;
  left: 0;
  height: 1px;
  background: #94a3b8;
}

.column-bars {
  position: absolute;
  inset: 8px 6px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 3px;
}

.column-slot {
  position: relative;
  min-width: 0;
}

.stage-column {
  position: absolute;
  left: 50%;
  width: min(12px, 100%);
  min-height: 2px;
  transform: translateX(-50%);
}

.stage-column.positive {
  bottom: 50%;
  border-radius: 5px 5px 2px 2px;
}

.stage-column.negative {
  top: 50%;
  border-radius: 2px 2px 5px 5px;
}

.stage-column.neutral {
  top: calc(50% - 1px);
  height: 2px !important;
  border-radius: 999px;
  background: #94a3b8;
}

.stage-column.emerald {
  background: #059669;
}

.stage-column.blue {
  background: #2563eb;
}

.stage-column.rose {
  background: #e11d48;
}

.stage-column.slate {
  background: #334155;
}

.stage-column.is-selected {
  width: min(16px, 100%);
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px rgba(15, 23, 42, 0.5);
}

.column-label {
  font-size: 10px;
  font-weight: 800;
  line-height: 18px;
  color: #0f172a;
  text-align: center;
}

.column-values {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 9px;
  font-weight: 700;
  line-height: 14px;
  color: #64748b;
}

.value-separator {
  color: #94a3b8;
}

.column-scale-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #e2e8f0;
  padding-top: 5px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
}

.paired-chart {
  display: grid;
  min-height: 0;
  gap: 6px;
  padding: 10px 12px;
}

.paired-bar-row,
.sample-bar-row {
  min-height: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #ffffff;
  padding: 6px 8px;
}

.paired-bar-row {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 10px;
}

.paired-label,
.sample-bar-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  font-weight: 800;
  color: #0f172a;
}

.paired-label {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.paired-bars {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.paired-bars.compact {
  margin-top: 5px;
}

.bar-line {
  display: grid;
  min-width: 0;
  grid-template-columns: 54px minmax(0, 1fr) 70px;
  align-items: center;
  gap: 6px;
}

.bar-name,
.bar-value {
  overflow: hidden;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bar-value {
  color: #334155;
  text-align: right;
}

.bar-track.slim {
  height: 7px;
  margin-top: 0;
}

.bar-fill.original {
  background: #64748b;
}

.bar-fill.target {
  background: #0f766e;
}

.background-slide-layout {
  grid-template-rows: 126px 48px minmax(0, 1fr);
}

.background-summary-row {
  display: grid;
  min-height: 0;
  grid-template-columns: 1fr;
  gap: 14px;
}

.bg-stat-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.bg-stat-grid .stat-tile {
  padding: 16px;
}

.bg-stat-grid .stat-label {
  font-size: 12px;
}

.bg-stat-grid .stat-value {
  font-size: clamp(24px, 2vw, 34px);
}

.heatmap-row {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.heatmap-sample-carousel {
  min-height: 48px;
}

.heatmap-large .image-label {
  padding: 9px 12px;
  font-size: 13px;
}

.bg-result-layout {
  grid-template-columns: minmax(0, 1.03fr) minmax(0, 0.97fr);
}

.bg-image-column {
  display: grid;
  min-height: 0;
  grid-template-rows: 48px minmax(0, 1fr);
  gap: 10px;
}

.sample-carousel {
  display: grid;
  min-height: 0;
  grid-template-columns: 34px minmax(0, 1fr) 34px;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 6px 8px;
}

.sample-nav-button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.sample-nav-button:disabled {
  opacity: 0.35;
  cursor: default;
}

.sample-carousel-info {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(120px, 0.34fr) minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.sample-carousel-title {
  margin: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 800;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-carousel-dots {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}

.sample-carousel-dot {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  padding: 4px 7px;
  font-size: 10px;
  font-weight: 800;
  color: #475569;
  cursor: pointer;
}

.sample-carousel-dot.is-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #ffffff;
}

.bg-image-grid {
  min-height: 0;
}

.bg-result-right {
  display: grid;
  min-height: 0;
  grid-template-rows: 326px minmax(0, 1fr);
  gap: 10px;
}

.bg-image-stack {
  display: grid;
  min-height: 0;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.bg-result-metric-table {
  display: flex;
}

.bg-result-metric-table .data-table {
  height: 100%;
  table-layout: fixed;
  font-size: var(--report-table-font-size);
  line-height: 1.14;
}

.bg-result-metric-table .data-table thead tr {
  height: 28px;
}

.bg-result-metric-table .data-table tbody tr {
  height: 22px;
}

.bg-result-metric-table .data-table th,
.bg-result-metric-table .data-table td {
  padding: 3px 6px;
}

.bg-result-column-panel {
  min-height: 0;
}

.bg-result-column-chart {
  padding: 8px 10px 10px;
}

.bg-result-column-chart .metric-column-grid {
  gap: 7px;
}

.bg-result-column-chart .metric-column-card {
  grid-template-rows: 17px minmax(0, 1fr);
  gap: 4px;
  padding: 6px;
}

.bg-result-column-chart .metric-column-plot {
  grid-template-columns: 31px minmax(0, 1fr);
}

.bg-result-column-chart .metric-y-axis {
  padding-bottom: 16px;
  font-size: 7px;
}

.bg-result-column-chart .metric-bar-grid {
  inset: 6px 7px 0;
  gap: 9px;
}

.bg-result-column-chart .metric-x-axis {
  gap: 9px;
  padding-right: 7px;
  padding-left: 7px;
  font-size: 8px;
}

.mmd-result-layout {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1.03fr) minmax(0, 0.97fr);
  gap: 14px;
}

.mmd-image-column {
  display: grid;
  min-height: 0;
  grid-template-rows: 48px minmax(0, 1fr);
  gap: 10px;
}

.mmd-image-stack {
  display: grid;
  min-height: 0;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.mmd-result-right {
  display: grid;
  min-height: 0;
  grid-template-rows: 366px minmax(0, 1fr);
  gap: 10px;
}

.mmd-metric-table {
  display: flex;
  min-height: 0;
  flex-direction: column;
  background: #ffffff;
}

.mmd-metric-table-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px 10px;
}

.mmd-metric-table .data-table {
  flex: 1;
  table-layout: fixed;
  font-size: var(--report-table-font-size);
  line-height: 1.14;
}

.mmd-metric-table .data-table thead tr {
  height: 28px;
}

.mmd-metric-table .data-table tbody tr {
  height: 22px;
}

.mmd-metric-table .data-table th,
.mmd-metric-table .data-table td {
  padding: 3px 6px;
}

.mmd-summary-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.mmd-summary-grid .stat-tile {
  min-width: 0;
  padding: 13px 11px;
}

.mmd-summary-grid .stat-label,
.mmd-summary-grid .stat-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mmd-summary-grid .stat-value {
  font-size: clamp(19px, 1.6vw, 28px);
}

.mmd-summary-grid .stat-value.small {
  font-size: clamp(15px, 1.1vw, 20px);
}

.mmd-result-column-panel {
  min-height: 0;
}

.mmd-result-column-chart {
  padding: 8px 10px 10px;
}

.mmd-result-column-chart .metric-column-grid {
  gap: 7px;
}

.mmd-result-column-chart .metric-column-card {
  grid-template-rows: 17px minmax(0, 1fr);
  gap: 4px;
  padding: 6px;
}

.mmd-result-column-chart .metric-column-plot {
  grid-template-columns: 31px minmax(0, 1fr);
}

.mmd-result-column-chart .metric-y-axis {
  padding-bottom: 16px;
  font-size: 7px;
}

.mmd-result-column-chart .metric-bar-grid {
  inset: 6px 7px 0;
  gap: 9px;
}

.mmd-result-column-chart .metric-x-axis {
  gap: 9px;
  padding-right: 7px;
  padding-left: 7px;
  font-size: 8px;
}

.blur-result-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: 86px 48px minmax(0, 1fr);
  gap: 12px;
}

.blur-result-images {
  min-height: 0;
}

.noise-slide-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: 48px minmax(0, 1fr);
  gap: 12px;
}

.noise-result-layout {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(350px, 0.34fr);
  gap: 12px;
}

.noise-image-row {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.noise-image-panel .image-label {
  padding: 7px 10px;
  font-size: 11px;
}

.noise-parameter-panel {
  min-height: 0;
}

.noise-reference-row {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 8px 10px;
}

.noise-reference-image {
  display: flex;
  min-width: 0;
  flex: 0 1 calc((100% - 8px) / 2);
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  padding: 0;
  cursor: pointer;
}

.noise-reference-image img {
  display: block;
  width: 100%;
  max-width: 762px;
  height: auto;
}

.noise-result-table {
  display: flex;
  min-height: 0;
  flex-direction: column;
  background: #ffffff;
}

.noise-result-table-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px 10px;
}

.noise-result-table .data-table {
  flex: 1;
  table-layout: fixed;
  font-size: var(--report-table-font-size);
  line-height: 1.14;
}

.noise-result-table .data-table thead tr {
  height: 28px;
}

.noise-result-table .data-table tbody tr {
  height: 24px;
}

.noise-result-table .data-table th,
.noise-result-table .data-table td {
  padding: 3px 6px;
}

.noise-parameter-chart {
  width: 88%;
  align-self: center;
  padding: 8px 10px 10px;
}

.noise-parameter-chart .metric-column-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.noise-parameter-chart .metric-column-card {
  grid-template-rows: 17px minmax(0, 1fr);
  gap: 4px;
  padding: 6px;
}

.noise-parameter-chart .metric-column-plot {
  grid-template-columns: 31px minmax(0, 1fr);
}

.noise-parameter-chart .metric-y-axis {
  padding-bottom: 16px;
  font-size: 7px;
}

.noise-parameter-chart .metric-bar-grid,
.noise-parameter-chart .metric-x-axis {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.noise-parameter-chart .metric-bar-grid {
  inset: 6px 7px 0;
  gap: 7px;
}

.noise-parameter-chart .metric-column-bar {
  width: min(38px, 78%);
}

.noise-parameter-chart .metric-x-axis {
  gap: 7px;
  padding-right: 7px;
  padding-left: 7px;
  font-size: 8px;
}

.metric-selector {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 5px;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 10px;
}

.metric-chip {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  padding: 5px 7px;
  font-size: 10px;
  font-weight: 800;
  color: #475569;
  cursor: pointer;
}

.metric-chip.is-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #ffffff;
}

.sample-bars {
  display: grid;
  min-height: 0;
  gap: 7px;
  overflow: hidden;
  padding: 9px 10px 10px;
}

.dumbbell-chart {
  display: grid;
  min-height: 0;
  grid-template-rows: 22px minmax(0, 1fr);
  gap: 5px;
  overflow: hidden;
  padding: 8px 10px 10px;
}

.dumbbell-axis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cbd5e1;
  padding: 0 104px 4px 76px;
  font-size: 9px;
  font-weight: 800;
  color: #64748b;
}

.sample-dumbbell-list {
  display: grid;
  min-height: 0;
  gap: 6px;
}

.sample-dumbbell-row {
  display: grid;
  min-height: 0;
  grid-template-columns: 72px minmax(0, 1fr) 94px;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #ffffff;
  padding: 6px 8px;
}

.sample-dumbbell-name,
.sample-dumbbell-values {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.sample-dumbbell-name span,
.sample-dumbbell-values span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-dumbbell-name span:first-child {
  font-size: 10px;
  font-weight: 800;
  color: #0f172a;
}

.sample-dumbbell-name span:last-child {
  font-size: 9px;
  font-weight: 700;
  color: #64748b;
}

.sample-dumbbell-values {
  justify-items: end;
  font-size: 10px;
  font-weight: 800;
  color: #334155;
}

.dumbbell-track {
  position: relative;
  height: 20px;
  min-width: 0;
}

.dumbbell-track::before {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  height: 2px;
  transform: translateY(-50%);
  border-radius: 999px;
  background: #e2e8f0;
  content: "";
}

.dumbbell-link {
  position: absolute;
  top: 50%;
  height: 4px;
  transform: translateY(-50%);
  border-radius: 999px;
}

.dumbbell-link.positive {
  background: #ef4444;
}

.dumbbell-link.negative {
  background: #2563eb;
}

.dumbbell-link.neutral {
  background: #94a3b8;
}

.dumbbell-point {
  position: absolute;
  top: 50%;
  width: 12px;
  height: 12px;
  transform: translate(-50%, -50%);
  border-radius: 999px;
  box-shadow: 0 0 0 2px #ffffff;
}

.dumbbell-point.original {
  border: 2px solid #64748b;
  background: #ffffff;
}

.dumbbell-point.target {
  border: 2px solid #0f766e;
  background: #0f766e;
}

.correlation-comparison-layout {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.correlation-panel {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.correlation-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 9px 11px;
}

.correlation-panel-header > div {
  min-width: 0;
}

.correlation-badge {
  flex-shrink: 0;
  border: 1px solid #99f6e4;
  border-radius: 6px;
  background: #f0fdfa;
  padding: 5px 7px;
  color: #0f766e;
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.correlation-chart-box {
  min-height: 0;
  background: #ffffff;
  padding: 8px 10px 2px;
}

.correlation-chart-box .chart-svg {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.correlation-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px;
}

.correlation-summary-item {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #ffffff;
  padding: 8px;
}

.correlation-summary-item.interpretation {
  grid-column: 1/-1;
}

.correlation-summary-item p {
  margin: 0;
}

.correlation-summary-item p:first-child {
  overflow: hidden;
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.correlation-summary-item p:last-child {
  margin-top: 3px;
  color: #0f172a;
  font-size: clamp(12px, 0.8vw, 15px);
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.correlation-summary-item.interpretation p:last-child {
  font-size: clamp(11px, 0.72vw, 13px);
  font-weight: 750;
  line-height: 1.35;
}

.conclusion-slide {
  background: #f8fafc;
}

.conclusion-slide .slide-heading {
  font-size: clamp(28px, 2.35vw, 44px);
}

.conclusion-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: 150px 38px minmax(0, 1fr);
  gap: 12px;
}

.conclusion-card-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.conclusion-summary-card {
  appearance: none;
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto auto minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: default;
}

.conclusion-summary-card.slate {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.conclusion-summary-card.blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.conclusion-summary-card.emerald {
  border-color: #a7f3d0;
  background: #ecfdf5;
}

.conclusion-summary-card.rose {
  border-color: #fecdd3;
  background: #fff1f2;
}

.conclusion-summary-card.is-actionable {
  cursor: pointer;
}

.conclusion-summary-card.is-actionable:hover {
  border-color: #334155;
}

.conclusion-summary-card.is-active {
  border-color: #0f172a;
  box-shadow: inset 0 0 0 2px #0f172a;
}

.conclusion-summary-card:disabled {
  color: inherit;
}

.conclusion-card-label {
  display: none;
  margin: 0;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #64748b;
}

.conclusion-summary-card h3 {
  margin: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: clamp(16px, 1.18vw, 22px);
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conclusion-card-value {
  margin: 8px 0 0;
  color: #0f172a;
  font-size: clamp(20px, 1.55vw, 28px);
  font-weight: 950;
  line-height: 1;
}

.conclusion-card-meta {
  margin: 7px 0 0;
  overflow: hidden;
  color: #475569;
  font-size: clamp(10px, 0.72vw, 12px);
  font-weight: 850;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conclusion-card-description {
  margin: 7px 0 0;
  overflow: hidden;
  color: #475569;
  font-size: clamp(10px, 0.72vw, 12px);
  font-weight: 650;
  line-height: 1.3;
}

.conclusion-detail-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(430px, 0.42fr);
  gap: 14px;
}

.legend-item.comparison-a::before {
  background: #0f766e;
}

.legend-item.comparison-b::before {
  background: #2563eb;
}

.conclusion-column-panel {
  min-width: 0;
}

.conclusion-column-chart {
  padding: 10px;
}

.conclusion-slide .metric-column-card {
  grid-template-rows: 21px minmax(0, 1fr);
  gap: 5px;
  padding: 7px;
}

.conclusion-slide .metric-column-title {
  font-size: 12px;
}

.conclusion-slide .metric-column-delta {
  font-size: 10px;
}

.conclusion-slide .metric-y-axis {
  font-size: 8px;
}

.final-conclusion-slide {
  grid-template-rows: minmax(0, 1fr) 34px;
  background: #f8fafc;
}

.final-conclusion-heading {
  position: absolute;
  z-index: 3;
  top: 30px;
  left: 44px;
}

.final-conclusion-kicker {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  text-transform: uppercase;
}

.final-conclusion-title {
  margin: 0;
  margin-top: 6px;
  color: #0f172a;
  font-size: clamp(36px, 3vw, 56px);
  font-weight: 900;
  line-height: 1.1;
}

.final-conclusion-slide .slide-body {
  display: grid;
  min-height: 0;
  place-items: center;
  padding: 56px 44px 34px;
}

.final-conclusion-layout {
  display: grid;
  width: 100%;
  min-height: 360px;
}

.final-conclusion-layout .preprocess-conclusion-panel {
  min-height: 360px;
  gap: 18px;
  padding: 20px;
}

.final-conclusion-layout .preprocess-conclusion-lead {
  padding: 26px 28px;
}

.final-conclusion-layout .preprocess-conclusion-kicker {
  font-size: 18px;
}

.final-conclusion-layout .preprocess-conclusion-lead h3 {
  margin-top: 12px;
  font-size: 34px;
  line-height: 1.18;
}

.final-conclusion-layout .preprocess-conclusion-lead p:last-child {
  margin-top: 16px;
  font-size: 20px;
  line-height: 1.4;
}

.final-conclusion-layout .preprocess-conclusion-list {
  gap: 14px;
}

.final-conclusion-layout .preprocess-conclusion-list li {
  gap: 14px;
  padding: 16px 18px;
  font-size: 21px;
  line-height: 1.35;
}

.final-conclusion-layout .preprocess-conclusion-list li::before {
  width: 42px;
  height: 42px;
  font-size: 18px;
}

.conclusion-side-grid {
  display: grid;
  min-height: 0;
  grid-template-rows: 272px minmax(0, 1fr);
  gap: 12px;
}

.conclusion-comparison-table {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.conclusion-table-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 9px 10px;
}

.conclusion-comparison-table .data-table {
  flex: 1;
  table-layout: fixed;
  font-size: clamp(10px, 0.68vw, 12px);
}

.conclusion-comparison-table .data-table th,
.conclusion-comparison-table .data-table td {
  padding: 5px 7px;
}

.conclusion-comparison-table .i3-table-row td {
  background: #f8fafc;
  font-weight: 900;
}

.conclusion-note-panel {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  border-radius: 8px;
  background: #0f172a;
  padding: 18px;
  color: #ffffff;
}

.conclusion-note-kicker {
  margin: 0;
  color: #5eead4;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.conclusion-note-list {
  display: grid;
  min-height: 0;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.conclusion-note-item {
  display: grid;
  min-height: 0;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.36);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.64);
  padding: 10px;
}

.conclusion-note-item span {
  display: inline-flex;
  width: 30px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #0f766e;
  color: #ccfbf1;
  font-size: 12px;
  font-weight: 900;
}

.conclusion-note-item p {
  margin: 0;
  overflow: hidden;
  color: #cbd5e1;
  font-size: clamp(11px, 0.78vw, 14px);
  font-weight: 650;
  line-height: 1.42;
}

.chart-card {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 16px;
}

.chart-box {
  min-height: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px;
}

.chart-svg {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 430px;
}

.summary-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-item {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 12px;
}

.summary-item p {
  margin: 0;
}

.summary-item p:first-child {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
}

.summary-item p:last-child {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.text-blue {
  color: #1d4ed8;
}

.text-red {
  color: #dc2626;
}

.text-green {
  color: #047857;
}

.loading-box,
.error-box {
  margin: 0 auto;
  max-width: 520px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 28px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
}

.error-box {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.74);
  padding: 24px;
}

.modal-shade {
  position: absolute;
  inset: 0;
  cursor: default;
}

.image-modal {
  position: relative;
  z-index: 1;
  display: flex;
  width: min(1200px, 100%);
  height: calc(100vh - 48px);
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
}

.image-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 14px;
}

.image-modal-header h2 {
  margin: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-modal-header p {
  margin: 2px 0 0;
  overflow: hidden;
  font-size: 12px;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-modal-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.image-modal-actions a,
.image-modal-actions button {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  padding: 7px 10px;
  font-size: 12px;
  font-weight: 800;
  color: #334155;
}

.image-modal-actions a.primary {
  border-color: #0f172a;
  background: #0f172a;
  color: #ffffff;
}

.native-note {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.modal-image-box {
  display: flex;
  min-height: 0;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: #020617;
  padding: 12px;
}

.modal-image-box img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.presentation-root.is-integrated-report {
  grid-template-rows: auto minmax(0, 1fr);
  align-content: stretch;
  justify-items: stretch;
  height: 100vh;
  overflow: hidden;
  background: #020617;
}

.integrated-report-toolbar {
  justify-self: center;
}

.integrated-toolbar-badge {
  display: inline-flex;
  height: 32px;
  align-items: center;
  border: 1px solid rgba(94, 234, 212, 0.32);
  border-radius: 7px;
  background: rgba(15, 118, 110, 0.18);
  padding: 0 10px;
  color: #ccfbf1;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.integrated-report-stage {
  width: min(100%, (100vh - 96px) * 1.7778, 1920px);
  max-height: calc(100vh - 96px);
  aspect-ratio: 16/9;
  justify-self: center;
  padding-bottom: 0;
}

.integrated-report-sheet {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.integrated-cover {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.42fr);
  gap: 22px;
  align-items: end;
  background: #ffffff;
  padding: 64px 64px 42px;
}

.integrated-cover-slide {
  grid-template-rows: minmax(0, 1fr);
  min-height: 0;
}

.integrated-cover-copy {
  display: grid;
  gap: 12px;
}

.integrated-cover-title {
  margin: 0;
  max-width: 980px;
  color: #0f172a;
  font-size: clamp(42px, 4vw, 76px);
  font-weight: 950;
  line-height: 1.05;
}

.integrated-cover-note {
  max-width: 900px;
  margin: 0;
  color: #334155;
  font-size: clamp(15px, 1.1vw, 20px);
  font-weight: 700;
  line-height: 1.55;
}

.integrated-cover-meta {
  display: grid;
  gap: 12px;
}

.integrated-dataset-card,
.integrated-panel,
.integrated-comparison-card,
.integrated-image-card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.integrated-dataset-card {
  display: grid;
  gap: 6px;
  padding: 18px;
}

.integrated-dataset-card p,
.integrated-dataset-card h2,
.integrated-dataset-card span {
  margin: 0;
}

.integrated-dataset-card p {
  color: #0f766e;
  font-size: 12px;
  font-weight: 950;
}

.integrated-dataset-card h2 {
  color: #0f172a;
  font-size: 30px;
  font-weight: 950;
  line-height: 1;
}

.integrated-dataset-card span {
  color: #475569;
  font-size: 12px;
  font-weight: 750;
}

.integrated-dataset-card .integrated-warning {
  width: fit-content;
  border-radius: 6px;
  background: #fff7ed;
  padding: 4px 7px;
  color: #c2410c;
  font-weight: 900;
}

.integrated-section {
  display: grid;
  gap: 12px;
  padding: 0 42px;
}

.integrated-section.presentation-slide {
  grid-template-rows: auto minmax(0, 1fr);
  align-content: stretch;
  gap: 16px;
  padding: 38px 42px 30px;
}

.integrated-section:last-child {
  padding-bottom: 30px;
}

.integrated-section-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
}

.integrated-section-title {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: clamp(24px, 2vw, 38px);
  font-weight: 900;
  line-height: 1.12;
}

.integrated-section-note {
  max-width: 560px;
  margin: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.5;
  text-align: right;
}

.integrated-case-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 8px;
}

.integrated-case-button {
  display: grid;
  min-height: 66px;
  align-content: center;
  gap: 4px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.integrated-case-button:hover,
.integrated-case-button.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.integrated-case-button span {
  overflow: hidden;
  font-size: 13px;
  font-weight: 950;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-case-button small {
  overflow: hidden;
  color: inherit;
  font-size: 10px;
  font-weight: 750;
  opacity: 0.72;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-two-column,
.integrated-line-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.integrated-section.integrated-boxplot-slide {
  grid-template-rows: minmax(0, 1fr);
  align-items: stretch;
}

.integrated-line-grid {
  display: grid;
  min-height: 0;
  gap: 12px;
}

.integrated-line-grid .integrated-panel:first-child {
  grid-column: 1/-1;
}

.integrated-line-slide .integrated-line-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.integrated-line-slide .integrated-line-grid .integrated-panel:first-child {
  grid-column: auto;
}

.integrated-panel {
  display: grid;
  min-width: 0;
  min-height: 0;
}

.integrated-panel-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 12px 14px;
}

.integrated-panel-header.compact {
  padding: 10px 12px;
}

.integrated-chart-svg {
  display: block;
  width: 100%;
  height: auto;
  background: #ffffff;
}

.integrated-boxplot-slide .integrated-chart-svg {
  align-self: center;
}

.integrated-chart-svg.line {
  min-height: 260px;
}

.integrated-line-slide .integrated-chart-svg.line {
  min-height: 0;
}

.integrated-mini-legend,
.integrated-chart-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  color: #64748b;
  font-size: 10px;
  font-weight: 850;
}

.integrated-mini-legend span,
.integrated-chart-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.integrated-mini-legend span::before,
.integrated-chart-legend i {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  content: "";
}

.integrated-mini-legend .normal::before {
  background: #047857;
}

.integrated-mini-legend .patient::before {
  background: #e11d48;
}

.integrated-chart-legend {
  border-top: 1px solid #e2e8f0;
  padding: 9px 12px;
}

.integrated-image-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  min-height: 0;
  gap: 12px;
}

.integrated-image-card-header {
  display: grid;
  gap: 3px;
  border-bottom: 1px solid #e2e8f0;
  padding: 9px 10px;
}

.integrated-image-card-header strong,
.integrated-image-card-header span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-image-card-header strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 950;
}

.integrated-image-card-header span {
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
}

.integrated-image-pair {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
}

.integrated-image-pair button {
  position: relative;
  min-width: 0;
  aspect-ratio: 4/3;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #f8fafc;
  padding: 0;
  cursor: pointer;
}

.integrated-image-pair img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.integrated-image-pair span {
  position: absolute;
  right: 6px;
  bottom: 6px;
  left: 6px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.92);
  padding: 5px 6px;
  color: #0f172a;
  font-size: 10px;
  font-weight: 900;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-comparison-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  min-height: 0;
  gap: 9px;
}

.integrated-comparison-card {
  display: grid;
  align-content: start;
  gap: 8px;
  min-height: 156px;
  padding: 12px;
}

.integrated-comparison-card h3,
.integrated-comparison-card p {
  margin: 0;
}

.integrated-comparison-card h3 {
  color: #0f172a;
  font-size: 13px;
  font-weight: 950;
  line-height: 1.2;
}

.integrated-comparison-card p {
  overflow: hidden;
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-card-metrics {
  display: grid;
  gap: 6px;
}

.integrated-card-metrics div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 6px;
  background: #f8fafc;
  padding: 7px 8px;
}

.integrated-card-metrics span {
  color: #64748b;
  font-size: 10px;
  font-weight: 900;
}

.integrated-card-metrics strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 950;
}

.integrated-table-wrap {
  min-height: 0;
  max-height: none;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.integrated-data-table {
  width: 100%;
  min-width: 1120px;
  border-collapse: collapse;
  font-size: 12px;
}

.integrated-data-table thead {
  position: sticky;
  z-index: 1;
  top: 0;
  background: #f8fafc;
  color: #64748b;
}

.integrated-data-table th,
.integrated-data-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
}

.integrated-data-table th {
  font-weight: 900;
}

.integrated-data-table td {
  color: #334155;
  font-weight: 700;
}

.integrated-data-table td:nth-child(n+7),
.integrated-data-table th:nth-child(n+7) {
  text-align: right;
}

@media (max-width: 1320px) {
  .integrated-cover,
  .integrated-two-column,
  .integrated-line-grid {
    grid-template-columns: 1fr;
  }
  .integrated-cover {
    min-height: auto;
    padding: 42px 32px 32px;
  }
  .integrated-section {
    padding-right: 24px;
    padding-left: 24px;
  }
  .integrated-case-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .integrated-image-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .integrated-comparison-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .integrated-section-header {
    align-items: start;
    flex-direction: column;
  }
  .integrated-section-note {
    text-align: left;
  }
  .integrated-case-grid,
  .integrated-image-grid,
  .integrated-comparison-grid {
    grid-template-columns: 1fr;
  }
}
.presentation-root.is-integrated-report .integrated-cover {
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) auto;
  align-items: stretch;
  gap: 24px;
  background: #f8fafc;
  padding: 56px 64px 42px;
}

.integrated-cover-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(340px, 0.36fr);
  align-items: end;
  gap: 26px;
}

.integrated-cover-strip,
.integrated-overview-stat-grid,
.integrated-metric-definition-grid,
.integrated-final-card-grid {
  display: grid;
  min-height: 0;
  gap: 12px;
}

.integrated-cover-strip {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.integrated-cover-stat,
.integrated-overview-stat,
.integrated-metric-definition-card,
.integrated-topic-stat,
.integrated-topic-metric,
.integrated-summary-metric,
.integrated-final-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.integrated-cover-stat {
  display: grid;
  gap: 5px;
  padding: 13px 14px;
}

.integrated-cover-stat span,
.integrated-overview-stat p,
.integrated-metric-definition-card p,
.integrated-topic-stat span,
.integrated-topic-metric span,
.integrated-summary-metric span,
.integrated-final-card p {
  margin: 0;
  color: #0f766e;
  font-size: 11px;
  font-weight: 950;
  line-height: 1.1;
}

.integrated-cover-stat strong,
.integrated-overview-stat h3,
.integrated-topic-stat strong,
.integrated-topic-metric strong,
.integrated-summary-metric strong,
.integrated-final-card h3 {
  margin: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: clamp(18px, 1.4vw, 26px);
  font-weight: 950;
  line-height: 1.05;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-cover-stat small,
.integrated-overview-stat span,
.integrated-metric-definition-card span,
.integrated-topic-metric small,
.integrated-summary-metric small,
.integrated-final-card span {
  overflow: hidden;
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-overview-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto minmax(0, 1fr);
  gap: 14px;
}

.integrated-overview-stat-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.integrated-overview-stat {
  display: grid;
  gap: 6px;
  padding: 13px;
}

.integrated-overview-flow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.integrated-flow-step {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border: 1px solid #ccfbf1;
  border-radius: 8px;
  background: #f0fdfa;
  padding: 12px;
}

.integrated-flow-step strong {
  display: inline-flex;
  width: 32px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #0f766e;
  color: #ffffff;
  font-size: 11px;
  font-weight: 950;
}

.integrated-flow-step span {
  overflow: hidden;
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-flow-arrow {
  color: #94a3b8;
  font-size: 20px;
  font-weight: 900;
}

.integrated-metric-definition-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.integrated-metric-definition-card {
  display: grid;
  align-content: start;
  gap: 7px;
  padding: 15px;
}

.integrated-metric-definition-card strong {
  color: #0f172a;
  font-size: 17px;
  font-weight: 950;
  line-height: 1.18;
}

.integrated-metric-definition-card span {
  white-space: normal;
  font-size: 12px;
  line-height: 1.4;
}

.integrated-metric-definition-card.highlight {
  border-color: #fecdd3;
  background: #fff1f2;
}

.integrated-pipeline-overview-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: 154px 54px minmax(0, 1fr);
  gap: 12px;
}

.integrated-pipeline-overview-layout.separated {
  grid-template-rows: 62px 56px minmax(0, 1fr);
}

.integrated-dataset-tabs,
.integrated-comparison-button-grid {
  display: grid;
  min-height: 0;
  gap: 8px;
}

.integrated-dataset-tabs {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.integrated-dataset-tabs.compact {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.integrated-dataset-tab,
.integrated-comparison-option {
  display: grid;
  min-width: 0;
  align-content: center;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.integrated-dataset-tab {
  grid-template-columns: auto auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  padding: 9px 12px;
}

.integrated-dataset-tab:hover,
.integrated-dataset-tab.is-active,
.integrated-comparison-option:hover,
.integrated-comparison-option.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.integrated-dataset-tab strong,
.integrated-dataset-tab span,
.integrated-dataset-tab small,
.integrated-comparison-option span,
.integrated-comparison-option small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-dataset-tab strong {
  color: inherit;
  font-size: 18px;
  font-weight: 950;
  line-height: 1;
}

.integrated-dataset-tab span {
  border-radius: 6px;
  background: rgba(15, 118, 110, 0.1);
  padding: 5px 7px;
  color: inherit;
  font-size: 11px;
  font-weight: 950;
}

.integrated-dataset-tab small {
  justify-self: end;
  color: #64748b;
  font-size: 11px;
  font-weight: 850;
}

.integrated-dataset-tab.is-active small {
  color: #0f766e;
}

.integrated-comparison-button-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.integrated-comparison-button-grid.stacked {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
}

.integrated-comparison-option {
  min-height: 50px;
  gap: 3px;
  padding: 8px 10px;
}

.integrated-comparison-button-grid.stacked .integrated-comparison-option {
  min-height: 38px;
  padding: 6px 8px;
}

.integrated-comparison-option span {
  font-size: 11px;
  font-weight: 950;
  line-height: 1.1;
}

.integrated-comparison-option small {
  color: inherit;
  font-size: 9px;
  font-weight: 750;
  opacity: 0.72;
}

.integrated-pipeline-card-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.integrated-pipeline-card {
  padding: 13px 14px;
}

.integrated-pipeline-card .step-title {
  font-size: 18px;
}

.integrated-pipeline-card .step-label {
  font-size: 12px;
}

.integrated-pipeline-card .step-description {
  font-size: 12px;
  line-height: 1.35;
}

.integrated-condition-strip {
  align-items: stretch;
}

.integrated-main-compare-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(380px, 0.34fr);
  gap: 12px;
}

.integrated-main-compare-grid.with-image {
  grid-template-columns: minmax(300px, 0.28fr) minmax(0, 1fr) minmax(380px, 0.32fr);
}

.integrated-comparison-visual-panel {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(126px, 0.58fr) auto;
  gap: 9px;
  overflow: hidden;
}

.integrated-comparison-image-pair {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.integrated-comparison-image-card {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 0;
  cursor: pointer;
}

.integrated-comparison-image-card img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  object-fit: contain;
}

.integrated-comparison-image-card span,
.integrated-comparison-image-card small {
  position: absolute;
  right: 6px;
  left: 6px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.92);
  color: #0f172a;
  font-weight: 950;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-comparison-image-card span {
  bottom: 6px;
  padding: 5px 6px;
  font-size: 10px;
  line-height: 1;
}

.integrated-comparison-image-card small {
  top: 6px;
  padding: 4px 5px;
  color: #b45309;
  font-size: 8px;
  line-height: 1.15;
}

.integrated-primary-chart-panel {
  min-width: 0;
}

.integrated-primary-chart {
  padding: 12px;
}

.integrated-primary-metric-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: minmax(0, 1fr);
  gap: 10px;
}

.integrated-primary-metric-grid .metric-column-card {
  grid-template-rows: 24px minmax(0, 1fr);
  padding: 9px;
}

.integrated-primary-metric-grid .metric-column-title {
  font-size: 14px;
}

.integrated-primary-metric-grid .metric-column-delta {
  font-size: 12px;
}

.integrated-primary-metric-grid .metric-y-axis {
  width: 42px;
  font-size: 9px;
}

.integrated-primary-metric-grid .metric-x-axis {
  font-size: 11px;
}

.integrated-primary-metric-grid .i3-metric-card {
  border-color: #fecdd3;
  background: #fff7f7;
}

.integrated-primary-metric-grid .i3-metric-card .metric-column-title {
  color: #be123c;
}

.integrated-comparison-table {
  display: flex;
  min-height: 0;
  flex-direction: column;
}

.integrated-comparison-table .data-table {
  flex: 1;
  table-layout: fixed;
  font-size: clamp(10px, 0.72vw, 13px);
}

.integrated-comparison-table .data-table th,
.integrated-comparison-table .data-table td {
  padding: 8px 9px;
}

.integrated-comparison-table .i3-table-row td {
  border-top: 2px solid #fecdd3;
  background: #fff1f2;
  color: #0f172a;
  font-weight: 950;
}

.integrated-topic-layout,
.integrated-threshold-layout,
.integrated-combination-layout,
.integrated-i3-layout,
.integrated-final-layout {
  display: grid;
  min-height: 0;
  gap: 12px;
}

.integrated-topic-layout {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-topic-report-layout {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(310px, 0.3fr) minmax(0, 1fr) minmax(380px, 0.32fr);
  gap: 12px;
}

.integrated-topic-explainer {
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto minmax(114px, 0.52fr) minmax(0, 0.48fr) auto;
  gap: 10px;
}

.integrated-topic-title.compact {
  padding: 14px;
}

.integrated-topic-title.compact h3 {
  font-size: 17px;
}

.integrated-topic-title.compact span {
  display: block;
  overflow: hidden;
  margin-top: 7px;
  color: #cbd5e1;
  font-size: 10px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-process-list {
  display: grid;
  align-content: start;
  gap: 8px;
  min-height: 0;
  margin: 0;
  overflow: hidden;
  padding: 0;
  list-style: none;
  counter-reset: process-list;
}

.integrated-process-list li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 9px;
  color: #334155;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.35;
}

.integrated-process-list li::before {
  counter-increment: process-list;
  content: counter(process-list);
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #0f766e;
  color: #ffffff;
  font-size: 11px;
  font-weight: 950;
}

.integrated-process-list.compact {
  gap: 6px;
}

.integrated-process-list.compact li {
  grid-template-columns: 24px minmax(0, 1fr);
  padding: 7px;
  font-size: 10px;
  line-height: 1.25;
}

.integrated-process-list.compact li::before {
  width: 22px;
  height: 22px;
  font-size: 10px;
}

.integrated-topic-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.integrated-topic-summary-card {
  display: grid;
  min-width: 0;
  gap: 4px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 9px;
}

.integrated-topic-summary-card span,
.integrated-topic-summary-card strong,
.integrated-topic-summary-card small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-topic-summary-card span {
  color: #0f766e;
  font-size: 10px;
  font-weight: 950;
}

.integrated-topic-summary-card strong {
  color: #0f172a;
  font-size: 15px;
  font-weight: 950;
}

.integrated-topic-summary-card small {
  color: #64748b;
  font-size: 9px;
  font-weight: 750;
}

.integrated-topic-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.integrated-topic-tab {
  display: grid;
  min-height: 54px;
  align-content: center;
  gap: 3px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 9px 10px;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.integrated-topic-tab:hover,
.integrated-topic-tab.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.integrated-topic-tab strong,
.integrated-topic-tab span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-topic-tab strong {
  font-size: 12px;
  font-weight: 950;
}

.integrated-topic-tab span {
  font-size: 10px;
  font-weight: 750;
}

.integrated-topic-main {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.34fr);
  gap: 14px;
}

.integrated-topic-image-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.integrated-topic-image-card {
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 0;
  cursor: pointer;
}

.integrated-topic-image-card img,
.integrated-blend-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.integrated-topic-image-card > img {
  position: absolute;
  inset: 0;
}

.integrated-topic-image-card > span {
  position: absolute;
  right: 8px;
  bottom: 8px;
  left: 8px;
  overflow: hidden;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.92);
  padding: 7px 8px;
  color: #0f172a;
  font-size: 11px;
  font-weight: 950;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-blend-image {
  position: absolute;
  inset: 0;
  background: #ffffff;
}

.integrated-blend-image img {
  position: absolute;
  inset: 0;
}

.integrated-blend-image img:first-child {
  opacity: 0.62;
}

.integrated-blend-image img:last-child {
  opacity: 0.54;
  mix-blend-mode: multiply;
}

.integrated-topic-side {
  display: grid;
  min-height: 0;
  grid-template-rows: auto auto minmax(0, 1fr);
  gap: 10px;
}

.integrated-topic-title {
  overflow: hidden;
  border-radius: 8px;
  background: #0f172a;
  padding: 16px;
}

.integrated-topic-title p,
.integrated-topic-title h3 {
  margin: 0;
}

.integrated-topic-title p {
  color: #5eead4;
  font-size: 11px;
  font-weight: 950;
  text-transform: uppercase;
}

.integrated-topic-title h3 {
  margin-top: 8px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.25;
}

.integrated-topic-stat-grid,
.integrated-topic-metric-grid {
  display: grid;
  min-height: 0;
  gap: 8px;
}

.integrated-topic-stat-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.integrated-topic-stat,
.integrated-topic-metric {
  display: grid;
  gap: 5px;
  padding: 11px;
}

.integrated-topic-metric-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.integrated-topic-metric strong {
  font-size: 21px;
}

.integrated-threshold-layout {
  grid-template-columns: minmax(0, 1fr) minmax(230px, 0.22fr);
}

.integrated-threshold-chart-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.integrated-threshold-panel {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-threshold-summary {
  display: grid;
  min-height: 0;
  align-content: start;
  gap: 10px;
}

.integrated-summary-metric {
  display: grid;
  gap: 6px;
  padding: 14px;
}

.integrated-combination-layout {
  grid-template-rows: minmax(0, 1fr) 178px;
}

.integrated-combination-slide .integrated-line-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.integrated-comparison-grid.compact {
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.integrated-comparison-grid.compact .integrated-comparison-card {
  min-height: 0;
  padding: 10px;
}

.integrated-comparison-grid.compact .integrated-comparison-card h3 {
  font-size: 11px;
}

.integrated-comparison-grid.compact .integrated-card-metrics {
  gap: 4px;
}

.integrated-comparison-grid.compact .integrated-card-metrics div {
  padding: 5px 6px;
}

.integrated-i3-layout {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-i3-layout.single {
  grid-template-rows: auto auto minmax(0, 1fr);
}

.integrated-case-grid.compact {
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 7px;
}

.integrated-case-grid.compact .integrated-case-button {
  min-height: 50px;
  padding: 7px 8px;
}

.integrated-boxplot-grid {
  display: grid;
  min-height: 0;
  gap: 12px;
}

.integrated-single-boxplot-panel {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-single-boxplot-panel .integrated-chart-svg {
  align-self: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.integrated-final-layout {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-final-card-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.integrated-final-card {
  display: grid;
  gap: 7px;
  padding: 15px;
}

.integrated-final-card h3 {
  white-space: normal;
  font-size: 18px;
  line-height: 1.2;
}

.integrated-final-card span {
  white-space: normal;
  font-size: 11px;
  line-height: 1.35;
}

.integrated-final-message {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(280px, 0.38fr) minmax(0, 1fr);
  gap: 18px;
  overflow: hidden;
  border-radius: 8px;
  background: #0f172a;
  padding: 22px;
  color: #ffffff;
}

.integrated-final-message h3 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(24px, 2.1vw, 38px);
  font-weight: 950;
  line-height: 1.18;
}

.integrated-final-message ol {
  display: grid;
  align-content: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: final-list;
}

.integrated-final-message li {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  color: #dbeafe;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.35;
}

.integrated-final-message li::before {
  counter-increment: final-list;
  content: counter(final-list);
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #14b8a6;
  color: #ffffff;
  font-size: 12px;
  font-weight: 950;
}

.integrated-preprocess-sample-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: minmax(0, 58%) minmax(0, 42%);
  gap: 10px;
}

.integrated-preprocess-method-grid {
  align-items: stretch;
  padding-top: 0;
}

.integrated-overview-sample-slide .preprocess-method-card {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 5px;
}

.integrated-overview-sample-slide .preprocess-method-card h3 {
  margin-top: 3px;
  font-size: 18px;
}

.integrated-overview-sample-slide .preprocess-method-copy {
  font-size: 10.5px;
  line-height: 1.26;
}

.integrated-overview-sample-slide .preprocess-evidence-row {
  flex: 1 1 auto;
  align-content: center;
  align-items: center;
  justify-items: center;
  min-height: 0;
}

.integrated-overview-sample-slide .preprocess-evidence-image {
  align-self: center;
  aspect-ratio: 4/3;
  width: 100%;
  max-height: 100%;
}

.integrated-overview-sample-slide .mmd-threshold-callout {
  flex: 0 0 auto;
  min-height: 31px;
  padding: 5px 8px;
  font-size: 20px;
}

.integrated-overview-sample-slide .preprocess-method-card.blue .preprocess-evidence-image {
  aspect-ratio: 2.05/1;
}

.integrated-overview-sample-slide .preprocess-flow {
  flex: 0 0 auto;
  width: 100%;
  padding: 4px;
}

.integrated-overview-sample-slide .preprocess-flow span {
  font-size: 10px;
  min-height: 24px;
  padding: 4px;
}

.integrated-sample-info-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.integrated-sample-info-card {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.integrated-sample-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 9px 12px;
}

.integrated-sample-info-header p,
.integrated-sample-info-header h3 {
  margin: 0;
}

.integrated-sample-info-header p {
  color: #0f766e;
  font-size: 11px;
  font-weight: 950;
  line-height: 1;
}

.integrated-sample-info-header h3 {
  margin-top: 4px;
  color: #0f172a;
  font-size: 15px;
  font-weight: 950;
  line-height: 1.15;
}

.integrated-sample-info-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
  max-width: 58%;
}

.sample-info-badge,
.sample-bg-badge {
  flex-shrink: 0;
  border-radius: 6px;
  padding: 5px 7px;
  font-size: 10px;
  font-weight: 950;
  line-height: 1;
  white-space: nowrap;
}

.sample-info-badge {
  background: #eef2ff;
  color: #334155;
}

.sample-bg-badge.has-bg {
  background: #ecfdf5;
  color: #047857;
}

.sample-bg-badge.no-bg {
  background: #fff7ed;
  color: #c2410c;
}

.integrated-sample-info-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  padding: 8px 10px;
}

.integrated-sample-info-stats span {
  overflow: hidden;
  border-radius: 6px;
  background: #f8fafc;
  padding: 7px 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 900;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-sample-info-table {
  display: grid;
  height: 100%;
  min-height: 0;
  align-content: stretch;
  overflow: hidden;
  padding: 0 10px 10px;
}

.sample-info-row {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) 0.62fr 0.9fr 0.72fr;
  border-bottom: 1px solid #e2e8f0;
}

.sample-info-row:last-child {
  border-bottom: 0;
}

.sample-info-row span {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sample-info-row.header span {
  color: #64748b;
  font-size: 12px;
  font-weight: 950;
}

.integrated-result-workspace {
  display: grid;
  min-height: 0;
  grid-template-rows: 126px minmax(0, 1fr);
  gap: 12px;
}

.integrated-result-condition-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.integrated-result-condition-grid.three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.integrated-result-condition-grid.five {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.integrated-result-selector-row {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  gap: 10px;
}

.integrated-result-condition-buttons {
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.integrated-result-condition-buttons.three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.integrated-result-condition-buttons.five {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.pipeline-card.slate,
.integrated-result-condition-card.slate {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.integrated-result-condition-button {
  width: 100%;
  color: #0f172a;
  font: inherit;
  cursor: pointer;
}

.integrated-result-condition-button:hover,
.integrated-result-condition-button.is-active {
  border-color: #0f172a;
  box-shadow: inset 0 0 0 2px #0f172a;
}

.integrated-result-condition-button:focus-visible,
.integrated-result-all-button:focus-visible {
  outline: 3px solid rgba(15, 23, 42, 0.24);
  outline-offset: 2px;
}

.integrated-result-all-button {
  display: inline-flex;
  min-width: 104px;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid #0f766e;
  border-radius: 8px;
  background: #ffffff;
  color: #0f766e;
  font: inherit;
  font-size: 13px;
  font-weight: 950;
  cursor: pointer;
}

.integrated-result-all-button:hover,
.integrated-result-all-button.is-active {
  background: #0f766e;
  color: #ffffff;
}

.integrated-result-condition-card .step-title {
  margin-top: 8px;
  font-size: 18px;
  line-height: 1.08;
}

.integrated-result-condition-card .step-label {
  font-size: 11px;
}

.integrated-result-condition-card .step-description {
  font-size: 11px;
  line-height: 1.32;
}

.integrated-result-detail-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 0.76fr) minmax(450px, 0.68fr);
  gap: 12px;
}

.integrated-sample-csp-slide .slide-heading {
  font-size: clamp(30px, 2.35vw, 44px);
}

.integrated-sample-csp-workspace {
  display: grid;
  min-height: 0;
  grid-template-rows: 116px minmax(0, 1fr);
  gap: 12px;
}

.integrated-sample-control-row {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 0.45fr) minmax(0, 0.55fr);
  gap: 12px;
}

.integrated-sample-control-panel {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
}

.integrated-sample-control-header {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.integrated-sample-control-header .panel-title,
.integrated-sample-control-header .panel-note {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-sample-group-buttons,
.integrated-sample-condition-buttons {
  display: grid;
  min-height: 0;
  gap: 6px;
  overflow: auto;
  padding-right: 2px;
}

.integrated-sample-group-buttons {
  grid-template-columns: repeat(auto-fill, minmax(86px, 1fr));
}

.integrated-sample-condition-buttons {
  grid-template-columns: repeat(auto-fill, minmax(106px, 1fr));
}

.integrated-sample-group-button,
.integrated-sample-condition-button {
  min-width: 0;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #f8fafc;
  color: #334155;
  font: inherit;
  cursor: pointer;
}

.integrated-sample-group-button {
  display: grid;
  min-height: 34px;
  align-content: center;
  gap: 2px;
  padding: 5px 7px;
  text-align: left;
}

.integrated-sample-group-button span,
.integrated-sample-group-button small,
.integrated-sample-condition-button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-sample-group-button span {
  color: inherit;
  font-size: 11px;
  font-weight: 950;
}

.integrated-sample-group-button small {
  color: #64748b;
  font-size: 9px;
  font-weight: 750;
}

.integrated-sample-condition-button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
}

.integrated-sample-condition-button span {
  font-size: 11px;
  font-weight: 950;
}

.integrated-sample-group-button:hover,
.integrated-sample-group-button.is-active,
.integrated-sample-condition-button:hover,
.integrated-sample-condition-button.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.integrated-sample-group-button:focus-visible,
.integrated-sample-condition-button:focus-visible {
  outline: 3px solid rgba(15, 118, 110, 0.22);
  outline-offset: 2px;
}

.integrated-sample-main-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 0.43fr) minmax(0, 0.57fr);
  gap: 12px;
}

.integrated-sample-image-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.integrated-sample-image-card {
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-rows: minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.integrated-sample-image-card:hover {
  border-color: #0f766e;
}

.integrated-sample-image-frame {
  min-height: 0;
  background: #f8fafc;
}

.integrated-sample-image-frame img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.integrated-sample-image-meta {
  display: grid;
  gap: 3px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 7px 8px;
}

.integrated-sample-image-meta strong,
.integrated-sample-image-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-sample-image-meta strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 950;
}

.integrated-sample-image-meta span {
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.integrated-sample-analysis-grid {
  display: grid;
  min-height: 0;
  grid-template-rows: 68px minmax(0, 1fr) max-content;
  gap: 10px;
}

.integrated-sample-summary-row {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.integrated-sample-summary-card {
  display: grid;
  min-width: 0;
  align-content: center;
  gap: 3px;
  overflow: hidden;
  border: 1px solid #ccfbf1;
  border-radius: 8px;
  background: #f0fdfa;
  padding: 10px 12px;
}

.integrated-sample-summary-card span,
.integrated-sample-summary-card strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-sample-summary-card span {
  color: #0f766e;
  font-size: 10px;
  font-weight: 950;
}

.integrated-sample-summary-card strong {
  color: #0f172a;
  font-size: 20px;
  font-weight: 950;
  line-height: 1;
}

.integrated-sample-boxplot-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.integrated-sample-boxplot-panel .chart-panel-header {
  padding: 7px 9px;
}

.integrated-sample-boxplot-panel .panel-title {
  font-size: 12px;
}

.integrated-sample-boxplot-panel .panel-note {
  font-size: 9px;
}

.compact-sample-boxplot {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.integrated-sample-parameter-table-wrap {
  display: flex;
  min-height: 0;
  flex-direction: column;
  --report-table-font-size: 11px;
}

.integrated-sample-parameter-table-wrap .selected-pipeline-header {
  padding: 7px 9px;
}

.integrated-sample-parameter-table {
  table-layout: fixed;
}

.integrated-sample-parameter-table th,
.integrated-sample-parameter-table td {
  padding: 5px 6px !important;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
}

.integrated-sample-parameter-table th:first-child,
.integrated-sample-parameter-table td:first-child {
  width: 74px;
  text-align: left;
}

.integrated-sample-parameter-table .i3-table-row td {
  border-top: 2px solid #cbd5e1;
  background: #f8fafc;
  font-weight: 950;
}

.integrated-boxplot-chart-panel .chart-panel-header,
.integrated-parameter-table-wrap .selected-pipeline-header {
  padding: 8px 10px;
}

.integrated-boxplot-chart-panel .panel-title,
.integrated-parameter-table-wrap .panel-title {
  font-size: 13px;
}

.integrated-boxplot-chart-panel .panel-note,
.integrated-parameter-table-wrap .panel-note {
  font-size: 10px;
}

.integrated-boxplot-chart-panel .integrated-chart-svg {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.integrated-chart-svg.dense-labels {
  padding-bottom: 2px;
}

.integrated-parameter-table-wrap {
  --report-table-font-size: 13px;
}

.integrated-parameter-table {
  table-layout: fixed;
}

.integrated-parameter-table th,
.integrated-parameter-table td {
  padding: 7px 8px !important;
  overflow: visible;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: keep-all;
  vertical-align: middle;
}

.integrated-parameter-table th:first-child,
.integrated-parameter-table td:first-child {
  width: 76px;
  text-align: left;
  white-space: nowrap;
}

.integrated-parameter-table-wrap.is-all-view {
  --report-table-font-size: 12px;
}

.integrated-parameter-table-wrap.is-all-view .integrated-parameter-table th,
.integrated-parameter-table-wrap.is-all-view .integrated-parameter-table td {
  padding: 6px 5px !important;
  overflow: visible;
  line-height: 1.18;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: keep-all;
  font-variant-numeric: tabular-nums;
}

.integrated-parameter-table-wrap.is-all-view .integrated-parameter-table th:first-child,
.integrated-parameter-table-wrap.is-all-view .integrated-parameter-table td:first-child {
  width: 82px;
  overflow-wrap: normal;
  white-space: nowrap;
}

.integrated-parameter-table-wrap.is-all-view .integrated-parameter-table th:not(:first-child) {
  font-size: 11px;
}

.integrated-grouped-boxplot-layout {
  display: grid;
  min-height: 0;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 12px;
}

.integrated-boxplot-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 12px;
}

.integrated-boxplot-toggle-row .panel-title,
.integrated-boxplot-toggle-row .panel-note {
  margin: 0;
}

.integrated-boxplot-toggle-row .panel-title {
  color: #0f172a;
  font-size: 13px;
  font-weight: 950;
}

.integrated-boxplot-toggle-row .panel-note {
  margin-top: 3px;
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
}

.integrated-boxplot-toggle-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.integrated-boxplot-toggle-button {
  display: grid;
  min-width: 168px;
  gap: 3px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #ffffff;
  padding: 8px 10px;
  color: #334155;
  text-align: left;
  cursor: pointer;
}

.integrated-boxplot-toggle-button:hover,
.integrated-boxplot-toggle-button.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.integrated-boxplot-toggle-button span,
.integrated-boxplot-toggle-button small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrated-boxplot-toggle-button span {
  font-size: 12px;
  font-weight: 950;
}

.integrated-boxplot-toggle-button small {
  font-size: 10px;
  font-weight: 750;
  opacity: 0.75;
}

.integrated-grouped-boxplot-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.34fr);
  gap: 12px;
}

.integrated-grouped-boxplot-grid.is-transposed-table {
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) auto;
}

.integrated-grouped-boxplot-panel {
  grid-template-rows: auto minmax(0, 1fr);
}

.integrated-grouped-boxplot-panel .integrated-chart-svg {
  align-self: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.integrated-grouped-boxplot-table {
  --report-table-font-size: 10px;
  min-height: 0;
  max-height: none;
  overflow: auto;
}

.integrated-grouped-boxplot-table .selected-pipeline-header {
  padding: 9px 10px;
}

.integrated-grouped-boxplot-table .data-table {
  table-layout: fixed;
}

.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table {
  --report-table-font-size: clamp(12px, 0.86vw, 15px);
  overflow: hidden;
}

.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table .selected-pipeline-header {
  padding: 8px 12px;
}

.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table .data-table th,
.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table .data-table td {
  padding: 8px 10px !important;
  text-align: center;
}

.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table .data-table th:first-child,
.integrated-grouped-boxplot-grid.is-transposed-table .integrated-grouped-boxplot-table .data-table td:first-child {
  width: 92px;
  text-align: left;
}

.integrated-grouped-boxplot-table th,
.integrated-grouped-boxplot-table td {
  padding: 6px 6px !important;
}

.integrated-boxplot-column-label {
  display: block;
  border-top: 4px solid #64748b;
  padding-top: 5px;
  color: #0f172a;
  font-weight: 950;
  line-height: 1.15;
  white-space: normal;
}

.integrated-boxplot-stat-label,
.integrated-boxplot-stat-value {
  color: #0f172a;
  font-weight: 900;
}

.integrated-boxplot-table-label {
  display: block;
  overflow: hidden;
  border-left: 4px solid #64748b;
  padding-left: 6px;
  color: #0f172a;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (prefers-reduced-motion: reduce) {
  .presentation-slide {
    transition: none;
  }
}
@media print {
  @page {
    size: 16in 9in;
    margin: 0;
  }
  :host,
  .presentation-root {
    background: #ffffff;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  .presentation-root {
    padding: 0;
    display: block;
    height: auto;
    overflow: visible;
  }
  .no-print,
  .modal-backdrop {
    display: none !important;
  }
  .presentation-stage {
    width: 100vw;
    max-width: none;
    max-height: none;
    height: auto;
    aspect-ratio: auto;
  }
  .presentation-slide,
  .presentation-slide.is-hidden {
    display: grid !important;
    position: relative;
    inset: auto;
    width: 100vw;
    height: 100vh;
    break-after: page;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    opacity: 1;
    transform: none;
    visibility: visible;
  }
  .presentation-slide:last-of-type {
    break-after: auto;
  }
}`],
})
export class PageReportComponent implements OnInit, OnDestroy {
    public analysis: any = null;
    public analysisSetId: string = "";
    public analysisSet: any = null;
    public loading: boolean = true;
    public error: string = "";
    public selectedSampleId: string = "";
    public imageModal: any = null;
    public currentSlideIndex: number = 0;
    public isPresentationMode: boolean = false;
    public isDrawingMode: boolean = false;
    public isPdfDownloadPreparing: boolean = false;
    public selectedPipelineCaseId: string = "background";
    public selectedConclusionCaseId: string = "background_blur_mmd_filter";
    public selectedBackgroundMetricKey: string = "CSP";
    public integratedReport: any = null;
    public selectedIntegratedSetId: string = "260612";
    public selectedIntegratedCaseId: string = "mmd_filter";
    public selectedIntegratedComparisonIds: { [key: string]: string } = {
        "260619": "260619-bg",
        "260612": "260612-blur",
    };
    public selectedIntegratedBackgroundId: string = "";
    public selectedIntegratedBlurId: string = "";
    public selectedIntegratedMmdId: string = "";
    public selectedIntegrated260612DiseaseBoxCaseId: string = "mmd_filter";
    public selectedIntegrated260619DiagnosisBoxCaseId: string = "background_blur_mmd_filter";
    public selectedIntegrated260612ThresholdCaseId: string = "all";
    public selectedIntegrated260612BlurMmdCaseId: string = "all";
    public selectedIntegrated260619SingleCaseId: string = "all";
    public selectedIntegrated260619CombinationCaseId: string = "original";
    public selectedIntegrated260612SampleGroupId: string = "";
    public selectedIntegrated260612SampleCaseId: string = "original";
    public selectedIntegrated260619SampleGroupId: string = "";
    public selectedIntegrated260619SampleCaseId: string = "original";
    public noiseReferenceImages: any[] = [
        {
            src: "/assets/cellytics/report/ori.png",
            alt: "원본 세포 이미지",
            modalTitle: "원본 이미지",
            caption: "ori.png · 762x382",
            label: "원본",
            width: 762,
            height: 382,
        },
        {
            src: "/assets/cellytics/report/box2x2.png",
            alt: "Box 2x2 blur 세포 이미지",
            modalTitle: "Box 2x2 blur 이미지",
            caption: "box2x2.png · 762x360",
            label: "Box 2x2 blur",
            width: 762,
            height: 360,
        },
    ];
    public backgroundEvidenceImages: any[] = [
        {
            src: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_original.jpg",
            full: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_original.jpg",
            download: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_original.jpg",
            alt: "260619 20260618_193828 ASC C 배경 보정 전 heatmap",
            modalTitle: "260619 20260618_193828 ASC C 보정 전 heatmap",
            caption: "Background subtraction 적용 전 밝기 분포",
            label: "260619 C.jpg 보정 전",
            width: 980,
            height: 735,
            trustedNative: true,
        },
        {
            src: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_background_corrected.jpg",
            full: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_background_corrected.jpg",
            download: "/assets/cellytics/260619/20260618_193828_ASC_C/heatmap_background_corrected.jpg",
            alt: "260619 20260618_193828 ASC C 배경 보정 후 heatmap",
            modalTitle: "260619 20260618_193828 ASC C 보정 후 heatmap",
            caption: "Background subtraction 적용 후 밝기 분포",
            label: "260619 C.jpg 보정 후",
            width: 980,
            height: 735,
            trustedNative: true,
        },
    ];
    public mmdEvidenceImages: any[] = [
        {
            src: "/assets/cellytics/260619/20260618_193828_ASC_C/original.jpg",
            full: "/assets/cellytics/260619/20260618_193828_ASC_C/original.jpg",
            download: "/assets/cellytics/260619/20260618_193828_ASC_C/original.jpg",
            alt: "260619 20260618_193828 ASC C 원본 분석 이미지",
            modalTitle: "260619 20260618_193828 ASC C 원본",
            caption: "MMD-std filtering 적용 전",
            label: "260619 C.jpg 원본",
            width: 980,
            height: 735,
            trustedNative: true,
        },
        {
            src: "/assets/cellytics/260619/20260618_193828_ASC_C/mmd_filter.jpg",
            full: "/assets/cellytics/260619/20260618_193828_ASC_C/mmd_filter.jpg",
            download: "/assets/cellytics/260619/20260618_193828_ASC_C/mmd_filter.jpg",
            alt: "260619 20260618_193828 ASC C MMD-std filtering 결과 이미지",
            modalTitle: "260619 20260618_193828 ASC C MMD-std filtering 결과",
            caption: "MMD-std filtering 적용 후",
            label: "MMD-std 필터",
            width: 980,
            height: 735,
            trustedNative: true,
        },
    ];
    private imageLoadPromises: { [url: string]: Promise<boolean> } = {};
    private sampleSwitchToken: number = 0;
    private previousBodyOverflow: string | null = null;
    private previousDocumentOverflow: string | null = null;
    private slideDrawings: { [slideIndex: number]: DrawingStroke[] } = {};
    private activeDrawingStroke: DrawingStroke | null = null;
    private drawingRedrawFrame: number | null = null;
    private routerSub: any = null;
    private pdfCleanupTimer: number | null = null;
    private pdfAfterPrintHandler: (() => void) | null = null;
    private pdfPreviousTitle: string = "";

    public slides: any[] = [
        { index: "01", title: "Cover", label: "표지" },
        { index: "02", title: "CSP Definition", label: "증가 원인" },
        { index: "03", title: "Preprocess Rationale", label: "전처리 원리" },
        { index: "04", title: "Pipeline", label: "파라미터 비교" },
        { index: "05", title: "BG Heatmap", label: "광원 불균형" },
        { index: "06", title: "BG Result", label: "이미지/파라미터" },
        { index: "07", title: "Blur Result", label: "Box blur" },
        { index: "08", title: "Noise Visual", label: "이미지/그래프" },
        { index: "09", title: "MMD Metrics", label: "이미지/파라미터" },
        { index: "10", title: "Correlations", label: "상관관계" },
        { index: "11", title: "Experiment Compare", label: "실험 비교" },
        { index: "12", title: "Final Conclusion", label: "최종 결론" },
    ];
    public integratedSlides: any[] = [
        { index: "01", title: "Cover", label: "표지" },
        { index: "02", title: "Analysis Overview", label: "분석 개요 / 샘플정보" },
        { index: "03", title: "260612 Sample CSP", label: "260612 샘플별 CSP" },
        { index: "04", title: "260619 Sample CSP", label: "260619 샘플별 CSP" },
        { index: "05", title: "260612 Disease Box Plot", label: "260612 질병명별 box plot" },
        { index: "06", title: "260619 Diagnosis Box Plot", label: "260619 환자/정상 box plot" },
        { index: "07", title: "Final Conclusion", label: "최종 결론" },
    ];

    public analytics: any = {
        mmdWsm: this.emptyCorrelation("MMD_STD", "WSM_STD"),
        mmdCsp: this.emptyCorrelation("MMD_STD", "CSP"),
    };

    public pipelineSteps: any[] = [
        {
            index: "01",
            caseId: "background",
            title: "BG",
            label: "Background subtraction",
            description: "저주파 밝기장을 추정해 배경 광원 편차를 제거하고 cell 검출 전 밝기 기준을 맞춥니다.",
            tone: "emerald",
        },
        {
            index: "02",
            caseId: "blur",
            title: "Blur",
            label: "Noise reduction",
            description: "검출 박스 주변의 고주파 노이즈를 낮춥니다. 현재 비교에서는 2x2 box blur 결과를 확인합니다.",
            tone: "blue",
        },
        {
            index: "03",
            caseId: "mmd_filter",
            title: "MMD-STD filtering",
            label: "Outlier filtering",
            description: "MMD_STD threshold를 넘는 cell을 제외해 불안정한 신호가 최종 파라미터에 미치는 영향을 줄입니다.",
            tone: "rose",
        },
        {
            index: "결과",
            caseId: "background_blur_mmd_filter",
            title: "BG + Blur + MMD",
            label: "현재 분석 조합",
            description: "현재 대시보드에서 기준 비교 대상으로 쓰는 전체 전처리 조합입니다.",
            tone: "slate",
        },
    ];

    public comparisonRows: any[] = [
        { key: "finalCount", label: "최종 cell", digits: 0, source: "case" },
        { key: "mmdRejected", label: "MMD 제외", digits: 0, source: "case" },
        { key: "overlapRejected", label: "Overlap 제외", digits: 0, source: "case" },
        { key: "CMV", label: "CMV", digits: 2, source: "metrics" },
        { key: "PPD", label: "PPD", digits: 2, source: "metrics" },
        { key: "MMD", label: "MMD", digits: 2, source: "metrics" },
        { key: "MMD_SD", label: "MMD_STD", digits: 2, source: "metrics" },
        { key: "WCM", label: "WCM", digits: 2, source: "metrics" },
        { key: "WCM_SD", label: "WCM_STD", digits: 2, source: "metrics" },
        { key: "WSM", label: "WSM", digits: 2, source: "metrics" },
        { key: "WSM_SD", label: "WSM_STD", digits: 2, source: "metrics" },
        { key: "CSP", label: "CSP", digits: 2, source: "metrics" },
        { key: "I3", label: "I3", digits: 1, source: "derived" },
    ];

    public metricRows: any[] = this.comparisonRows.filter((row: any) => row.source === "metrics" || row.source === "derived");
    public pipelineComparisonRows: any[] = [
        ...this.comparisonRows.filter((row: any) => row.source === "metrics"),
        { key: "I3", label: "I3", digits: 1, source: "derived" },
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.hasAccess()) {
            location.href = "/access";
            return;
        }
        this.applyAccessSession();
        this.syncAnalysisSet();
        this.bindRouteChanges();
        await this.load();
    }

    public ngOnDestroy() {
        this.clearReportPdfDownloadState();
        this.cancelActiveDrawingStroke();
        this.cancelDrawingRedraw();
        this.clearPresentationShell();
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.hasPresentationFullscreen()) {
            this.exitFullscreen().catch(() => { });
        }
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private applyAccessSession() {
        if (this.service.auth.check()) return;
        this.service.auth.status = true;
        this.service.auth.session = ACCESS_USER;
    }

    private syncAnalysisSet() {
        this.analysisSetId = cellyticsCurrentAnalysisSetId();
        this.analysisSet = cellyticsAnalysisSet(this.analysisSetId) || cellyticsDefaultAnalysisSet();
    }

    private bindRouteChanges() {
        if (this.routerSub) return;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (!(event instanceof NavigationEnd)) return;
            const nextSetId = cellyticsCurrentAnalysisSetId();
            if (nextSetId === this.analysisSetId) return;
            this.syncAnalysisSet();
            await this.load();
        });
    }

    public async load() {
        this.syncAnalysisSet();
        this.ensureSlideIndexInRange();
        this.loading = true;
        this.error = "";
        this.integratedReport = null;
        this.analysis = null;
        await this.service.render();

        try {
            if (this.isIntegratedReport) {
                await this.loadIntegratedReport();
                this.loading = false;
                await this.service.render();
                this.scheduleIntegratedReportWarmup();
                return;
            }

            this.analysis = await fetchJsonCached(cellyticsAnalysisDataUrl(this.analysisSetId));
            this.selectedSampleId = this.samples[0]?.id || "";
            const recommendedCaseId = cellyticsRecommendedCaseId(this.analysisSetId);
            if (this.caseSummaryById(recommendedCaseId)) this.selectedConclusionCaseId = recommendedCaseId;
            if (!this.caseSummaryById(this.selectedPipelineCaseId)) {
                this.selectedPipelineCaseId = this.caseSummary[1]?.caseId || this.caseSummary[0]?.caseId || "";
            }
            this.analytics = this.buildAnalytics();
            await this.preloadInitialImages();
        } catch (error) {
            this.error = "분석 데이터를 불러오지 못했습니다.";
        }

        this.loading = false;
        await this.service.render();
    }

    public get isIntegratedReport() {
        return this.analysisSetId === "260622";
    }

    private async loadIntegratedReport() {
        const datasets = await this.loadIntegratedReportDatasets();
        this.integratedReport = this.buildIntegratedReport(this.filteredIntegratedDatasets(datasets));
        this.analysis = this.integratedReport;
        this.ensureSelectedIntegratedDataset();
        this.ensureIntegratedComparisonSelections();
        this.ensureSelectedIntegratedCaseForSet();
        this.ensureIntegratedTopicSelections();
        this.ensureIntegratedSampleSelections();
    }

    private async loadIntegratedReportDatasets() {
        try {
            const reportData = await fetchJsonCached(INTEGRATED_REPORT_DATA_URL);
            const datasets = (reportData?.datasets || [])
                .map((dataset: any) => ({
                    setId: dataset.setId,
                    set: cellyticsAnalysisSet(dataset.setId),
                    data: dataset.data,
                }))
                .filter((dataset: any) => !!dataset.setId && !!dataset.data);
            if (datasets.length) return datasets;
        } catch (error) {
            // Fall back to the source analysis files when the compact report bundle is unavailable.
        }

        const datasets = await Promise.all(INTEGRATED_REPORT_SET_IDS.map(async (setId: string) => {
            return {
                setId,
                set: cellyticsAnalysisSet(setId),
                data: await fetchJsonCached(cellyticsAnalysisDataUrl(setId)),
            };
        }));
        return datasets;
    }

    private filteredIntegratedDatasets(datasets: any[]) {
        return (datasets || []).map((dataset: any) => {
            if (dataset?.setId !== "260612") return dataset;
            return {
                ...dataset,
                data: {
                    ...dataset.data,
                    samples: (dataset.data?.samples || []).filter((sample: any) => !this.isExcludedIntegratedSample(sample)),
                },
            };
        });
    }

    private isExcludedIntegratedSample(sample: any) {
        const text = [
            sample?.id,
            sample?.name,
            sample?.group,
            sample?.stem,
            sample?.path,
        ].map((value: any) => String(value || "")).join(" ");
        return /26AN185/.test(text) && /(ver1[_\s-]*2|ver1\s*-2|MIT_ver1_2)/i.test(text);
    }

    public get selectedIntegratedCase() {
        return this.integratedCaseOption(this.selectedIntegratedCaseId, this.selectedIntegratedSetId)
            || this.selectedIntegratedDatasetCaseOptions[0]
            || null;
    }

    public get selectedBackgroundPanel() {
        return this.integratedTopicPanel("background", this.selectedIntegratedBackgroundId);
    }

    public get selectedBlurPanel() {
        return this.integratedTopicPanel("blur", this.selectedIntegratedBlurId);
    }

    public get selectedMmdPanel() {
        return this.integratedTopicPanel("mmd", this.selectedIntegratedMmdId);
    }

    public get selectedI3BoxPlot() {
        return this.integratedReport?.i3BoxPlotsBySet?.[this.selectedIntegratedSetId]?.[this.selectedIntegratedCaseId]
            || this.integratedReport?.i3BoxPlots?.[this.selectedIntegratedCaseId]
            || this.emptyIntegratedBoxPlot();
    }

    public get selectedTreatmentBoxPlot() {
        return this.integratedReport?.treatmentBoxPlotsBySet?.[this.selectedIntegratedSetId]?.[this.selectedIntegratedCaseId]
            || this.integratedReport?.treatmentBoxPlots?.[this.selectedIntegratedCaseId]
            || this.emptyIntegratedBoxPlot();
    }

    public get integratedMetricLineCharts() {
        return this.integratedReport?.metricLineChartsBySet?.[this.selectedIntegratedSetId]
            || this.integratedReport?.metricLineCharts
            || [];
    }

    public get integratedDatasetSections() {
        return this.integratedReport?.datasetSections || [];
    }

    public get selectedIntegratedDatasetSection() {
        return this.integratedDatasetSection(this.selectedIntegratedSetId) || this.integratedDatasetSections[0] || null;
    }

    public get selectedIntegratedDatasetCaseOptions() {
        return this.selectedIntegratedDatasetSection?.caseOptions || [];
    }

    public get selectedIntegratedDatasetComparisons() {
        return this.selectedIntegratedDatasetSection?.comparisons || [];
    }

    public get selectedIntegratedComparison() {
        const section = this.selectedIntegratedDatasetSection;
        if (!section) return null;
        const selectedId = this.selectedIntegratedComparisonIds[section.setId];
        return section.comparisons.find((comparison: any) => comparison.id === selectedId)
            || section.comparisons[0]
            || null;
    }

    public get integratedPipelineCards() {
        return INTEGRATED_PIPELINE_STEPS.filter((step: any) => this.integratedCaseOption(step.caseId, this.selectedIntegratedSetId));
    }

    public get selectedIntegratedPipelineView() {
        return this.integratedComparisonView(this.selectedIntegratedComparison || {
            index: "03",
            title: "데이터셋별 전처리 비교",
            note: "260619와 260612 중 선택한 데이터셋만 집계합니다.",
            baseCaseId: "original",
            targetCaseId: this.selectedIntegratedCaseId || "blur",
            setIds: [this.selectedIntegratedSetId],
        });
    }

    public get integrated260612ThresholdResultView() {
        return this.integratedResultView("threshold");
    }

    public get integrated260612BlurMmdResultView() {
        return this.integratedResultView("blurMmd");
    }

    public get integrated260619ResultViews() {
        return ["260619Single", "260619Combination"]
            .map((sectionKey: string) => this.integratedResultView(sectionKey))
            .filter((view: any) => !!view);
    }

    public get visibleIntegrated260619ResultViews() {
        return [];
    }

    public get integrated260612SampleResultView() {
        return this.integratedSampleResultView("260612");
    }

    public get integrated260619SampleResultView() {
        return this.integratedSampleResultView("260619");
    }

    public get integrated260612DiseaseBoxPlotView() {
        return this.integratedGroupedI3BoxPlotView({
            setId: "260612",
            selectedCaseId: this.selectedIntegrated260612DiseaseBoxCaseId,
            caseIds: ["original", "mmd_filter", "blur_mmd_filter"],
            groupMode: "disease",
            title: "260612 질병명별 I3 box plot",
            note: "260612 · 결장암, 방광암, 다발성골수종, 위암, 정상 샘플의 ASC CSP / ve CSP x100 분포",
        });
    }

    public get integrated260619DiagnosisBoxPlotView() {
        return this.integratedGroupedI3BoxPlotView({
            setId: "260619",
            selectedCaseId: this.selectedIntegrated260619DiagnosisBoxCaseId,
            caseIds: ["original", "background_blur_mmd_filter", "background_mmd_filter"],
            groupMode: "diagnosis",
            title: "260619 환자/정상인 I3 box plot",
            note: "260619 · 질병명 없이 환자/정상인 기준으로 ASC CSP / ve CSP x100 분포",
        });
    }

    public get integratedDatasetSectionViews() {
        return this.integratedDatasetSections.map((section: any) => ({
            ...section,
            view: this.integratedComparisonView(this.selectedComparisonForSection(section)),
        }));
    }

    public integratedDatasetTabClass(setId: string) {
        return setId === this.selectedIntegratedSetId ? "integrated-dataset-tab is-active" : "integrated-dataset-tab";
    }

    public integratedCaseButtonClass(caseId: string) {
        if (caseId === this.selectedIntegratedCaseId) return "integrated-case-button is-active";
        return "integrated-case-button";
    }

    public integratedComparisonButtonClass(setId: string, comparisonId: string) {
        return this.selectedIntegratedComparisonIds[setId] === comparisonId ? "integrated-comparison-option is-active" : "integrated-comparison-option";
    }

    public integratedBoxPlotCaseButtonClass(caseId: string, selectedCaseId: string) {
        return caseId === selectedCaseId ? "integrated-boxplot-toggle-button is-active" : "integrated-boxplot-toggle-button";
    }

    public integratedResultConditionButtonClass(sectionKey: string, caseId: string, tone: string) {
        const active = this.integratedResultSelectedCaseId(sectionKey) === caseId ? " is-active" : "";
        return `pipeline-card integrated-result-condition-card integrated-result-condition-button ${tone || "slate"}${active}`;
    }

    public integratedResultAllButtonClass(sectionKey: string) {
        const active = this.integratedResultSelectedCaseId(sectionKey) === "all" ? " is-active" : "";
        return `integrated-result-all-button${active}`;
    }

    public integratedSampleGroupButtonClass(setId: string, groupId: string) {
        const active = this.integratedSampleResultSelectedGroupId(setId) === groupId ? " is-active" : "";
        return `integrated-sample-group-button${active}`;
    }

    public integratedSampleConditionButtonClass(setId: string, caseId: string) {
        const active = this.integratedSampleResultSelectedCaseId(setId) === caseId ? " is-active" : "";
        return `integrated-sample-condition-button${active}`;
    }

    public integratedPipelineCardClass(step: any) {
        const active = step?.caseId === this.selectedIntegratedCaseId ? " is-active" : "";
        return `pipeline-card integrated-pipeline-card ${step?.tone || "slate"}${active}`;
    }

    public async selectIntegratedCase(caseId: string) {
        if (!this.integratedCaseOption(caseId, this.selectedIntegratedSetId)) return;
        this.selectedIntegratedCaseId = caseId;
        await this.service.render();
    }

    public async selectIntegratedDataset(setId: string) {
        if (!this.integratedDatasetSection(setId)) return;
        this.selectedIntegratedSetId = setId;
        this.ensureIntegratedComparisonSelections();
        this.ensureSelectedIntegratedCaseForSet();
        await this.service.render();
    }

    public async selectIntegratedComparison(setId: string, comparisonId: string) {
        const comparison = this.integratedComparisonDefinition(setId, comparisonId);
        if (!comparison) return;
        this.selectedIntegratedSetId = setId;
        this.selectedIntegratedComparisonIds = {
            ...this.selectedIntegratedComparisonIds,
            [setId]: comparisonId,
        };
        this.selectedIntegratedCaseId = comparison.targetCaseId;
        this.ensureSelectedIntegratedCaseForSet();
        await this.service.render();
    }

    public integratedTopicTabClass(topic: string, panelId: string) {
        const selectedId = this.integratedTopicSelectedId(topic);
        return selectedId === panelId ? "integrated-topic-tab is-active" : "integrated-topic-tab";
    }

    public async selectIntegratedTopicTab(topic: string, panelId: string) {
        if (topic === "background") this.selectedIntegratedBackgroundId = panelId;
        if (topic === "blur") this.selectedIntegratedBlurId = panelId;
        if (topic === "mmd") this.selectedIntegratedMmdId = panelId;
        await this.service.render();
    }

    public async selectIntegrated260612DiseaseBoxCase(caseId: string) {
        if (!this.integratedGroupedBoxCaseAvailable("260612", caseId)) return;
        this.selectedIntegrated260612DiseaseBoxCaseId = caseId;
        await this.service.render();
    }

    public async selectIntegrated260619DiagnosisBoxCase(caseId: string) {
        if (!this.integratedGroupedBoxCaseAvailable("260619", caseId)) return;
        this.selectedIntegrated260619DiagnosisBoxCaseId = caseId;
        await this.service.render();
    }

    public async selectIntegratedResultCase(sectionKey: string, caseId: string) {
        const definition = INTEGRATED_RESULT_SECTIONS[sectionKey];
        if (!definition) return;
        const selectedCaseId = caseId === "all" || definition.cases.indexOf(caseId) >= 0 ? caseId : "all";
        if (sectionKey === "threshold") this.selectedIntegrated260612ThresholdCaseId = selectedCaseId;
        if (sectionKey === "blurMmd") this.selectedIntegrated260612BlurMmdCaseId = selectedCaseId;
        if (sectionKey === "260619Single") this.selectedIntegrated260619SingleCaseId = selectedCaseId;
        if (sectionKey === "260619Combination") this.selectedIntegrated260619CombinationCaseId = selectedCaseId;
        await this.service.render();
    }

    public async selectIntegratedSampleGroup(setId: string, groupId: string) {
        const groups = this.integratedSampleResultGroups(setId);
        if (!groups.some((group: any) => group.id === groupId)) return;
        if (setId === "260612") this.selectedIntegrated260612SampleGroupId = groupId;
        if (setId === "260619") this.selectedIntegrated260619SampleGroupId = groupId;
        this.preloadIntegratedSampleSelectionImages(setId);
        await this.service.render();
        this.scheduleIntegratedReportWarmup();
    }

    public async selectIntegratedSampleCase(setId: string, caseId: string) {
        const caseIds = this.integratedSampleResultCaseOptions(setId).map((row: any) => row.id);
        if (caseIds.indexOf(caseId) < 0) return;
        if (setId === "260612") this.selectedIntegrated260612SampleCaseId = caseId;
        if (setId === "260619") this.selectedIntegrated260619SampleCaseId = caseId;
        this.preloadIntegratedSampleSelectionImages(setId);
        await this.service.render();
        this.scheduleIntegratedReportWarmup();
    }

    private integratedResultSelectedCaseId(sectionKey: string) {
        if (sectionKey === "threshold") return this.selectedIntegrated260612ThresholdCaseId || "all";
        if (sectionKey === "blurMmd") return this.selectedIntegrated260612BlurMmdCaseId || "all";
        if (sectionKey === "260619Single") return this.selectedIntegrated260619SingleCaseId || "all";
        if (sectionKey === "260619Combination") return this.selectedIntegrated260619CombinationCaseId || "all";
        return "all";
    }

    private integratedTopicSelectedId(topic: string) {
        if (topic === "background") return this.selectedIntegratedBackgroundId;
        if (topic === "blur") return this.selectedIntegratedBlurId;
        if (topic === "mmd") return this.selectedIntegratedMmdId;
        return "";
    }

    private integratedTopicPanel(topic: string, panelId: string) {
        const panels = this.integratedReport?.interactivePanels?.[topic] || [];
        return panels.find((panel: any) => panel.id === panelId) || panels[0] || null;
    }

    private ensureIntegratedTopicSelections() {
        const panels = this.integratedReport?.interactivePanels || {};
        if (!this.integratedTopicPanel("background", this.selectedIntegratedBackgroundId)) {
            this.selectedIntegratedBackgroundId = panels.background?.[0]?.id || "";
        }
        if (!this.integratedTopicPanel("blur", this.selectedIntegratedBlurId)) {
            this.selectedIntegratedBlurId = panels.blur?.[0]?.id || "";
        }
        if (!this.integratedTopicPanel("mmd", this.selectedIntegratedMmdId)) {
            this.selectedIntegratedMmdId = panels.mmd?.[0]?.id || "";
        }
    }

    private ensureSelectedIntegratedDataset() {
        if (!this.integratedDatasetSection(this.selectedIntegratedSetId)) {
            this.selectedIntegratedSetId = this.integratedDatasetSections[0]?.setId || "260619";
        }
    }

    private ensureIntegratedComparisonSelections() {
        this.integratedDatasetSections.forEach((section: any) => {
            if (!this.integratedComparisonDefinition(section.setId, this.selectedIntegratedComparisonIds[section.setId])) {
                this.selectedIntegratedComparisonIds[section.setId] = section.comparisons?.[0]?.id || "";
            }
        });
    }

    private ensureSelectedIntegratedCaseForSet() {
        const options = this.selectedIntegratedDatasetCaseOptions;
        if (options.some((row: any) => row.id === this.selectedIntegratedCaseId)) return;
        const preferred = this.selectedIntegratedDatasetSection?.finalCaseId || this.selectedIntegratedComparison?.targetCaseId || "";
        this.selectedIntegratedCaseId = options.find((row: any) => row.id === preferred)?.id
            || options[0]?.id
            || "";
    }

    private selectedComparisonForSection(section: any) {
        if (!section) return null;
        const selectedId = this.selectedIntegratedComparisonIds[section.setId];
        return section.comparisons.find((comparison: any) => comparison.id === selectedId)
            || section.comparisons[0]
            || null;
    }

    private integratedDatasetSection(setId: string) {
        return this.integratedDatasetSections.find((section: any) => section.setId === setId) || null;
    }

    private integratedComparisonDefinition(setId: string, comparisonId: string) {
        const section = this.integratedDatasetSection(setId);
        return section?.comparisons?.find((comparison: any) => comparison.id === comparisonId) || null;
    }

    private integratedComparisonView(definition: any) {
        const comparison = definition || {};
        const empty = {
            ...comparison,
            baseCase: this.integratedCaseMeta(comparison?.baseCaseId || "original"),
            targetCase: this.integratedCaseMeta(comparison?.targetCaseId || "original"),
            tableRows: [],
            chartColumns: [],
            summaryCards: [],
            imageCards: [],
            representative: null,
        };
        if (!this.integratedReport) return empty;

        const baseCaseId = comparison?.baseCaseId || "original";
        const targetCaseId = comparison?.targetCaseId || "original";
        const setIds = comparison?.setIds || (comparison?.setId ? [comparison.setId] : [this.selectedIntegratedSetId]);
        const baseCase = this.integratedCaseMeta(baseCaseId);
        const targetCase = this.integratedCaseMeta(targetCaseId);
        const requiredCaseIds = Array.from(new Set([baseCaseId, targetCaseId]));
        const tableRows = INTEGRATED_PRIMARY_METRICS.map((metric: any) => {
            const originalValue = this.integratedAggregateMetricValue(metric, baseCaseId, setIds, requiredCaseIds);
            const targetValue = this.integratedAggregateMetricValue(metric, targetCaseId, setIds, requiredCaseIds);
            const hasValues = originalValue !== null && originalValue !== undefined && targetValue !== null && targetValue !== undefined;
            const delta = hasValues ? Number(targetValue) - Number(originalValue) : null;
            const deltaPercent = hasValues && originalValue ? (Number(delta) / Number(originalValue)) * 100 : null;
            const axisMax = this.metricAxisMax(metric, [originalValue, targetValue]);
            return {
                ...metric,
                originalValue,
                targetValue,
                delta,
                deltaPercent,
                axisMax,
                axisTicks: this.metricAxisTicks(axisMax, metric.digits),
            };
        });
        const chartColumns = tableRows.map((row: any) => ({
            ...row,
            columns: [
                {
                    key: "original",
                    label: baseCase.shortLabel || baseCase.label,
                    value: row.originalValue,
                    height: this.valueColumnPercent(row.originalValue, row.axisMax),
                },
                {
                    key: "target",
                    label: targetCase.shortLabel || targetCase.label,
                    value: row.targetValue,
                    height: this.valueColumnPercent(row.targetValue, row.axisMax),
                },
            ],
        }));

        return {
            ...comparison,
            baseCase,
            targetCase,
            setIds,
            tableRows,
            chartColumns,
            summaryCards: this.integratedComparisonSummaryCards(comparison, tableRows),
            ...this.integratedComparisonImages(comparison, baseCase, targetCase, setIds),
        };
    }

    private integratedAggregateMetricValue(metric: any, caseId: string, setIds: string[], requiredCaseIds: string[] = [caseId]) {
        const allowedSetIds = setIds || INTEGRATED_REPORT_SET_IDS;
        if (metric?.key === "I3") {
            return this.average((this.integratedReport?.i3Groups || [])
                .filter((group: any) => allowedSetIds.indexOf(group.setId) >= 0)
                .filter((group: any) => requiredCaseIds.every((requiredCaseId: string) => group.caseResultMap?.[requiredCaseId]?.i3 !== null && group.caseResultMap?.[requiredCaseId]?.i3 !== undefined))
                .map((group: any) => group.caseResultMap?.[caseId]?.i3));
        }
        const rows = (this.integratedReport?.sampleRows || [])
            .filter((row: any) => allowedSetIds.indexOf(row.setId) >= 0 && row.caseId === caseId)
            .filter((row: any) => requiredCaseIds.every((requiredCaseId: string) => {
                const caseRow = this.integratedCaseRow(row.sample, requiredCaseId);
                return caseRow?.metrics?.[metric.key] !== null && caseRow?.metrics?.[metric.key] !== undefined;
            }));
        return this.integratedAverageMetricFromRows(rows, metric.key);
    }

    private integratedComparisonSummaryCards(definition: any, rows: any[]) {
        const i3Row = rows.find((row: any) => row.key === "I3");
        const cspRow = rows.find((row: any) => row.key === "CSP");
        return [
            {
                label: "대상 데이터",
                value: (definition?.setIds || INTEGRATED_REPORT_SET_IDS).join(" + "),
                note: "선택 데이터셋만 집계",
            },
            {
                label: "비교 조건",
                value: `${this.integratedCaseMeta(definition?.baseCaseId || "original").shortLabel} -> ${this.integratedCaseMeta(definition?.targetCaseId || "original").shortLabel}`,
                note: "좌측 기준값, 우측 선택값",
            },
            {
                label: "CSP 변화율",
                value: `${this.signed(cspRow?.deltaPercent, 1)}%`,
                note: "PPD x WSM-sd 기반 핵심값",
            },
            {
                label: "I3 변화율",
                value: `${this.signed(i3Row?.deltaPercent, 1)}%`,
                note: "ASC CSP / ve CSP x100",
            },
        ];
    }

    private integratedComparisonImages(definition: any, baseCase: any, targetCase: any, setIds: string[]) {
        const representative = this.integratedRepresentativeForComparison(setIds, definition?.baseCaseId, definition?.targetCaseId);
        const sample = representative?.sample || null;
        const baseRow = representative?.baseRow || null;
        const targetRow = representative?.targetRow || null;
        const sampleLabel = sample ? `${representative.setId} · ${sample.name || sample.filename || sample.id}` : "대표 이미지 없음";
        return {
            representative: representative ? {
                setId: representative.setId,
                sampleId: sample?.id || "",
                sampleName: sample?.name || sample?.filename || sample?.id || "",
                label: sampleLabel,
            } : null,
            imageCards: [
                this.integratedComparisonImageCard("기준", baseCase, baseRow, sampleLabel),
                this.integratedComparisonImageCard("처리 후", targetCase, targetRow, sampleLabel),
            ].filter((row: any) => !!row),
        };
    }

    private integratedRepresentativeForComparison(setIds: string[], baseCaseId: string, targetCaseId: string) {
        const datasetIds = setIds?.length ? setIds : [this.selectedIntegratedSetId];
        for (const setId of datasetIds) {
            const dataset = this.integratedReport?.datasets?.find((row: any) => row.setId === setId);
            const samples = dataset?.data?.samples || [];
            const sortedSamples = [
                ...samples.filter((sample: any) => sample.diagnosis === "normal" && this.assayType(sample) === "asc"),
                ...samples.filter((sample: any) => sample.diagnosis === "patient" && this.assayType(sample) === "asc"),
                ...samples,
            ];
            const uniqueSamples = sortedSamples.filter((sample: any, index: number, list: any[]) => {
                return !!sample && list.findIndex((row: any) => row?.id === sample.id) === index;
            });
            const sample = uniqueSamples.find((row: any) => {
                return !!this.integratedCaseRow(row, baseCaseId) && !!this.integratedCaseRow(row, targetCaseId);
            });
            if (!sample) continue;
            return {
                setId,
                sample,
                baseRow: this.integratedCaseRow(sample, baseCaseId),
                targetRow: this.integratedCaseRow(sample, targetCaseId),
            };
        }
        return null;
    }

    private integratedComparisonImageCard(role: string, caseMeta: any, caseRow: any, sampleLabel: string) {
        if (!caseRow) return null;
        const image = this.imageRef(
            caseRow.preview,
            caseRow.fullImage,
            caseRow.downloadImage,
            caseRow.nativeWidth,
            caseRow.nativeHeight,
            true,
        );
        return {
            role,
            label: caseMeta?.shortLabel || caseMeta?.label || caseRow?.shortLabel || caseRow?.label || "-",
            modalTitle: `${sampleLabel} ${caseMeta?.shortLabel || caseRow?.shortLabel || role}`,
            caption: caseRow.synthetic ? caseRow.imageNote || "동적 집계 조건" : sampleLabel,
            note: caseRow.synthetic ? caseRow.imageNote || "" : "",
            image,
        };
    }

    private buildIntegratedReport(datasets: any[]) {
        const caseOptions = INTEGRATED_REPORT_CASES.filter((caseMeta: any) => {
            return datasets.some((dataset: any) => (dataset.data.samples || []).some((sample: any) => !!this.integratedCaseRow(sample, caseMeta.id)));
        });
        const caseIds = caseOptions.map((caseMeta: any) => caseMeta.id);
        const sampleRows = this.integratedSampleRows(datasets, caseIds);
        const i3Groups = this.integratedI3Groups(datasets, caseIds);
        const axisDomains = this.integratedAxisDomains(sampleRows, i3Groups, caseIds);
        const i3BoxPlots = this.integratedI3BoxPlots(caseIds, i3Groups, axisDomains.i3);
        const treatmentBoxPlots = this.integratedTreatmentBoxPlots(caseIds, sampleRows, axisDomains.csp);
        const metricLineCharts = this.integratedMetricLineChartsFor(sampleRows, caseOptions, axisDomains.metrics);
        const comparisonRows = this.integratedComparisonRows(sampleRows);
        const comparisonCards = this.integratedComparisonCards(comparisonRows);
        const representativeImages = this.integratedRepresentativeImages(datasets);
        const datasetCards = datasets.map((dataset: any) => {
            const samples = dataset.data.samples || [];
            const groups = i3Groups.filter((group: any) => group.setId === dataset.setId);
            return {
                setId: dataset.setId,
                label: dataset.set?.label || dataset.data.analysisSet?.label || dataset.setId,
                sampleCount: samples.length,
                normalCount: samples.filter((sample: any) => sample.diagnosis === "normal").length,
                patientCount: samples.filter((sample: any) => sample.diagnosis === "patient").length,
                i3GroupCount: groups.length,
                backgroundAvailable: dataset.data.analysisSet?.backgroundAvailable !== false,
            };
        });
        const interactivePanels = this.integratedInteractivePanels(datasets, i3Groups);
        const thresholdCharts = this.integratedThresholdCharts(datasets);
        const thresholdSummaryCards = this.integratedComparisonMetricCards(comparisonRows, "threshold");
        const overviewCards = this.integratedOverviewCards(datasetCards, sampleRows, i3Groups, caseOptions);
        const sampleInfoCards = this.integratedSampleInfoCards(datasets, i3Groups);
        const datasetSections = this.integratedDatasetSectionsFor(datasets, datasetCards);
        const bySetCharts = this.integratedChartsBySet(datasetSections, sampleRows, i3Groups);
        const finalCards = this.integratedFinalCards(datasetSections, bySetCharts.i3BoxPlotsBySet);
        return {
            generatedAt: new Date().toISOString(),
            datasets,
            datasetCards,
            datasetSections,
            overviewCards,
            sampleInfoCards,
            caseOptions,
            sampleRows,
            i3Groups,
            i3BoxPlots,
            treatmentBoxPlots,
            metricLineCharts,
            i3BoxPlotsBySet: bySetCharts.i3BoxPlotsBySet,
            treatmentBoxPlotsBySet: bySetCharts.treatmentBoxPlotsBySet,
            metricLineChartsBySet: bySetCharts.metricLineChartsBySet,
            axisDomains,
            comparisonRows,
            comparisonCards,
            thresholdCharts,
            thresholdSummaryCards,
            interactivePanels,
            finalCards,
            representativeImages,
            metricDefinitions: INTEGRATED_REPORT_METRICS,
            totalSamples: sampleRows.length,
            totalI3Groups: i3Groups.length,
            threshold: datasets.find((dataset: any) => dataset.data.parameters?.mmdSdThreshold)?.data.parameters.mmdSdThreshold || 13.5,
        };
    }

    private integratedDatasetSectionsFor(datasets: any[], datasetCards: any[]) {
        return INTEGRATED_DATASET_SECTIONS.map((section: any) => {
            const dataset = datasets.find((row: any) => row.setId === section.setId);
            const datasetCard = datasetCards.find((row: any) => row.setId === section.setId) || null;
            const comparisons = section.comparisons.map((comparison: any) => ({
                ...comparison,
                setId: section.setId,
                setIds: [section.setId],
                datasetLabel: section.label,
            }));
            const caseIds = Array.from(new Set(comparisons.flatMap((comparison: any) => [comparison.baseCaseId, comparison.targetCaseId])));
            const samples = dataset?.data?.samples || [];
            const caseOptions = caseIds
                .map((caseId: string) => this.integratedCaseMeta(caseId))
                .filter((caseMeta: any) => samples.some((sample: any) => !!this.integratedCaseRow(sample, caseMeta.id)));
            return {
                ...section,
                dataset,
                datasetCard,
                comparisons,
                caseOptions,
            };
        });
    }

    private integratedChartsBySet(datasetSections: any[], sampleRows: any[], i3Groups: any[]) {
        const i3BoxPlotsBySet: any = {};
        const treatmentBoxPlotsBySet: any = {};
        const metricLineChartsBySet: any = {};
        datasetSections.forEach((section: any) => {
            const setSampleRows = sampleRows.filter((row: any) => row.setId === section.setId);
            const setI3Groups = i3Groups.filter((group: any) => group.setId === section.setId);
            const setCaseOptions = section.caseOptions || [];
            const setCaseIds = setCaseOptions.map((caseMeta: any) => caseMeta.id);
            const axisDomains = this.integratedAxisDomains(setSampleRows, setI3Groups, setCaseIds);
            i3BoxPlotsBySet[section.setId] = this.integratedI3BoxPlots(setCaseIds, setI3Groups, axisDomains.i3);
            treatmentBoxPlotsBySet[section.setId] = this.integratedTreatmentBoxPlots(setCaseIds, setSampleRows, axisDomains.csp);
            metricLineChartsBySet[section.setId] = this.integratedMetricLineChartsFor(setSampleRows, setCaseOptions, axisDomains.metrics);
        });
        return { i3BoxPlotsBySet, treatmentBoxPlotsBySet, metricLineChartsBySet };
    }

    private integratedOverviewCards(datasetCards: any[], sampleRows: any[], i3Groups: any[], caseOptions: any[]) {
        const normalCount = datasetCards.reduce((sum: number, row: any) => sum + row.normalCount, 0);
        const patientCount = datasetCards.reduce((sum: number, row: any) => sum + row.patientCount, 0);
        return [
            {
                label: "통합 이미지",
                value: `${this.format(datasetCards.reduce((sum: number, row: any) => sum + row.sampleCount, 0), 0)} images`,
                note: datasetCards.map((row: any) => row.setId).join(" + "),
            },
            {
                label: "정상/환자",
                value: `${this.format(normalCount, 0)} / ${this.format(patientCount, 0)}`,
                note: "정상군 / 환자군 이미지 수",
            },
            {
                label: "I3 pair",
                value: this.format(i3Groups.length, 0),
                note: "ASC CSP / ve CSP x100",
            },
            {
                label: "주요 지표",
                value: "4 metrics",
                note: "PPD · WSM-sd · CSP · I3",
            },
            {
                label: "처리 조건",
                value: this.format(caseOptions.length, 0),
                note: "원본, 단일 처리, 조합 처리",
            },
            {
                label: "집계 row",
                value: this.format(sampleRows.length, 0),
                note: "sample x condition 기준",
            },
        ];
    }

    private integratedSampleInfoCards(datasets: any[], i3Groups: any[]) {
        return datasets.map((dataset: any) => {
            const samples = dataset.data.samples || [];
            const subjectRows = this.integratedSubjectRows(samples);
            const subjectCount = subjectRows.length;
            const i3GroupCount = i3Groups.filter((group: any) => group.setId === dataset.setId).length;
            const backgroundAvailable = dataset.data.analysisSet?.backgroundAvailable !== false;
            const rows = dataset.setId === "260612"
                ? this.integratedDiseaseSampleRows(subjectRows)
                : this.integratedDiagnosisSampleRows(subjectRows);
            return {
                setId: dataset.setId,
                title: dataset.data.analysisSet?.label || dataset.set?.label || dataset.setId,
                sampleCount: samples.length,
                subjectCount,
                i3GroupCount,
                backgroundAvailable,
                backgroundNote: backgroundAvailable ? "background 이미지 있음" : "background 이미지 없음",
                repeatSummary: this.integratedRepeatSummary(subjectRows),
                rows,
            };
        });
    }

    private integratedSubjectRows(samples: any[]) {
        const subjectMap: any = {};
        samples.forEach((sample: any) => {
            const subjectId = sample.subjectId || sample.sampleNumber || sample.subjectLabel || sample.group || sample.id;
            if (!subjectMap[subjectId]) {
                subjectMap[subjectId] = {
                    subjectId,
                    diseaseName: sample.diseaseName || "",
                    diagnosis: sample.diagnosis || "",
                    diagnosisLabel: sample.diagnosisLabel || "-",
                    sampleCount: 0,
                    replicates: [] as string[],
                    assays: [] as string[],
                };
            }
            const row = subjectMap[subjectId];
            row.sampleCount += 1;
            if (sample.replicate && row.replicates.indexOf(sample.replicate) < 0) row.replicates.push(sample.replicate);
            const assay = this.assayType(sample);
            if (assay && row.assays.indexOf(assay) < 0) row.assays.push(assay);
        });
        return Object.values(subjectMap);
    }

    private integratedDiseaseSampleRows(subjectRows: any[]) {
        const map: any = {};
        subjectRows.forEach((subject: any) => {
            const key = subject.diseaseName || subject.diagnosisLabel || subject.diagnosis || "미분류";
            if (!map[key]) {
                map[key] = { group: key, subjectCount: 0, sampleCount: 0, repeatCounts: [] as number[] };
            }
            map[key].subjectCount += 1;
            map[key].sampleCount += subject.sampleCount || 0;
            map[key].repeatCounts.push((subject.replicates || []).length);
        });
        return Object.values(map).map((row: any) => ({
            ...row,
            repeatSummary: this.repeatCountSummary(row.repeatCounts),
        }));
    }

    private integratedDiagnosisSampleRows(subjectRows: any[]) {
        const map: any = {};
        subjectRows.forEach((subject: any) => {
            const key = subject.diagnosisLabel || subject.diagnosis || "미분류";
            if (!map[key]) {
                map[key] = { group: key, subjectCount: 0, sampleCount: 0, repeatCounts: [] as number[] };
            }
            map[key].subjectCount += 1;
            map[key].sampleCount += subject.sampleCount || 0;
            map[key].repeatCounts.push((subject.replicates || []).length);
        });
        return Object.values(map).map((row: any) => ({
            ...row,
            repeatSummary: this.repeatCountSummary(row.repeatCounts),
        }));
    }

    private integratedRepeatSummary(subjectRows: any[]) {
        return this.repeatCountSummary(subjectRows.map((row: any) => (row.replicates || []).length));
    }

    private repeatCountSummary(counts: any[]) {
        const values = counts.map((value: any) => Number(value || 0)).filter((value: number) => value > 0);
        if (!values.length) return "-";
        const min = Math.min(...values);
        const max = Math.max(...values);
        return min === max ? `${min}개` : `${min}-${max}개`;
    }

    private integratedResultView(sectionKey: string) {
        const definition = INTEGRATED_RESULT_SECTIONS[sectionKey];
        if (!definition || !this.integratedReport) return null;
        const setId = definition.setId || "260612";
        const caseIds = definition.cases;
        const conditions = caseIds.map((caseId: string, index: number) => {
            const caseMeta = this.integratedCaseMeta(caseId);
            return {
                ...caseMeta,
                caseId,
                index: String(index + 1).padStart(2, "0"),
                tone: ["slate", "emerald", "blue", "rose", "amber"][index] || "slate",
                description: definition.descriptions?.[caseId] || caseMeta.label,
            };
        });
        const selectedCaseId = this.integratedResultSelectedCaseId(sectionKey);
        const selectedCondition = conditions.find((condition: any) => condition.caseId === selectedCaseId) || null;
        const isAllCaseView = !selectedCondition;
        const visibleCaseIds = isAllCaseView ? caseIds : [selectedCondition.caseId];
        const visibleConditions = isAllCaseView ? conditions : [selectedCondition];
        const parameterColumns = visibleConditions.map((condition: any) => ({
            ...condition,
            tableLabel: isAllCaseView ? this.integratedConditionTableLabel(condition) : condition.shortLabel,
        }));
        const chartModeLabel = isAllCaseView ? "전체 조건" : selectedCondition.shortLabel;
        const conditionLabelSummary = conditions.map((condition: any) => condition.shortLabel).join("/");
        return {
            ...definition,
            sectionKey,
            setId,
            conditions,
            selectedCaseId: isAllCaseView ? "all" : selectedCondition.caseId,
            selectedCondition,
            isAllCaseView,
            chartModeLabel,
            visibleCaseIds,
            conditionGridClass: conditions.length === 3 ? "three" : conditions.length === 5 ? "five" : "",
            cspPanelNote: isAllCaseView
                ? `${setId} · ${conditionLabelSummary} 조건별 정상 ve/ASC, 환자 ve/ASC CSP 분포`
                : `${setId} · ${chartModeLabel} 정상 ve/ASC, 환자 ve/ASC CSP 분포`,
            i3PanelNote: isAllCaseView
                ? `${setId} · ${conditionLabelSummary} 조건별 ASC CSP / ve CSP x100`
                : `${setId} · ${chartModeLabel} ASC CSP / ve CSP x100`,
            cspBoxPlot: this.integratedConditionCspBoxPlot(setId, visibleCaseIds),
            i3BoxPlot: this.integratedConditionI3BoxPlot(setId, visibleCaseIds),
            parameterColumns,
            parameterRows: this.integratedConditionParameterRows(setId, visibleCaseIds),
        };
    }

    private integratedSampleResultView(setId: string) {
        const definition = INTEGRATED_SAMPLE_RESULT_SECTIONS[setId];
        if (!definition || !this.integratedReport) return null;

        const groups = this.integratedSampleResultGroups(setId);
        const selectedGroupId = this.integratedSampleResultSelectedGroupId(setId);
        const group = groups.find((row: any) => row.id === selectedGroupId) || groups[0] || null;
        const caseOptions = this.integratedSampleResultCaseOptions(setId);
        const selectedCaseId = this.integratedSampleResultSelectedCaseId(setId);
        const selectedCase = caseOptions.find((row: any) => row.id === selectedCaseId) || caseOptions[0] || null;
        const imageCards = group && selectedCase ? this.integratedSampleImageCards(group.samples, selectedCase.id) : [];
        const cspDomain = this.integratedSampleCspDomain(group, caseOptions);
        const i3Group = group ? (this.integratedReport?.i3Groups || []).find((row: any) => row.groupKey === group.id) : null;
        const i3Result = selectedCase ? i3Group?.caseResultMap?.[selectedCase.id] || {} : {};

        return {
            ...definition,
            groups,
            selectedGroupId: group?.id || "",
            selectedGroup: group,
            selectedGroupLabel: group?.label || "-",
            caseOptions,
            selectedCaseId: selectedCase?.id || "",
            selectedCase,
            imageCards,
            assayCspBoxPlot: this.integratedSampleCombinedCspBoxPlot(imageCards, cspDomain),
            parameterColumns: imageCards.map((card: any) => ({ id: card.id, label: card.tableLabel })),
            parameterRows: this.integratedSampleParameterRows(imageCards, i3Result),
            summaryCards: [
                { label: "vehicle CSP", value: this.format(i3Result?.vehicleCsp, 1) },
                { label: "ASC CSP", value: this.format(i3Result?.ascCsp, 1) },
                { label: "I3", value: this.format(i3Result?.i3, 1) },
            ],
        };
    }

    private ensureIntegratedSampleSelections() {
        ["260612", "260619"].forEach((setId: string) => {
            const groups = this.integratedSampleResultGroups(setId);
            const currentGroupId = setId === "260612" ? this.selectedIntegrated260612SampleGroupId : this.selectedIntegrated260619SampleGroupId;
            if (!groups.some((group: any) => group.id === currentGroupId)) {
                if (setId === "260612") this.selectedIntegrated260612SampleGroupId = groups[0]?.id || "";
                if (setId === "260619") this.selectedIntegrated260619SampleGroupId = groups[0]?.id || "";
            }

            const caseOptions = this.integratedSampleResultCaseOptions(setId);
            const currentCaseId = setId === "260612" ? this.selectedIntegrated260612SampleCaseId : this.selectedIntegrated260619SampleCaseId;
            if (!caseOptions.some((row: any) => row.id === currentCaseId)) {
                if (setId === "260612") this.selectedIntegrated260612SampleCaseId = caseOptions[0]?.id || "";
                if (setId === "260619") this.selectedIntegrated260619SampleCaseId = caseOptions[0]?.id || "";
            }
        });
    }

    private integratedSampleResultSelectedGroupId(setId: string) {
        const current = setId === "260612" ? this.selectedIntegrated260612SampleGroupId : this.selectedIntegrated260619SampleGroupId;
        const groups = this.integratedSampleResultGroups(setId);
        return groups.some((group: any) => group.id === current) ? current : groups[0]?.id || "";
    }

    private integratedSampleResultSelectedCaseId(setId: string) {
        const current = setId === "260612" ? this.selectedIntegrated260612SampleCaseId : this.selectedIntegrated260619SampleCaseId;
        const caseOptions = this.integratedSampleResultCaseOptions(setId);
        return caseOptions.some((row: any) => row.id === current) ? current : caseOptions[0]?.id || "";
    }

    private integratedSampleResultCaseOptions(setId: string) {
        const definition = INTEGRATED_SAMPLE_RESULT_SECTIONS[setId];
        const dataset = this.integratedReport?.datasets?.find((row: any) => row.setId === setId);
        const samples = dataset?.data?.samples || [];
        return (definition?.cases || [])
            .map((caseId: string) => this.integratedCaseMeta(caseId))
            .filter((caseMeta: any) => samples.some((sample: any) => !!this.integratedCaseRow(sample, caseMeta.id)));
    }

    private integratedSampleResultGroups(setId: string) {
        const dataset = this.integratedReport?.datasets?.find((row: any) => row.setId === setId);
        const groupMap: any = {};
        (dataset?.data?.samples || []).forEach((sample: any) => {
            const rawGroupKey = this.integratedSampleResultGroupKey(setId, sample);
            if (!rawGroupKey) return;
            const id = `${setId}:${rawGroupKey}`;
            if (!groupMap[id]) {
                groupMap[id] = {
                    id,
                    rawGroupKey,
                    setId,
                    label: this.integratedSampleResultGroupLabel(setId, sample),
                    buttonLabel: this.integratedSampleResultGroupButtonLabel(setId, sample),
                    meta: this.integratedSampleResultGroupMeta(sample),
                    diagnosis: sample.diagnosis || "",
                    diagnosisLabel: sample.diagnosisLabel || "-",
                    diseaseName: sample.diseaseName || "",
                    samples: [],
                };
            }
            groupMap[id].samples.push(sample);
        });

        return Object.values(groupMap)
            .map((group: any) => ({
                ...group,
                samples: [...group.samples].sort((a: any, b: any) => this.integratedSampleImageSortValue(a) - this.integratedSampleImageSortValue(b)),
                sampleCount: group.samples.length,
            }))
            .filter((group: any) => group.sampleCount > 0)
            .sort((a: any, b: any) => a.label.localeCompare(b.label, "ko-KR", { numeric: true }));
    }

    private integratedSampleResultGroupKey(setId: string, sample: any) {
        if (setId === "260612" && sample?.sampleNumber && sample?.replicate) return `${sample.sampleNumber}:${sample.replicate}`;
        return sample?.subjectId || sample?.sampleNumber || this.integratedGroupKey(sample);
    }

    private integratedSampleResultGroupLabel(setId: string, sample: any) {
        if (setId === "260612") return `${sample?.subjectLabel || sample?.sampleNumber || "-"} ${sample?.replicate || ""}`.trim();
        return sample?.subjectLabel || String(sample?.subjectId || "-").replace(/^20260618_/, "");
    }

    private integratedSampleResultGroupButtonLabel(setId: string, sample: any) {
        if (setId === "260612") return `${sample?.subjectLabel || sample?.sampleNumber || "-"} ${sample?.replicate || ""}`.trim();
        return sample?.subjectLabel || String(sample?.subjectId || "-").replace(/^20260618_/, "");
    }

    private integratedSampleResultGroupMeta(sample: any) {
        const disease = sample?.diseaseName ? `${sample.diseaseName} · ` : "";
        return `${disease}${sample?.diagnosisLabel || "-"}`;
    }

    private integratedSampleImageCards(samples: any[], caseId: string) {
        return [...(samples || [])]
            .sort((a: any, b: any) => this.integratedSampleImageSortValue(a) - this.integratedSampleImageSortValue(b))
            .map((sample: any) => {
                const caseRow = this.integratedCaseRow(sample, caseId);
                const assay = this.assayType(sample);
                const assayLabel = assay === "vehicle" ? "vehicle" : "ASC";
                const wellLabel = this.integratedSampleWellLabel(sample);
                const fileLabel = sample?.filename || `${wellLabel}.jpg`;
                return {
                    id: sample.id,
                    sample,
                    caseRow,
                    assay,
                    assayLabel,
                    wellLabel,
                    title: `${assayLabel}:${fileLabel}`,
                    tableLabel: `${assayLabel} ${wellLabel}`,
                    csp: this.numberValue(caseRow?.metrics?.CSP),
                    finalCount: caseRow?.finalCount,
                    caption: `${sample?.name || sample?.id || ""} · ${this.integratedCaseMeta(caseId).shortLabel}`,
                    image: this.imageRef(
                        caseRow?.preview,
                        caseRow?.fullImage,
                        caseRow?.downloadImage,
                        caseRow?.nativeWidth || sample?.width,
                        caseRow?.nativeHeight || sample?.height,
                        true,
                    ),
                };
            });
    }

    private integratedSampleImageSortValue(sample: any) {
        const assayOrder = this.assayType(sample) === "vehicle" ? 0 : 1;
        const wellOrder: any = { A: 0, B: 1, C: 2, D: 3 };
        const well = this.integratedSampleWellLabel(sample);
        return assayOrder * 10 + (wellOrder[well] ?? 9);
    }

    private integratedSampleWellLabel(sample: any) {
        const source = String(sample?.stem || sample?.filename || sample?.replicate || "");
        const match = source.match(/[A-D]/i);
        return match ? match[0].toUpperCase() : source.replace(/\.[^.]+$/, "") || "-";
    }

    private integratedSampleCombinedCspBoxPlot(imageCards: any[], domain: any) {
        const rows = [
            {
                key: "vehicle",
                label: "vehicle A+B",
                color: "#047857",
                values: (imageCards || [])
                    .filter((card: any) => card.assay === "vehicle")
                    .flatMap((card: any) => this.integratedMetricValuesFromCase(card.caseRow, "CSP")),
            },
            {
                key: "asc",
                label: "ASC C+D",
                color: "#e11d48",
                values: (imageCards || [])
                    .filter((card: any) => card.assay === "asc")
                    .flatMap((card: any) => this.integratedMetricValuesFromCase(card.caseRow, "CSP")),
            },
        ];
        return this.buildIntegratedBoxPlot(rows, "CSP", domain);
    }

    private integratedSampleCspDomain(group: any, caseOptions: any[]) {
        const values = (group?.samples || []).flatMap((sample: any) => {
            return (caseOptions || []).flatMap((caseMeta: any) => {
                return this.integratedMetricValuesFromCase(this.integratedCaseRow(sample, caseMeta.id), "CSP");
            });
        });
        return this.integratedFixedDomain(values, "CSP");
    }

    private integratedSampleParameterRows(imageCards: any[], i3Result: any) {
        return INTEGRATED_PARAMETER_TABLE_METRICS.map((metric: any) => {
            const values = (imageCards || []).map((card: any) => {
                const value = metric.key === "I3" ? i3Result?.i3 : card.caseRow?.metrics?.[metric.key];
                return {
                    value,
                    text: this.format(value, metric.digits),
                };
            });
            return { ...metric, values };
        });
    }

    private integratedConditionTableLabel(condition: any) {
        const labels: any = {
            original: "원본",
            background: "BG",
            blur: "Blur",
            mmd_threshold_12_6: "MMD12.6",
            mmd_filter: "MMD13.5",
            blur_mmd_threshold_12_6: "B+M12.6",
            background_blur: "BG+Blur",
            background_blur_mmd_filter: "BG+B+M",
            background_mmd_filter: "BG+MMD",
            blur_mmd_filter: "B+MMD",
        };
        return labels[condition?.caseId] || condition?.shortLabel || "-";
    }

    private integratedConditionCspBoxPlot(setId: string, caseIds: string[]) {
        const rows: any[] = [];
        caseIds.forEach((caseId: string) => {
            const caseMeta = this.integratedCaseMeta(caseId);
            INTEGRATED_COHORTS.forEach((cohort: any) => {
                const sampleRows = (this.integratedReport?.sampleRows || [])
                    .filter((row: any) => row.setId === setId && row.caseId === caseId && row.cohortKey === cohort.key);
                rows.push({
                    key: `${caseId}:${cohort.key}`,
                    label: `${caseMeta.shortLabel} ${this.integratedCohortShortLabel(cohort)}`,
                    color: cohort.color,
                    values: this.integratedMetricValuesFromRows(sampleRows, "CSP"),
                });
            });
        });
        const domain = this.integratedFixedDomain(rows.flatMap((row: any) => row.values), "CSP");
        return this.buildIntegratedBoxPlot(rows, "CSP", domain);
    }

    private integratedConditionI3BoxPlot(setId: string, caseIds: string[]) {
        const rows: any[] = [];
        caseIds.forEach((caseId: string) => {
            const caseMeta = this.integratedCaseMeta(caseId);
            [
                { key: "normal", label: "정상", color: "#047857" },
                { key: "patient", label: "환자", color: "#e11d48" },
            ].forEach((cohort: any) => {
                rows.push({
                    key: `${caseId}:${cohort.key}`,
                    label: `${caseMeta.shortLabel} ${cohort.label}`,
                    color: cohort.color,
                    values: (this.integratedReport?.i3Groups || [])
                        .filter((group: any) => group.setId === setId && group.diagnosis === cohort.key)
                        .map((group: any) => group.caseResultMap?.[caseId]?.i3),
                });
            });
        });
        const domain = this.integratedFixedDomain(rows.flatMap((row: any) => row.values), "I3");
        return this.buildIntegratedBoxPlot(rows, "I3", domain);
    }

    private integratedConditionParameterRows(setId: string, caseIds: string[]) {
        return INTEGRATED_PARAMETER_TABLE_METRICS.map((metric: any) => {
            const values = caseIds.map((caseId: string) => {
                const value = this.integratedAggregateMetricValue(metric, caseId, [setId], caseIds);
                return {
                    caseId,
                    value,
                    digits: metric.digits,
                    text: this.format(value, metric.digits),
                };
            });
            return { ...metric, values };
        });
    }

    private integratedGroupedI3BoxPlotView(config: any) {
        const options = (config.caseIds || [])
            .filter((caseId: string) => this.integratedGroupedBoxCaseAvailable(config.setId, caseId))
            .map((caseId: string) => this.integratedGroupedBoxCaseMeta(caseId));
        const selectedCaseId = options.some((option: any) => option.id === config.selectedCaseId)
            ? config.selectedCaseId
            : options[0]?.id || "";
        const selectedCase = this.integratedGroupedBoxCaseMeta(selectedCaseId);
        const groups = (this.integratedReport?.i3Groups || [])
            .filter((group: any) => group.setId === config.setId && this.numberValue(group.caseResultMap?.[selectedCaseId]?.i3) !== null);
        const groupedRows = this.integratedGroupedI3Rows(groups, selectedCaseId, config.groupMode);
        const axisDomain = this.integratedFixedDomain(
            this.integratedGroupedI3AxisValues(config.setId, options.map((option: any) => option.id)),
            "I3",
        );
        const chart = this.buildIntegratedBoxPlot(groupedRows, "I3", axisDomain);
        const tableRows = chart.boxes.map((box: any) => ({
            label: box.label,
            color: box.color,
            n: box.stats?.count,
            min: box.stats?.min,
            q1: box.stats?.q1,
            median: box.stats?.median,
            q3: box.stats?.q3,
            max: box.stats?.max,
        }));
        const statRows = [
            { key: "n", label: "n", digits: 0 },
            { key: "min", label: "min", digits: 1 },
            { key: "q1", label: "Q1", digits: 1 },
            { key: "median", label: "median", digits: 1 },
            { key: "q3", label: "Q3", digits: 1 },
            { key: "max", label: "max", digits: 1 },
        ].map((stat: any) => ({
            label: stat.label,
            values: tableRows.map((row: any) => ({
                label: row.label,
                color: row.color,
                text: this.format(row[stat.key], stat.digits),
            })),
        }));
        return {
            ...config,
            selectedCaseId,
            selectedCase,
            options,
            chart,
            tableRows,
            statRows,
            summary: `${config.setId} · ${selectedCase.label} · ${chart.boxes.length} groups`,
        };
    }

    private integratedGroupedI3AxisValues(setId: string, caseIds: string[]) {
        return (this.integratedReport?.i3Groups || [])
            .filter((group: any) => group.setId === setId)
            .flatMap((group: any) => (caseIds || []).map((caseId: string) => group.caseResultMap?.[caseId]?.i3));
    }

    private integratedGroupedI3Rows(groups: any[], caseId: string, groupMode: string) {
        const groupMap: any = {};
        groups.forEach((group: any) => {
            const groupLabel = groupMode === "disease"
                ? (group.diseaseName || group.diagnosisLabel || group.diagnosis || "미분류")
                : (group.diagnosis === "patient" ? "환자" : group.diagnosis === "normal" ? "정상인" : group.diagnosisLabel || "미분류");
            if (!groupMap[groupLabel]) {
                groupMap[groupLabel] = {
                    key: `${groupMode}:${groupLabel}`,
                    label: groupLabel,
                    color: this.integratedGroupedI3Color(groupMode, groupLabel),
                    values: [] as any[],
                    order: Object.keys(groupMap).length,
                };
            }
            groupMap[groupLabel].values.push(group.caseResultMap?.[caseId]?.i3);
        });
        return Object.values(groupMap).sort((a: any, b: any) => {
            const isNormalLabel = (label: string) => label === "정상" || label === "정상인";
            if (groupMode === "diagnosis") {
                const order: any = { "정상인": 0, "정상": 0, "환자": 1 };
                return (order[a.label] ?? 9) - (order[b.label] ?? 9);
            }
            if (isNormalLabel(a.label) && !isNormalLabel(b.label)) return -1;
            if (!isNormalLabel(a.label) && isNormalLabel(b.label)) return 1;
            return a.order - b.order;
        });
    }

    private integratedGroupedI3Color(groupMode: string, label: string) {
        if (groupMode === "diagnosis") {
            if (label === "환자") return "#e11d48";
            if (label === "정상인" || label === "정상") return "#047857";
        }
        const colors: any = {
            "결장암": "#0f766e",
            "방광암": "#2563eb",
            "다발성골수종": "#7c3aed",
            "위암": "#c2410c",
            "정상": "#047857",
        };
        return colors[label] || "#475569";
    }

    private integratedGroupedBoxCaseAvailable(setId: string, caseId: string) {
        return (this.integratedReport?.i3Groups || []).some((group: any) => {
            return group.setId === setId && this.numberValue(group.caseResultMap?.[caseId]?.i3) !== null;
        });
    }

    private integratedGroupedBoxCaseMeta(caseId: string) {
        const caseMeta = this.integratedCaseMeta(caseId);
        const overrides: any = {
            mmd_filter: { label: "MMD std(13.5)", shortLabel: "MMD std" },
            blur_mmd_filter: { label: "Blur + MMD std(13.5)", shortLabel: "Blur+MMD std" },
            background_blur_mmd_filter: { label: "Background + Blur + MMD std(13.5)", shortLabel: "BG+Blur+MMD" },
            background_mmd_filter: { label: "Background + MMD std(13.5)", shortLabel: "BG+MMD" },
        };
        return { ...caseMeta, ...(overrides[caseId] || {}) };
    }

    private integratedCohortShortLabel(cohort: any) {
        const diagnosis = cohort.diagnosis === "normal" ? "정상" : "환자";
        const assay = cohort.assay === "vehicle" ? "ve" : "ASC";
        return `${diagnosis} ${assay}`;
    }

    private integratedInteractivePanels(datasets: any[], i3Groups: any[]) {
        return {
            background: this.integratedTopicPanels(datasets, i3Groups, "background"),
            blur: this.integratedTopicPanels(datasets, i3Groups, "blur"),
            mmd: this.integratedTopicPanels(datasets, i3Groups, "mmd"),
        };
    }

    private integratedTopicPanels(datasets: any[], i3Groups: any[], topic: string) {
        const panels: any[] = [];
        datasets.forEach((dataset: any) => {
            const samples = dataset.data.samples || [];
            const wantedSamples = [
                this.integratedRepresentativeSample(samples, "normal", "asc", topic),
                this.integratedRepresentativeSample(samples, "patient", "asc", topic),
            ].filter((sample: any, index: number, list: any[]) => {
                return !!sample && list.findIndex((row: any) => row?.id === sample.id) === index;
            });

            wantedSamples.forEach((sample: any) => {
                const panel = this.integratedTopicPanelForSample(dataset, sample, topic, i3Groups);
                if (panel) panels.push(panel);
            });
        });
        return panels;
    }

    private integratedRepresentativeSample(samples: any[], diagnosis: string, assay: string, topic: string) {
        return samples.find((sample: any) => {
            if (sample.diagnosis !== diagnosis || this.assayType(sample) !== assay) return false;
            if (topic === "background" && !sample.visuals?.backgroundHeatmap) return false;
            if (topic === "blur" && !sample.visuals?.blurVisual) return false;
            return true;
        }) || null;
    }

    private integratedTopicPanelForSample(dataset: any, sample: any, topic: string, i3Groups: any[]) {
        const targetCaseIdMap: any = {
            background: "background",
            blur: "blur",
            mmd: "mmd_filter",
        };
        const baseCaseId = "original";
        const targetCaseId = targetCaseIdMap[topic];
        const baseCase = this.integratedCaseRow(sample, baseCaseId);
        const targetCase = this.integratedCaseRow(sample, targetCaseId);
        if (!baseCase || !targetCase) return null;

        const i3Group = this.integratedI3GroupForSample(i3Groups, dataset.setId, sample);
        const topicLabels: any = {
            background: "밝기 보정",
            blur: "Blur",
            mmd: "MMD filtering",
        };
        return {
            id: `${topic}:${dataset.setId}:${sample.id}`,
            topic,
            setId: dataset.setId,
            title: `${dataset.setId} ${sample.diagnosisLabel || sample.diagnosis} ${sample.assay || ""}`,
            subtitle: sample.name,
            topicLabel: topicLabels[topic] || topic,
            baseCase,
            targetCase,
            baseCaseMeta: this.integratedCaseMeta(baseCaseId),
            targetCaseMeta: this.integratedCaseMeta(targetCaseId),
            images: this.integratedTopicImages(topic, sample, baseCase, targetCase),
            metrics: this.integratedPanelMetrics(baseCase, targetCase, baseCaseId, targetCaseId, i3Group),
            stats: this.integratedTopicStats(topic, sample, baseCase, targetCase),
        };
    }

    private integratedI3GroupForSample(i3Groups: any[], setId: string, sample: any) {
        const groupKey = `${setId}:${this.integratedGroupKey(sample)}`;
        return i3Groups.find((group: any) => group.groupKey === groupKey) || null;
    }

    private integratedTopicImages(topic: string, sample: any, baseCase: any, targetCase: any) {
        if (topic === "background") {
            const visual = sample.visuals?.backgroundHeatmap || {};
            const original = this.imageRef(visual.original, visual.originalFull, visual.originalDownload, visual.nativeWidth, visual.nativeHeight, true);
            const corrected = this.imageRef(visual.corrected, visual.correctedFull, visual.correctedDownload, visual.nativeWidth, visual.nativeHeight, true);
            return [
                { label: "원본", caption: "보정 전 밝기 분포", image: original },
                { label: "처리 후", caption: "보정 후 밝기 분포", image: corrected },
                { label: "차이", caption: "보정 전/후 heatmap overlay", image: corrected, mode: "blend", before: original, after: corrected },
            ];
        }

        if (topic === "blur") {
            const visual = sample.visuals?.blurVisual || {};
            const original = this.imageRef(visual.original || baseCase.preview, visual.originalFull || baseCase.fullImage, visual.originalDownload, visual.nativeWidth || baseCase.nativeWidth, visual.nativeHeight || baseCase.nativeHeight, true);
            const blurred = this.imageRef(visual.blurred || targetCase.preview, visual.blurredFull || targetCase.fullImage, visual.blurredDownload, visual.nativeWidth || targetCase.nativeWidth, visual.nativeHeight || targetCase.nativeHeight, true);
            const residual = this.imageRef(visual.residualHeatmap, visual.residualHeatmapFull, visual.residualHeatmapDownload, visual.nativeWidth, visual.nativeHeight, true);
            return [
                { label: "원본", caption: "원본 crop", image: original },
                { label: "처리 후", caption: "Box blur 처리 후", image: blurred },
                { label: "차이", caption: "Blur residual heatmap", image: residual || blurred },
            ];
        }

        const original = this.imageRef(baseCase.preview, baseCase.fullImage, baseCase.downloadImage, baseCase.nativeWidth, baseCase.nativeHeight, true);
        const filtered = this.imageRef(targetCase.preview, targetCase.fullImage, targetCase.downloadImage, targetCase.nativeWidth, targetCase.nativeHeight, true);
        return [
            { label: "원본", caption: "MMD filtering 전 분석 결과", image: original },
            { label: "처리 후", caption: "MMD filtering 후 분석 결과", image: filtered },
            { label: "차이", caption: "필터링 전/후 overlay", image: filtered, mode: "blend", before: original, after: filtered },
        ];
    }

    private integratedPanelMetrics(baseCase: any, targetCase: any, baseCaseId: string, targetCaseId: string, i3Group: any) {
        const rows = INTEGRATED_REPORT_METRICS.map((metric: any) => {
            return this.integratedMetricDelta(metric, baseCase?.metrics?.[metric.key], targetCase?.metrics?.[metric.key]);
        });
        const baseI3 = this.numberValue(i3Group?.caseResultMap?.[baseCaseId]?.i3);
        const targetI3 = this.numberValue(i3Group?.caseResultMap?.[targetCaseId]?.i3);
        if (baseI3 !== null || targetI3 !== null) {
            rows.push(this.integratedMetricDelta({ key: "I3", label: "I3", digits: 1 }, baseI3, targetI3));
        }
        return rows;
    }

    private integratedMetricDelta(metric: any, baseValue: any, targetValue: any) {
        const base = this.numberValue(baseValue);
        const target = this.numberValue(targetValue);
        const delta = base !== null && target !== null ? target - base : null;
        return {
            ...metric,
            baseValue: base,
            targetValue: target,
            delta,
            deltaPercent: base ? (Number(delta) / Number(base)) * 100 : null,
        };
    }

    private integratedTopicStats(topic: string, sample: any, baseCase: any, targetCase: any) {
        if (topic === "background") {
            const visual = sample.visuals?.backgroundHeatmap || {};
            return [
                { label: "원본 CV", value: this.format(visual.originalStats?.cv, 3) },
                { label: "보정 CV", value: this.format(visual.correctedStats?.cv, 3) },
                { label: "CV 감소", value: `${this.format(visual.cvReductionPercent, 1)}%` },
                { label: "Range 감소", value: `${this.format(visual.rangeReductionPercent, 1)}%` },
            ];
        }
        if (topic === "blur") {
            const visual = sample.visuals?.blurVisual || {};
            return [
                { label: "Laplacian 감소", value: `${this.format(visual.laplacianReductionPercent, 1)}%` },
                { label: "Residual mean", value: this.format(visual.residualMean, 2) },
                { label: "Residual P95", value: this.format(visual.residualP95, 1) },
                { label: "cell 변화", value: this.signed((targetCase?.finalCount || 0) - (baseCase?.finalCount || 0), 0) },
            ];
        }
        return [
            { label: "최종 cell", value: this.format(targetCase?.finalCount, 0) },
            { label: "MMD 제외", value: this.format(targetCase?.mmdRejected, 0) },
            { label: "Overlap 제외", value: this.format(targetCase?.overlapRejected, 0) },
            { label: "cell 변화", value: this.signed((targetCase?.finalCount || 0) - (baseCase?.finalCount || 0), 0) },
        ];
    }

    private integratedThresholdCharts(datasets: any[]) {
        const rows: any[] = [];
        datasets.forEach((dataset: any) => {
            (dataset.data.samples || []).forEach((sample: any) => {
                (sample.mmdThresholdRows || []).forEach((row: any) => {
                    rows.push({ setId: dataset.setId, sample, threshold: Number(row.threshold), metrics: row.metrics || {}, finalCount: row.finalCount });
                });
            });
        });
        const thresholds = Array.from(new Set(rows.map((row: any) => row.threshold))).sort((a: any, b: any) => Number(a) - Number(b));
        if (!thresholds.length) return [];

        return INTEGRATED_REPORT_METRICS.map((metric: any) => {
            const chart = {
                width: 720,
                height: 260,
                left: 58,
                right: 26,
                top: 24,
                bottom: 56,
                metric,
                domain: this.integratedFixedDomain(rows.map((row: any) => row.metrics?.[metric.key]), metric.key),
                ticks: [] as any[],
                labels: [] as any[],
                series: [] as any[],
            };
            chart.ticks = this.buildTicks(chart.domain.min, chart.domain.max, INTEGRATED_AXIS_TICK_COUNT).map((value: number) => ({
                value,
                y: this.scaleSvgY(value, chart.domain.min, chart.domain.max, chart),
            }));
            const plotWidth = chart.width - chart.left - chart.right;
            const step = thresholds.length > 1 ? plotWidth / (thresholds.length - 1) : plotWidth;
            chart.labels = thresholds.map((threshold: any, index: number) => ({
                x: thresholds.length > 1 ? chart.left + step * index : chart.left + plotWidth / 2,
                text: this.format(threshold, 1),
            }));
            const points = thresholds.map((threshold: any, index: number) => {
                const value = this.average(rows
                    .filter((row: any) => Number(row.threshold) === Number(threshold))
                    .map((row: any) => row.metrics?.[metric.key]));
                const x = thresholds.length > 1 ? chart.left + step * index : chart.left + plotWidth / 2;
                const y = value === null ? null : this.scaleSvgY(Number(value), chart.domain.min, chart.domain.max, chart);
                return { threshold, label: this.format(threshold, 1), value, x, y };
            }).filter((point: any) => point.y !== null);
            chart.series = [{
                label: "260619 threshold sweep",
                color: "#0f766e",
                points,
                pointsAttr: points.map((point: any) => `${point.x},${point.y}`).join(" "),
            }];
            return chart;
        });
    }

    private integratedComparisonMetricCards(comparisonRows: any[], comparisonId: string) {
        const rows = comparisonRows.filter((row: any) => row.comparisonId === comparisonId);
        return INTEGRATED_REPORT_METRICS.map((metric: any) => {
            const metricRows = rows.filter((row: any) => row.metric.key === metric.key);
            return {
                ...metric,
                baseAverage: this.average(metricRows.map((row: any) => row.baseAverage)),
                targetAverage: this.average(metricRows.map((row: any) => row.targetAverage)),
                deltaPercent: this.average(metricRows.map((row: any) => row.deltaPercent)),
            };
        });
    }

    private integratedFinalCards(datasetSections: any[], i3BoxPlotsBySet: any) {
        const finalCases = datasetSections.map((section: any) => `${section.setId}: ${this.integratedCaseMeta(section.finalCaseId || INTEGRATED_FINAL_CASE_BY_SET[section.setId] || "blur_mmd_filter").shortLabel}`);
        const sectionSummaries = datasetSections.map((section: any) => `${section.setId} ${section.comparisons.length}개`);
        const selected260619Plot = i3BoxPlotsBySet?.["260619"]?.background_blur_mmd_filter || this.emptyIntegratedBoxPlot("I3");
        const selected260612Plot = i3BoxPlotsBySet?.["260612"]?.blur_mmd_filter || this.emptyIntegratedBoxPlot("I3");
        const normal619 = selected260619Plot.boxes?.find((box: any) => box.key === "normal");
        const patient612 = selected260612Plot.boxes?.find((box: any) => box.key === "patient");
        return [
            {
                label: "데이터셋별 섹션",
                value: sectionSummaries.join(" / "),
                note: "260619와 260612 비교 버튼을 분리",
            },
            {
                label: "대표 비교 조건",
                value: finalCases.join(" / "),
                note: "autoled 유무에 따라 최종 조건 분리",
            },
            {
                label: "I3 box plot",
                value: `260619 정상 ${this.format(normal619?.stats?.median, 1)} / 260612 환자 ${this.format(patient612?.stats?.median, 1)}`,
                note: "데이터셋 탭 기준으로 별도 집계",
            },
            {
                label: "260612 threshold",
                value: "12.6 재분석 이미지",
                note: "260612 전체 샘플에 threshold/mmd_12_6.jpg 생성",
            },
        ];
    }

    private integratedCaseOption(caseId: string, setId: string = "") {
        if (setId) {
            return this.integratedDatasetSection(setId)?.caseOptions?.find((row: any) => row.id === caseId) || null;
        }
        return this.integratedReport?.caseOptions?.find((row: any) => row.id === caseId) || null;
    }

    private integratedSampleRows(datasets: any[], caseIds: string[]) {
        const rows: any[] = [];
        datasets.forEach((dataset: any) => {
            (dataset.data.samples || []).forEach((sample: any) => {
                const assay = this.assayType(sample);
                if (!assay) return;
                caseIds.forEach((caseId: string) => {
                    const caseRow = this.integratedCaseRow(sample, caseId);
                    if (!caseRow?.metrics) return;
                    rows.push({
                        setId: dataset.setId,
                        setLabel: dataset.set?.label || dataset.data.analysisSet?.label || dataset.setId,
                        sample,
                        caseId,
                        caseMeta: this.integratedCaseMeta(caseId),
                        caseRow,
                        diagnosis: sample.diagnosis || "unknown",
                        diagnosisLabel: sample.diagnosisLabel || "-",
                        assay,
                        assayLabel: assay === "asc" ? "ASC" : "ve",
                        cohortKey: `${sample.diagnosis || "unknown"}:${assay}`,
                    });
                });
            });
        });
        return rows;
    }

    private integratedCaseMeta(caseId: string) {
        return INTEGRATED_REPORT_CASES.find((row: any) => row.id === caseId) || { id: caseId, label: caseId, shortLabel: caseId };
    }

    private integratedCaseRow(sample: any, caseId: string) {
        const caseMeta = this.integratedCaseMeta(caseId);
        if (caseMeta.threshold) {
            const thresholdRow = (sample?.mmdThresholdRows || []).find((row: any) => {
                if (Number(row.threshold) !== Number(caseMeta.threshold)) return false;
                return !row.caseId || row.caseId === caseMeta.id;
            });
            if (thresholdRow && !caseMeta.baseCaseId) return thresholdRow;
            return this.syntheticMmdThresholdRow(sample, caseMeta.threshold, caseMeta.baseCaseId || "original", caseMeta)
                || this.fallbackIntegratedCaseRow(sample, caseMeta)
                || thresholdRow
                || null;
        }
        return sample?.cases?.find((row: any) => row.caseId === caseId) || null;
    }

    private fallbackIntegratedCaseRow(sample: any, caseMeta: any) {
        if (!sample || !caseMeta?.fallbackCaseId) return null;
        const fallback = sample?.cases?.find((row: any) => row.caseId === caseMeta.fallbackCaseId) || null;
        if (!fallback) return null;
        return {
            ...fallback,
            caseId: caseMeta.id,
            label: caseMeta.label,
            shortLabel: caseMeta.shortLabel,
            synthetic: true,
            imageNote: `${caseMeta.shortLabel} 전용 cell-level 데이터가 없어 ${this.integratedCaseMeta(caseMeta.fallbackCaseId).shortLabel} 집계를 표시합니다.`,
        };
    }

    private syntheticMmdThresholdRow(sample: any, threshold: number, baseCaseId: string = "original", caseMeta: any = null) {
        if (!sample || !threshold) return null;
        const key = `_syntheticMmdThreshold_${baseCaseId}_${String(threshold).replace(".", "_")}`;
        if (sample[key]) return sample[key];

        const baseCase = sample?.cases?.find((row: any) => row.caseId === baseCaseId) || null;
        const baseCells = baseCase?.cellMetrics || [];
        if (!baseCase || !baseCells.length) return null;

        const selectedCells = baseCells.filter((cell: any) => {
            const value = this.numberValue(cell.MMD_SD);
            return value !== null && value <= threshold;
        });
        const metricKeys = ["CMV", "PPD", "MMD", "MMD_SD", "WCM", "WCM_SD", "WSM", "WSM_SD", "CSP"];
        const metrics: any = {};
        metricKeys.forEach((metricKey: string) => {
            metrics[metricKey] = this.roundMetricValue(this.average(selectedCells.map((cell: any) => cell[metricKey])));
        });

        const thresholdLabel = this.format(threshold, 1);
        sample[key] = {
            caseId: caseMeta?.id || `mmd_threshold_${String(threshold).replace(".", "_")}`,
            label: caseMeta?.label || `MMD std ${thresholdLabel}`,
            shortLabel: caseMeta?.shortLabel || `MMD ${thresholdLabel}`,
            threshold,
            thresholdLabel,
            preview: baseCase.preview,
            fullImage: baseCase.fullImage,
            downloadImage: baseCase.downloadImage,
            nativeWidth: baseCase.nativeWidth,
            nativeHeight: baseCase.nativeHeight,
            detectedCount: baseCase.detectedCount,
            analyzedCount: baseCase.analyzedCount,
            mmdRejected: Math.max(0, Number(baseCase.finalCount || baseCells.length) - selectedCells.length),
            overlapRejected: 0,
            finalCount: selectedCells.length,
            metrics,
            cellMetrics: selectedCells,
            deltaCount: selectedCells.length - Number(baseCase.finalCount || 0),
            deltaPercent: baseCase.finalCount ? ((selectedCells.length - Number(baseCase.finalCount)) / Number(baseCase.finalCount)) * 100 : null,
            synthetic: true,
            imageNote: `${thresholdLabel} threshold 전용 이미지가 없을 때만 기준 분석 이미지를 임시 표시합니다.`,
        };
        return sample[key];
    }

    private integratedAverageMetricFromRows(rows: any[], metricKey: string) {
        let sum = 0;
        let count = 0;
        (rows || []).forEach((row: any) => {
            const caseRow = row?.caseRow || row;
            const cellValues = this.integratedCellMetricValuesFromCase(caseRow, metricKey);
            if (cellValues.length) {
                sum += cellValues.reduce((total: number, value: number) => total + value, 0);
                count += cellValues.length;
                return;
            }

            const value = this.numberValue(caseRow?.metrics?.[metricKey]);
            if (value === null) return;
            const weight = Math.max(1, Math.floor(Number(caseRow?.finalCount) || 0));
            sum += Number(value) * weight;
            count += weight;
        });
        return count ? sum / count : null;
    }

    private integratedMetricValuesFromRows(rows: any[], metricKey: string) {
        return (rows || []).flatMap((row: any) => this.integratedMetricValuesFromCase(row?.caseRow || row, metricKey));
    }

    private integratedMetricValuesFromCase(caseRow: any, metricKey: string) {
        if (!caseRow) return [];
        const cacheKey = `_integratedMetricValues_${metricKey}`;
        if (caseRow[cacheKey]) return caseRow[cacheKey];

        const cellValues = this.integratedCellMetricValuesFromCase(caseRow, metricKey);
        if (cellValues.length) {
            caseRow[cacheKey] = cellValues;
            return cellValues;
        }

        const value = this.numberValue(caseRow?.metrics?.[metricKey]);
        if (value === null) {
            caseRow[cacheKey] = [];
            return caseRow[cacheKey];
        }

        const count = Math.max(1, Math.floor(Number(caseRow?.finalCount) || 0));
        caseRow[cacheKey] = Array.from({ length: count }, () => Number(value));
        return caseRow[cacheKey];
    }

    private integratedCellMetricValuesFromCase(caseRow: any, metricKey: string) {
        return (caseRow?.cellMetrics || [])
            .map((cell: any) => this.numberValue(cell?.[metricKey]))
            .filter((value: any) => value !== null) as number[];
    }

    private roundMetricValue(value: any) {
        const numeric = this.numberValue(value);
        if (numeric === null) return null;
        return Math.round(Number(numeric) * 1000) / 1000;
    }

    private integratedI3Groups(datasets: any[], caseIds: string[]) {
        const groups: any[] = [];
        datasets.forEach((dataset: any) => {
            const groupMap: any = {};
            (dataset.data.samples || []).forEach((sample: any) => {
                const assay = this.assayType(sample);
                if (!assay) return;
                const groupKey = `${dataset.setId}:${this.integratedGroupKey(sample)}`;
                if (!groupMap[groupKey]) {
                    groupMap[groupKey] = {
                        setId: dataset.setId,
                        setLabel: dataset.set?.label || dataset.data.analysisSet?.label || dataset.setId,
                        groupKey,
                        groupLabel: this.integratedGroupLabel(sample),
                        subjectId: sample.subjectId || sample.sampleNumber || groupKey,
                        diseaseName: sample.diseaseName || "",
                        diagnosis: sample.diagnosis || "",
                        diagnosisLabel: sample.diagnosisLabel || "-",
                        buckets: this.integratedEmptyBuckets(caseIds),
                    };
                }
                caseIds.forEach((caseId: string) => {
                    const caseRow = this.integratedCaseRow(sample, caseId);
                    const values = this.integratedMetricValuesFromCase(caseRow, "CSP");
                    if (!values.length) return;
                    values.forEach((value: number) => groupMap[groupKey].buckets[caseId][assay].push(value));
                });
            });

            Object.values(groupMap).forEach((group: any) => {
                const caseResultMap: any = {};
                caseIds.forEach((caseId: string) => {
                    const bucket = group.buckets[caseId] || { asc: [], vehicle: [] };
                    const ascCsp = this.average(bucket.asc);
                    const vehicleCsp = this.average(bucket.vehicle);
                    const i3 = ascCsp !== null && vehicleCsp ? (Number(ascCsp) / Number(vehicleCsp)) * 100 : null;
                    caseResultMap[caseId] = { caseId, ascCsp, vehicleCsp, i3 };
                });
                groups.push({ ...group, caseResultMap });
            });
        });
        return groups.filter((group: any) => group.caseResultMap.original?.i3 !== null);
    }

    private integratedAxisDomains(sampleRows: any[], i3Groups: any[], caseIds: string[]) {
        const i3Values = i3Groups.flatMap((group: any) => {
            return caseIds.map((caseId: string) => group.caseResultMap[caseId]?.i3);
        });
        const cspValues = this.integratedMetricValuesFromRows(sampleRows, "CSP");
        const metrics: any = {};
        INTEGRATED_REPORT_METRICS.forEach((metric: any) => {
            metrics[metric.key] = this.integratedFixedDomain(
                this.integratedMetricValuesFromRows(sampleRows, metric.key),
                metric.key,
            );
        });
        return {
            i3: this.integratedFixedDomain(i3Values, "I3"),
            csp: this.integratedFixedDomain(cspValues, "CSP"),
            metrics,
        };
    }

    private integratedFixedDomain(values: any[], metricKey: string = "") {
        const fixedMax = FIXED_METRIC_AXIS_MAX[metricKey] || 0;
        let rawMax = Math.max(0, fixedMax);
        (values || []).forEach((value: any) => {
            const numeric = this.numberValue(value);
            if (numeric === null) return;
            rawMax = Math.max(rawMax, Math.abs(Number(numeric)));
        });
        return { min: 0, max: this.niceAxisCeiling(rawMax) };
    }

    private niceAxisCeiling(value: any) {
        const numeric = Math.abs(Number(value) || 0);
        if (!numeric) return 1;
        const magnitude = Math.pow(10, Math.floor(Math.log10(numeric)));
        const normalized = numeric / magnitude;
        const steps = [1, 1.5, 2, 2.5, 3, 4, 5, 7.5, 10];
        const step = steps.find((candidate: number) => normalized <= candidate) || 10;
        return step * magnitude;
    }

    private integratedEmptyBuckets(caseIds: string[]) {
        const buckets: any = {};
        caseIds.forEach((caseId: string) => {
            buckets[caseId] = { asc: [], vehicle: [] };
        });
        return buckets;
    }

    private integratedGroupKey(sample: any) {
        if (sample.sampleNumber && sample.replicate) return `${sample.sampleNumber}:${sample.replicate}`;
        return sample.subjectId || sample.group || sample.id;
    }

    private integratedGroupLabel(sample: any) {
        if (sample.sampleNumber && sample.replicate) return `${sample.sampleNumber} ${sample.replicate}`;
        return sample.subjectLabel || sample.subjectId || sample.name || sample.id;
    }

    private assayType(sample: any) {
        const source = `${sample.assay || ""} ${sample.group || ""} ${sample.name || ""} ${sample.id || ""}`.toLowerCase();
        if (source.indexOf("vehicle") >= 0) return "vehicle";
        if (source.indexOf("asc") >= 0) return "asc";
        return "";
    }

    private integratedI3BoxPlots(caseIds: string[], groups: any[], axisDomain: any) {
        const plots: any = {};
        caseIds.forEach((caseId: string) => {
            const rows = [
                {
                    key: "normal",
                    label: "정상군 I3",
                    color: "#047857",
                    values: groups.filter((group: any) => group.diagnosis === "normal").map((group: any) => group.caseResultMap[caseId]?.i3),
                },
                {
                    key: "patient",
                    label: "환자군 I3",
                    color: "#e11d48",
                    values: groups.filter((group: any) => group.diagnosis === "patient").map((group: any) => group.caseResultMap[caseId]?.i3),
                },
            ];
            plots[caseId] = this.buildIntegratedBoxPlot(rows, "I3", axisDomain);
        });
        return plots;
    }

    private integratedTreatmentBoxPlots(caseIds: string[], sampleRows: any[], axisDomain: any) {
        const plots: any = {};
        caseIds.forEach((caseId: string) => {
            const rows = INTEGRATED_COHORTS.map((cohort: any) => ({
                key: cohort.key,
                label: cohort.label,
                color: cohort.color,
                values: this.integratedMetricValuesFromRows(
                    sampleRows.filter((row: any) => row.caseId === caseId && row.cohortKey === cohort.key),
                    "CSP",
                ),
            }));
            plots[caseId] = this.buildIntegratedBoxPlot(rows, "CSP", axisDomain);
        });
        return plots;
    }

    private buildIntegratedBoxPlot(rows: any[], valueLabel: string, fixedDomain: any = null) {
        const chart = this.emptyIntegratedBoxPlot(valueLabel);
        const stats = rows
            .map((row: any) => ({ ...row, stats: this.boxStats(row.values) }))
            .filter((row: any) => !!row.stats);
        const values = stats.flatMap((row: any) => [row.stats.min, row.stats.q1, row.stats.median, row.stats.q3, row.stats.max]);
        const domain = fixedDomain || this.paddedNumericDomain(values, true);
        chart.domain = domain;
        chart.ticks = this.buildTicks(domain.min, domain.max, INTEGRATED_AXIS_TICK_COUNT).map((value: number) => ({
            value,
            y: this.scaleSvgY(value, domain.min, domain.max, chart),
        }));
        const plotWidth = chart.width - chart.left - chart.right;
        const step = stats.length ? plotWidth / stats.length : plotWidth;
        const boxWidth = Math.max(20, Math.min(78, step * 0.38));
        chart.boxes = stats.map((row: any, index: number) => {
            const center = chart.left + step * index + step / 2;
            const q1Y = this.scaleSvgY(row.stats.q1, domain.min, domain.max, chart);
            const q3Y = this.scaleSvgY(row.stats.q3, domain.min, domain.max, chart);
            return {
                ...row,
                x: center,
                boxX: center - boxWidth / 2,
                boxWidth,
                minY: this.scaleSvgY(row.stats.min, domain.min, domain.max, chart),
                q1Y,
                medianY: this.scaleSvgY(row.stats.median, domain.min, domain.max, chart),
                q3Y,
                maxY: this.scaleSvgY(row.stats.max, domain.min, domain.max, chart),
                boxY: Math.min(q1Y, q3Y),
                boxHeight: Math.max(4, Math.abs(q1Y - q3Y)),
                title: `${row.label}: n=${row.stats.count}, median ${this.format(row.stats.median, 1)}`,
            };
        });
        chart.labels = chart.boxes.map((box: any) => ({ x: box.x, text: box.label }));
        return chart;
    }

    private emptyIntegratedBoxPlot(valueLabel: string = "") {
        return {
            width: 720,
            height: 320,
            left: 68,
            right: 30,
            top: 28,
            bottom: 70,
            valueLabel,
            domain: null as any,
            ticks: [],
            labels: [],
            boxes: [],
        };
    }

    private boxStats(values: any[]) {
        const sorted = values
            .map((value: any) => this.numberValue(value))
            .filter((value: any) => value !== null)
            .sort((a: number, b: number) => a - b);
        if (!sorted.length) return null;
        return {
            count: sorted.length,
            min: sorted[0],
            q1: this.quantile(sorted, 0.25),
            median: this.quantile(sorted, 0.5),
            q3: this.quantile(sorted, 0.75),
            max: sorted[sorted.length - 1],
        };
    }

    private quantile(sortedValues: number[], quantile: number) {
        if (!sortedValues.length) return null;
        const position = (sortedValues.length - 1) * quantile;
        const base = Math.floor(position);
        const rest = position - base;
        const next = sortedValues[base + 1];
        if (next === undefined) return sortedValues[base];
        return sortedValues[base] + rest * (next - sortedValues[base]);
    }

    private integratedMetricLineChartsFor(sampleRows: any[], caseOptions: any[], metricDomains: any = {}) {
        return INTEGRATED_REPORT_METRICS.map((metric: any) => {
            const chart = {
                width: 760,
                height: 300,
                left: 58,
                right: 28,
                top: 24,
                bottom: 74,
                metric,
                domain: null as any,
                labels: [] as any[],
                ticks: [] as any[],
                series: [] as any[],
            };
            const seriesRows = INTEGRATED_COHORTS.map((cohort: any) => {
                const points = caseOptions.map((caseMeta: any) => {
                    const rows = sampleRows.filter((row: any) => row.caseId === caseMeta.id && row.cohortKey === cohort.key);
                    return {
                        caseId: caseMeta.id,
                        label: caseMeta.shortLabel,
                        value: this.integratedAverageMetricFromRows(rows, metric.key),
                    };
                });
                return { ...cohort, points };
            });
            const values = seriesRows.flatMap((series: any) => series.points.map((point: any) => point.value));
            const domain = metricDomains[metric.key] || this.paddedNumericDomain(values, true);
            chart.domain = domain;
            chart.ticks = this.buildTicks(domain.min, domain.max, INTEGRATED_AXIS_TICK_COUNT).map((value: number) => ({
                value,
                y: this.scaleSvgY(value, domain.min, domain.max, chart),
            }));
            const plotWidth = chart.width - chart.left - chart.right;
            const step = caseOptions.length > 1 ? plotWidth / (caseOptions.length - 1) : plotWidth;
            chart.labels = caseOptions.map((caseMeta: any, index: number) => ({
                x: caseOptions.length > 1 ? chart.left + step * index : chart.left + plotWidth / 2,
                text: caseMeta.shortLabel,
            }));
            chart.series = seriesRows.map((series: any) => {
                const points = series.points
                    .map((point: any, index: number) => {
                        if (point.value === null || point.value === undefined) return null;
                        const x = caseOptions.length > 1 ? chart.left + step * index : chart.left + plotWidth / 2;
                        const y = this.scaleSvgY(Number(point.value), domain.min, domain.max, chart);
                        return { ...point, x, y };
                    })
                    .filter((point: any) => !!point);
                return {
                    ...series,
                    points,
                    pointsAttr: points.map((point: any) => `${point.x},${point.y}`).join(" "),
                };
            });
            return chart;
        });
    }

    private integratedComparisonRows(sampleRows: any[]) {
        const rows: any[] = [];
        INTEGRATED_COMPARISONS.forEach((comparison: any) => {
            INTEGRATED_COHORTS.forEach((cohort: any) => {
                INTEGRATED_REPORT_METRICS.forEach((metric: any) => {
                    const baseRows = sampleRows.filter((row: any) => {
                        return comparison.setIds.indexOf(row.setId) >= 0 && row.caseId === comparison.baseCaseId && row.cohortKey === cohort.key;
                    });
                    const targetRows = sampleRows.filter((row: any) => {
                        return comparison.setIds.indexOf(row.setId) >= 0 && row.caseId === comparison.targetCaseId && row.cohortKey === cohort.key;
                    });
                    const baseValues = this.integratedMetricValuesFromRows(baseRows, metric.key);
                    const targetValues = this.integratedMetricValuesFromRows(targetRows, metric.key);
                    const baseAverage = this.average(baseValues);
                    const targetAverage = this.average(targetValues);
                    if (baseAverage === null || targetAverage === null) return;
                    const delta = Number(targetAverage) - Number(baseAverage);
                    rows.push({
                        comparisonId: comparison.id,
                        comparisonTitle: comparison.title,
                        datasetLabel: comparison.setIds.join(" + "),
                        baseCase: this.integratedCaseMeta(comparison.baseCaseId),
                        targetCase: this.integratedCaseMeta(comparison.targetCaseId),
                        cohort,
                        metric,
                        count: targetValues.filter((value: any) => this.numberValue(value) !== null).length,
                        baseAverage,
                        targetAverage,
                        targetStd: this.standardDeviation(targetValues),
                        delta,
                        deltaPercent: baseAverage ? (delta / Number(baseAverage)) * 100 : null,
                    });
                });
            });
        });
        return rows;
    }

    private integratedComparisonCards(comparisonRows: any[]) {
        return INTEGRATED_COMPARISONS.map((comparison: any) => {
            const rows = comparisonRows.filter((row: any) => row.comparisonId === comparison.id);
            const metricDeltas = INTEGRATED_REPORT_METRICS.map((metric: any) => {
                const metricRows = rows.filter((row: any) => row.metric.key === metric.key);
                return {
                    ...metric,
                    deltaPercent: this.average(metricRows.map((row: any) => row.deltaPercent)),
                    targetAverage: this.average(metricRows.map((row: any) => row.targetAverage)),
                };
            });
            return {
                ...comparison,
                baseCase: this.integratedCaseMeta(comparison.baseCaseId),
                targetCase: this.integratedCaseMeta(comparison.targetCaseId),
                metricDeltas,
                rowCount: rows.length,
            };
        });
    }

    private integratedRepresentativeImages(datasets: any[]) {
        const rows: any[] = [];
        datasets.forEach((dataset: any) => {
            ["normal", "patient"].forEach((diagnosis: string) => {
                const sample = (dataset.data.samples || []).find((row: any) => {
                    return row.diagnosis === diagnosis && this.assayType(row) === "asc";
                });
                if (!sample) return;
                const targetCaseId = dataset.data.analysisSet?.backgroundAvailable === false ? "blur_mmd_filter" : "background_blur_mmd_filter";
                const original = this.integratedCaseRow(sample, "original");
                const target = this.integratedCaseRow(sample, targetCaseId);
                rows.push({
                    setId: dataset.setId,
                    diagnosis,
                    title: `${dataset.setId} ${sample.diagnosisLabel || diagnosis}`,
                    sampleName: sample.name,
                    original,
                    target,
                    targetLabel: this.integratedCaseMeta(targetCaseId).shortLabel,
                });
            });
        });
        return rows;
    }

    private standardDeviation(values: any[]) {
        const numericValues = values
            .map((value: any) => this.numberValue(value))
            .filter((value: any) => value !== null) as number[];
        if (numericValues.length < 2) return 0;
        const average = numericValues.reduce((sum: number, value: number) => sum + value, 0) / numericValues.length;
        const variance = numericValues.reduce((sum: number, value: number) => sum + Math.pow(value - average, 2), 0) / (numericValues.length - 1);
        return Math.sqrt(variance);
    }

    private numericExtent(values: any[], includeZero: boolean = false) {
        let min: number | null = null;
        let max: number | null = null;
        const include = (value: any) => {
            const numeric = this.numberValue(value);
            if (numeric === null) return;
            const numberValue = Number(numeric);
            min = min === null ? numberValue : Math.min(min, numberValue);
            max = max === null ? numberValue : Math.max(max, numberValue);
        };
        (values || []).forEach((value: any) => include(value));
        if (includeZero) include(0);
        if (min === null || max === null) return null;
        return { min, max };
    }

    private paddedNumericDomain(values: any[], includeZero: boolean = false) {
        const extent = this.numericExtent(values, includeZero);
        if (!extent) return { min: 0, max: 1 };
        let min = extent.min;
        let max = extent.max;
        if (min === max) {
            const pad = Math.max(Math.abs(max) * 0.1, 1);
            min -= pad;
            max += pad;
        } else {
            const pad = (max - min) * 0.14;
            min -= pad;
            max += pad;
        }
        return { min, max };
    }

    public get samples() {
        return this.analysis?.samples || [];
    }

    public get cases() {
        return this.analysis?.cases || [];
    }

    public get caseSummary() {
        return this.analysis?.caseSummary || [];
    }

    public get blurMethodAnalysis() {
        return this.analysis?.blurMethodAnalysis || null;
    }

    public get blurMethodSummary() {
        return this.blurMethodAnalysis?.summary || [];
    }

    public get selectedSample() {
        return this.samples.find((sample: any) => sample.id === this.selectedSampleId) || this.samples[0] || null;
    }

    public get imageCarouselSamples() {
        return [...this.samples].sort((a: any, b: any) => {
            const aLabel = String(a?.filename || a?.name || "");
            const bLabel = String(b?.filename || b?.name || "");
            return aLabel.localeCompare(bLabel, undefined, { numeric: true, sensitivity: "base" });
        });
    }

    public get selectedSampleIndex() {
        const index = this.imageCarouselSamples.findIndex((sample: any) => sample.id === this.selectedSampleId);
        return index >= 0 ? index : 0;
    }

    public get originalCase() {
        return this.sampleCase(this.selectedSample, "original");
    }

    public get backgroundCase() {
        return this.sampleCase(this.selectedSample, "background");
    }

    public get blurCase() {
        return this.sampleCase(this.selectedSample, "blur");
    }

    public get mmdCase() {
        return this.sampleCase(this.selectedSample, "mmd_filter");
    }

    public get finalCase() {
        return this.sampleCase(this.selectedSample, "background_blur_mmd_filter");
    }

    public get selectedBackgroundVisual() {
        return this.selectedSample?.visuals?.backgroundHeatmap || null;
    }

    public get currentBlurVisual() {
        return this.selectedSample?.visuals?.blurVisual || null;
    }

    public get blurEvidenceImages() {
        return this.noiseReferenceImages;
    }

    public get pipelineTableCases() {
        return ["original", "background", "blur", "mmd_filter", "background_blur_mmd_filter"]
            .map((caseId: string) => this.sampleCase(this.selectedSample, caseId))
            .filter((row: any) => !!row);
    }

    public get selectedPipelineStep() {
        return this.pipelineSteps.find((step: any) => step.caseId === this.selectedPipelineCaseId) || this.pipelineSteps[0] || null;
    }

    public get selectedPipelineShortLabel() {
        return this.caseSummaryById(this.selectedPipelineCaseId)?.shortLabel || this.selectedPipelineStep?.title || "-";
    }

    public get selectedPipelineCase() {
        return this.sampleCase(this.selectedSample, this.selectedPipelineStep?.caseId) || this.backgroundCase;
    }

    public get pipelineMetricChart() {
        const targetCase = this.selectedPipelineCase;
        return this.metricRows.map((row: any) => {
            const originalValue = this.comparisonValue(row, this.originalCase);
            const targetValue = this.comparisonValue(row, targetCase);
            const maxValue = Math.max(Math.abs(Number(originalValue) || 0), Math.abs(Number(targetValue) || 0));
            const delta = this.deltaAgainstOriginal(row, targetCase);
            const deltaPercent = this.deltaPercentAgainstOriginal(row, targetCase);
            return {
                ...row,
                originalValue,
                targetValue,
                delta,
                deltaPercent,
                originalWidth: this.barPercent(originalValue, maxValue),
                targetWidth: this.barPercent(targetValue, maxValue),
            };
        });
    }

    public get pipelineParameterColumns() {
        return this.metricColumnGroups(this.selectedPipelineCase, this.selectedPipelineShortLabel);
    }

    public get backgroundParameterColumns() {
        return this.metricColumnGroups(this.backgroundCase, "BG");
    }

    public get mmdParameterColumns() {
        return this.metricColumnGroups(this.mmdCase, "MMD");
    }

    public get noiseParameterColumns() {
        const baseline = this.selectedSampleBlurAnalysis?.baseline || this.originalCase;
        return this.metricRows.map((row: any) => {
            const originalValue = this.comparisonValue(row, baseline);
            const blurValue = this.comparisonValue(row, this.selectedBoxMethod);
            const axisMax = this.metricAxisMax(row, [originalValue, blurValue]);
            return {
                ...row,
                axisMax,
                axisTicks: this.metricAxisTicks(axisMax, row.digits),
                columns: [
                    {
                        key: "original",
                        label: "원본",
                        value: originalValue,
                        height: this.valueColumnPercent(originalValue, axisMax),
                    },
                    {
                        key: "box-blur",
                        label: "기존 blur",
                        value: blurValue,
                        height: this.valueColumnPercent(blurValue, axisMax),
                    },
                ],
            };
        });
    }

    public get blurComparisonRows() {
        const baseline = this.selectedSampleBlurAnalysis?.baseline || this.originalCase;
        const blurResult = this.selectedBoxMethod || this.blurCase;
        const rows = [
            { key: "finalCount", label: "최종 cell", digits: 0, source: "case" },
            ...this.metricRows,
        ];

        return rows.map((row: any) => {
            const originalValue = this.comparisonValue(row, baseline);
            const blurValue = this.comparisonValue(row, blurResult);
            const hasValues = originalValue !== null && originalValue !== undefined && blurValue !== null && blurValue !== undefined;
            const delta = hasValues ? Number(blurValue) - Number(originalValue) : null;
            const deltaPercent = hasValues && originalValue ? (Number(delta) / Number(originalValue)) * 100 : null;
            return {
                ...row,
                originalValue,
                blurValue,
                delta,
                deltaPercent,
            };
        });
    }

    public get mmdComparisonRows() {
        return this.comparisonRows.map((row: any) => {
            const originalValue = this.comparisonValue(row, this.originalCase);
            const mmdValue = this.comparisonValue(row, this.mmdCase);
            const hasValues = originalValue !== null && originalValue !== undefined && mmdValue !== null && mmdValue !== undefined;
            const delta = hasValues ? Number(mmdValue) - Number(originalValue) : null;
            const deltaPercent = hasValues && originalValue ? (Number(delta) / Number(originalValue)) * 100 : null;
            return {
                ...row,
                originalValue,
                mmdValue,
                delta,
                deltaPercent,
            };
        });
    }

    private metricColumnGroups(targetCase: any, targetLabel: string) {
        return this.metricRows.map((row: any) => {
            const originalValue = this.comparisonValue(row, this.originalCase);
            const targetValue = this.comparisonValue(row, targetCase);
            const axisMax = this.metricAxisMax(row, [originalValue, targetValue]);
            const hasValues = originalValue !== null && originalValue !== undefined && targetValue !== null && targetValue !== undefined;
            const delta = hasValues ? Number(targetValue) - Number(originalValue) : null;
            const deltaPercent = hasValues && originalValue ? (Number(delta) / Number(originalValue)) * 100 : null;
            return {
                ...row,
                originalValue,
                targetValue,
                delta,
                deltaPercent,
                axisMax,
                axisTicks: this.metricAxisTicks(axisMax, row.digits),
                columns: [
                    {
                        key: "original",
                        label: "원본",
                        value: originalValue,
                        height: this.valueColumnPercent(originalValue, axisMax),
                    },
                    {
                        key: "target",
                        label: targetLabel,
                        value: targetValue,
                        height: this.valueColumnPercent(targetValue, axisMax),
                    },
                ],
            };
        });
    }

    public get selectedPipelineDeltaRows() {
        const targetCase = this.selectedPipelineCase;
        return this.pipelineComparisonRows.map((row: any) => {
            const originalValue = this.comparisonValue(row, this.originalCase);
            const targetValue = this.comparisonValue(row, targetCase);
            const hasValues = originalValue !== null && originalValue !== undefined && targetValue !== null && targetValue !== undefined;
            const delta = hasValues ? Number(targetValue) - Number(originalValue) : null;
            const deltaPercent = hasValues && originalValue ? (Number(delta) / Number(originalValue)) * 100 : null;
            return {
                ...row,
                originalValue,
                targetValue,
                delta,
                deltaPercent,
            };
        });
    }

    public get backgroundRows() {
        return this.samples
            .map((sample: any) => {
                const original = this.sampleCase(sample, "original");
                const background = this.sampleCase(sample, "background");
                const visual = sample.visuals?.backgroundHeatmap || null;
                if (!original || !background || !visual) return null;
                return {
                    sample,
                    original,
                    background,
                    visual,
                    countDelta: background.finalCount - original.finalCount,
                    mmdSdDelta: this.metricValue(background, "MMD_SD") - this.metricValue(original, "MMD_SD"),
                    cspDelta: this.metricValue(background, "CSP") - this.metricValue(original, "CSP"),
                };
            })
            .filter((row: any) => !!row);
    }

    public get backgroundAverage() {
        const rows = this.backgroundRows;
        const countDeltas = rows.map((row: any) => row.countDelta);
        const mmdSdDeltas = rows.map((row: any) => row.mmdSdDelta).filter((value: any) => !Number.isNaN(Number(value)));
        const cspDeltas = rows.map((row: any) => row.cspDelta).filter((value: any) => !Number.isNaN(Number(value)));
        return {
            sampleCount: rows.length,
            avgCvReduction: this.average(rows.map((row: any) => row.visual.cvReductionPercent)),
            avgRangeReduction: this.average(rows.map((row: any) => row.visual.rangeReductionPercent)),
            totalCountDelta: countDeltas.reduce((sum: number, value: number) => sum + value, 0),
            avgMmdSdDelta: this.average(mmdSdDeltas),
            avgCspDelta: this.average(cspDeltas),
        };
    }

    public get selectedBackgroundMetric() {
        return this.metricRows.find((row: any) => row.key === this.selectedBackgroundMetricKey) || this.metricRows[0] || null;
    }

    public get backgroundMetricChart() {
        const metric = this.selectedBackgroundMetric;
        if (!metric) return [];
        const domain = this.backgroundMetricDomain;
        return this.backgroundRows.map((row: any) => {
            const originalValue = this.comparisonValue(metric, row.original);
            const backgroundValue = this.comparisonValue(metric, row.background);
            const delta = Number(backgroundValue) - Number(originalValue);
            const deltaPercent = originalValue ? (delta / Number(originalValue)) * 100 : null;
            return {
                sample: row.sample,
                metric,
                originalValue,
                backgroundValue,
                delta,
                deltaPercent,
                originalPosition: this.valuePositionPercent(originalValue, domain),
                backgroundPosition: this.valuePositionPercent(backgroundValue, domain),
            };
        });
    }

    public get backgroundMetricDomain() {
        const metric = this.selectedBackgroundMetric;
        if (!metric) return { min: 0, max: 1, ticks: [0, 0.5, 1] };
        const values = this.backgroundRows
            .flatMap((row: any) => [
                this.comparisonValue(metric, row.original),
                this.comparisonValue(metric, row.background),
            ])
            .map((value: any) => Number(value))
            .filter((value: number) => Number.isFinite(value));

        if (!values.length) return { min: 0, max: 1, ticks: [0, 0.5, 1] };
        const domain = this.paddedDomain(values);
        if (domain.min > 0) domain.min = Math.max(0, domain.min);
        if (domain.max <= domain.min) domain.max = domain.min + 1;
        return {
            min: domain.min,
            max: domain.max,
            ticks: [domain.min, (domain.min + domain.max) / 2, domain.max],
        };
    }

    public get selectedSampleBlurAnalysis() {
        if (!this.selectedSample || !this.blurMethodAnalysis) return null;
        return this.blurMethodAnalysis.samples?.find((sample: any) => sample.sampleId === this.selectedSample.id) || null;
    }

    public get boxMethodSummary() {
        return this.methodSummary("box_2x2");
    }

    public get selectedBoxMethod() {
        return this.selectedMethodRow("box_2x2");
    }

    public get filterSummaryRows() {
        return this.caseSummary.filter((row: any) => row.caseId?.indexOf("mmd_filter") >= 0);
    }

    public get metricStatRows() {
        const rows = this.metricRows.map((row: any) => {
            const baseValue = this.comparisonValue(row, this.originalCase);
            const filteredValue = this.comparisonValue(row, this.mmdCase);
            const delta = this.deltaAgainstOriginal(row, this.mmdCase);
            const percent = this.deltaPercentAgainstOriginal(row, this.mmdCase);
            return {
                ...row,
                baseValue,
                filteredValue,
                delta,
                percent,
                absPercent: percent === null || percent === undefined ? 0 : Math.abs(Number(percent)),
                directionLabel: delta > 0 ? "증가" : delta < 0 ? "감소" : "유지",
            };
        });
        const maxAbsPercent = rows.reduce((max: number, row: any) => Math.max(max, row.absPercent), 0);
        return rows.map((row: any) => ({
            ...row,
            barWidth: maxAbsPercent > 0 && row.absPercent > 0 ? Math.max(6, (row.absPercent / maxAbsPercent) * 100) : 0,
        }));
    }

    public get metricOverview() {
        const rows = this.metricStatRows;
        const validRows = rows.filter((row: any) => row.percent !== null && row.percent !== undefined);
        let maxRow: any = null;
        validRows.forEach((row: any) => {
            if (!maxRow || row.absPercent > maxRow.absPercent) maxRow = row;
        });
        const averageAbsPercent = validRows.length
            ? validRows.reduce((sum: number, row: any) => sum + row.absPercent, 0) / validRows.length
            : null;

        return {
            total: rows.length,
            increased: rows.filter((row: any) => row.delta > 0).length,
            decreased: rows.filter((row: any) => row.delta < 0).length,
            stable: rows.filter((row: any) => row.delta === 0).length,
            averageAbsPercent,
            maxLabel: maxRow?.label || "-",
            maxPercent: maxRow?.percent ?? null,
        };
    }

    public get threshold() {
        return this.analysis?.parameters?.mmdSdThreshold || 0;
    }

    public get correlationCards() {
        return [
            {
                title: "MMD_STD vs WSM_STD",
                note: "cell 단위 내부 texture 변동성",
                yLabel: "WSM_STD",
                data: this.analytics.mmdWsm,
                fill: "#059669",
                stroke: "#047857",
            },
            {
                title: "MMD_STD vs CSP",
                note: "cell 단위 CSP 반응성",
                yLabel: "CSP",
                data: this.analytics.mmdCsp,
                fill: "#2563eb",
                stroke: "#1d4ed8",
            },
        ];
    }

    public get conclusionSummaryCards() {
        const fullPipeline = this.sampleCase(this.selectedSample, "background_blur_mmd_filter");
        const bgMmd = this.sampleCase(this.selectedSample, "background_mmd_filter");
        const selected = this.selectedConclusionCase;
        const original = this.originalCase;
        const selectedLabel = this.selectedConclusionShortLabel;
        return [
            {
                tone: "slate",
                caseId: "background_blur_mmd_filter",
                title: fullPipeline?.shortLabel || "BG+Blur+MMD",
                value: `cell ${this.format(fullPipeline?.finalCount)}`,
                meta: `원본 대비 ${this.signed(fullPipeline?.deltaCount, 0)} cell`,
                description: `${this.sampleButtonLabel(this.selectedSample)} 이미지에 background subtraction, blur, MMD_STD filtering을 모두 적용한 조합입니다.`,
            },
            {
                tone: "blue",
                caseId: "background_mmd_filter",
                title: bgMmd?.shortLabel || "BG+MMD",
                value: `cell ${this.format(bgMmd?.finalCount)}`,
                meta: `원본 대비 ${this.signed(bgMmd?.deltaCount, 0)} cell`,
                description: `${this.sampleButtonLabel(this.selectedSample)} 이미지에 blur 없이 background subtraction과 MMD_STD filtering만 적용한 조합입니다.`,
            },
            {
                tone: "emerald",
                title: "선택 이미지",
                value: this.sampleButtonLabel(this.selectedSample),
                meta: `${this.selectedSample?.name || "-"} · 원본 cell ${this.format(original?.finalCount)}`,
                description: "상단 A-D 버튼으로 선택한 이미지의 결과 그래프와 비교 표를 확인합니다.",
            },
            {
                tone: "rose",
                title: selectedLabel,
                value: `cell ${this.format(selected?.finalCount)}`,
                meta: `원본 대비 ${this.signed(selected?.deltaCount, 0)} cell`,
                description: `${this.sampleButtonLabel(this.selectedSample)} 이미지에서 선택한 조합의 최종 분석 결과입니다.`,
            },
        ];
    }

    public get selectedConclusionCaseSummary() {
        return this.caseSummaryById(this.selectedConclusionCaseId);
    }

    public get selectedConclusionShortLabel() {
        return this.selectedConclusionCaseSummary?.shortLabel || this.selectedConclusionCaseId || "-";
    }

    public get selectedConclusionCase() {
        return this.sampleCase(this.selectedSample, this.selectedConclusionCaseId) || this.finalCase;
    }

    public get conclusionParameterColumns() {
        return this.metricColumnGroups(this.selectedConclusionCase, this.selectedConclusionShortLabel);
    }

    public get conclusionComparisonRows() {
        return this.metricRows.map((row: any) => {
            const baseValue = this.comparisonValue(row, this.originalCase);
            const targetValue = this.comparisonValue(row, this.selectedConclusionCase);
            const hasValues = baseValue !== null && baseValue !== undefined && targetValue !== null && targetValue !== undefined;
            const delta = hasValues ? Number(targetValue) - Number(baseValue) : null;
            const deltaPercent = hasValues && baseValue ? (Number(delta) / Number(baseValue)) * 100 : null;
            return {
                ...row,
                baseValue,
                targetValue,
                delta,
                deltaPercent,
            };
        });
    }

    private metricColumnGroupsForCases(caseIds: string[], labels: string[]) {
        return this.metricRows.map((row: any) => {
            const rawColumns = caseIds.map((caseId: string, index: number) => ({
                key: index === 0 ? "original" : "target",
                label: labels[index] || caseId,
                value: this.comparisonValueForCaseId(row, caseId),
            }));
            const axisMax = this.metricAxisMax(row, rawColumns.map((column: any) => column.value));
            const baseValue = rawColumns[0]?.value;
            const targetValue = rawColumns[1]?.value;
            const hasValues = baseValue !== null && baseValue !== undefined && targetValue !== null && targetValue !== undefined;
            const delta = hasValues ? Number(targetValue) - Number(baseValue) : null;
            const deltaPercent = hasValues && baseValue ? (Number(delta) / Number(baseValue)) * 100 : null;
            return {
                ...row,
                baseValue,
                targetValue,
                delta,
                deltaPercent,
                axisMax,
                axisTicks: this.metricAxisTicks(axisMax, row.digits),
                columns: rawColumns.map((column: any) => ({
                    ...column,
                    height: this.valueColumnPercent(column.value, axisMax),
                })),
            };
        });
    }

    private comparisonValueForCaseId(row: any, caseId: string) {
        if (!row) return null;
        if (row.source === "summary") {
            const summary = this.caseSummaryById(caseId);
            return summary?.[row.key] ?? null;
        }
        if (row.source === "metrics") {
            return this.average(this.samples.map((sample: any) => this.metricValue(this.sampleCase(sample, caseId), row.key)));
        }
        if (row.source === "derived" && row.key === "I3") {
            return this.i3ForCase(caseId);
        }
        return null;
    }

    public async selectSample(sampleId: string) {
        if (!sampleId || this.selectedSampleId === sampleId) return;
        const token = ++this.sampleSwitchToken;
        const preload = this.preloadSampleImages(sampleId).catch(() => false);
        this.selectedSampleId = sampleId;
        await this.service.render();
        preload.then(async () => {
            if (token === this.sampleSwitchToken) await this.service.render();
        });
        this.preloadNeighborSamples(sampleId);
    }

    public async previousSample() {
        await this.moveSample(-1);
    }

    public async nextSample() {
        await this.moveSample(1);
    }

    private async moveSample(offset: number) {
        const samples = this.imageCarouselSamples;
        if (!samples.length) return;
        const nextIndex = (this.selectedSampleIndex + offset + samples.length) % samples.length;
        await this.selectSample(samples[nextIndex].id);
    }

    public async selectPipelineCase(caseId: string) {
        this.selectedPipelineCaseId = caseId;
        await this.service.render();
    }

    public async selectConclusionCase(caseId: string) {
        if (!caseId || this.selectedConclusionCaseId === caseId) return;
        this.selectedConclusionCaseId = caseId;
        await this.service.render();
    }

    public async selectBackgroundMetric(metricKey: string) {
        this.selectedBackgroundMetricKey = metricKey;
        await this.service.render();
    }

    public async printReport() {
        await this.downloadReportPdf();
    }

    public async downloadReportPdf() {
        if (this.loading || !this.analysis || this.isPdfDownloadPreparing) return;

        this.isPdfDownloadPreparing = true;
        this.pdfPreviousTitle = document.title;
        this.blurActiveElement();
        this.commitActiveDrawingStroke();

        if (this.isPresentationMode || this.hasPresentationFullscreen()) {
            await this.exitPresentationMode();
        }

        try {
            await this.prepareReportPdfDownload();
            this.beginReportPdfPrint();
        } catch (error) {
            await this.finishReportPdfDownload();
        }
    }

    private async prepareReportPdfDownload() {
        this.ensureSlideIndexInRange();
        await this.service.render();
        await this.waitForNextPaint();

        if (this.isIntegratedReport) {
            await this.preloadIntegratedSlideImages(this.printableSlideIndexes());
        }

        await this.waitForRenderedReportImages();
        await this.waitForNextPaint();
        document.title = this.reportPdfFileName();
    }

    private beginReportPdfPrint() {
        const cleanup = () => {
            this.finishReportPdfDownload().catch(() => { });
        };
        this.pdfAfterPrintHandler = cleanup;
        window.addEventListener("afterprint", cleanup, { once: true });
        this.pdfCleanupTimer = window.setTimeout(cleanup, 60000);
        window.print();
    }

    private async finishReportPdfDownload() {
        const needsRender = this.isPdfDownloadPreparing;
        this.clearReportPdfDownloadState();
        if (needsRender) await this.service.render();
    }

    private clearReportPdfDownloadState() {
        if (this.pdfCleanupTimer !== null) {
            window.clearTimeout(this.pdfCleanupTimer);
            this.pdfCleanupTimer = null;
        }
        if (this.pdfAfterPrintHandler) {
            window.removeEventListener("afterprint", this.pdfAfterPrintHandler);
            this.pdfAfterPrintHandler = null;
        }
        if (this.pdfPreviousTitle) {
            document.title = this.pdfPreviousTitle;
            this.pdfPreviousTitle = "";
        }
        this.isPdfDownloadPreparing = false;
    }

    private printableSlideIndexes() {
        return this.currentSlides.map((_: any, index: number) => index);
    }

    private isPrintableSlideIndex(index: number) {
        return Number.isFinite(index) && index >= 0 && index < this.slideCount;
    }

    private reportPdfFileName() {
        const setId = (this.analysisSetId || "report").replace(/[^0-9A-Za-z._-]+/g, "_");
        return `cellytics-nk-${setId}-report`;
    }

    private waitForNextPaint() {
        return new Promise<void>((resolve) => {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => resolve());
            });
        });
    }

    private async waitForRenderedReportImages() {
        const images = Array.from(document.querySelectorAll(".presentation-stage img")) as HTMLImageElement[];
        const urls = images
            .map((image: HTMLImageElement) => image.currentSrc || image.src)
            .filter((url: string) => !!url && url !== EMPTY_IMAGE);
        await this.preloadUrls(urls);
    }

    public async enterPresentationMode() {
        if (this.isPresentationMode) return;
        this.isPresentationMode = true;
        this.applyPresentationShell();
        this.blurActiveElement();

        const element = this.presentationElement();
        if (element) {
            try {
                await this.requestFullscreen(element);
            } catch (error) {
                // Fullscreen may be blocked in embedded contexts; fixed overlay mode remains active.
            }
        }

        await this.service.render();
        this.queueDrawingCanvasRedraw();
    }

    public async exitPresentationMode() {
        if (!this.isPresentationMode && !this.hasPresentationFullscreen()) return;

        this.isPresentationMode = false;
        this.isDrawingMode = false;
        this.cancelActiveDrawingStroke();
        this.clearPresentationShell();

        if (this.hasPresentationFullscreen()) {
            try {
                await this.exitFullscreen();
            } catch (error) { }
        }

        await this.service.render();
    }

    private presentationElement() {
        return document.querySelector(".presentation-root") as HTMLElement | null;
    }

    private fullscreenElement() {
        const doc: any = document;
        return doc.fullscreenElement
            || doc.webkitFullscreenElement
            || doc.mozFullScreenElement
            || doc.msFullscreenElement
            || null;
    }

    private hasPresentationFullscreen() {
        const element = this.presentationElement();
        const fullscreen = this.fullscreenElement();
        return !!element && !!fullscreen && (fullscreen === element || element.contains(fullscreen));
    }

    private requestFullscreen(element: HTMLElement) {
        const target: any = element;
        const request = target.requestFullscreen
            || target.webkitRequestFullscreen
            || target.mozRequestFullScreen
            || target.msRequestFullscreen;
        if (!request) return Promise.resolve();
        return Promise.resolve(request.call(target));
    }

    private exitFullscreen() {
        const doc: any = document;
        const exit = doc.exitFullscreen
            || doc.webkitExitFullscreen
            || doc.mozCancelFullScreen
            || doc.msExitFullscreen;
        if (!exit || !this.fullscreenElement()) return Promise.resolve();
        return Promise.resolve(exit.call(doc));
    }

    private applyPresentationShell() {
        document.documentElement.classList.add(PRESENTATION_BODY_CLASS);
        document.body.classList.add(PRESENTATION_BODY_CLASS);

        if (this.previousBodyOverflow === null) this.previousBodyOverflow = document.body.style.overflow;
        if (this.previousDocumentOverflow === null) this.previousDocumentOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
    }

    private clearPresentationShell() {
        document.documentElement.classList.remove(PRESENTATION_BODY_CLASS);
        document.body.classList.remove(PRESENTATION_BODY_CLASS);

        if (this.previousBodyOverflow !== null) {
            document.body.style.overflow = this.previousBodyOverflow;
            this.previousBodyOverflow = null;
        }
        if (this.previousDocumentOverflow !== null) {
            document.documentElement.style.overflow = this.previousDocumentOverflow;
            this.previousDocumentOverflow = null;
        }
    }

    private blurActiveElement() {
        const activeElement = document.activeElement as HTMLElement | null;
        if (activeElement?.blur) activeElement.blur();
    }

    public async toggleDrawingMode(event?: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.isPresentationMode) return;

        this.isDrawingMode = !this.isDrawingMode;
        if (!this.isDrawingMode) this.cancelActiveDrawingStroke();

        await this.service.render();
        this.queueDrawingCanvasRedraw();
    }

    public handleDrawingMouseDown(event: MouseEvent) {
        if (!this.canUseDrawingCanvas()) return;

        event.preventDefault();
        event.stopPropagation();

        if (event.button === 2) {
            this.undoCurrentSlideDrawing();
            return;
        }
        if (event.button !== 0) return;

        const point = this.drawingPoint(event);
        if (!point) return;

        this.activeDrawingStroke = [point];
        this.redrawCurrentSlideDrawing(this.activeDrawingStroke);
    }

    public handleDrawingContextMenu(event: MouseEvent) {
        if (!this.canUseDrawingCanvas()) return;
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener("document:mousemove", ["$event"])
    public handleDrawingMouseMove(event: MouseEvent) {
        if (!this.activeDrawingStroke) return;
        if ((event.buttons & 1) !== 1) {
            this.commitActiveDrawingStroke();
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.addDrawingPoint(event);
    }

    @HostListener("document:mouseup", ["$event"])
    public handleDrawingMouseUp(event: MouseEvent) {
        if (!this.activeDrawingStroke || event.button !== 0) return;

        event.preventDefault();
        event.stopPropagation();
        this.addDrawingPoint(event);
        this.commitActiveDrawingStroke();
    }

    @HostListener("window:resize")
    public handleDrawingResize() {
        if (this.isPresentationMode) this.queueDrawingCanvasRedraw();
    }

    private canUseDrawingCanvas() {
        return this.isPresentationMode && this.isDrawingMode;
    }

    private drawingCanvas() {
        return document.querySelector(".presentation-drawing-canvas") as HTMLCanvasElement | null;
    }

    private currentSlideDrawings() {
        if (!this.slideDrawings[this.currentSlideIndex]) this.slideDrawings[this.currentSlideIndex] = [];
        return this.slideDrawings[this.currentSlideIndex];
    }

    private drawingPoint(event: MouseEvent): DrawingPoint | null {
        const canvas = this.drawingCanvas();
        if (!canvas) return null;

        const rect = canvas.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return null;

        return {
            x: this.clampRatio((event.clientX - rect.left) / rect.width),
            y: this.clampRatio((event.clientY - rect.top) / rect.height),
        };
    }

    private addDrawingPoint(event: MouseEvent) {
        if (!this.activeDrawingStroke) return;

        const point = this.drawingPoint(event);
        if (!point) return;

        const last = this.activeDrawingStroke[this.activeDrawingStroke.length - 1];
        if (last && Math.abs(last.x - point.x) < 0.001 && Math.abs(last.y - point.y) < 0.001) return;

        this.activeDrawingStroke.push(point);
        this.redrawCurrentSlideDrawing(this.activeDrawingStroke);
    }

    private commitActiveDrawingStroke() {
        const stroke = this.activeDrawingStroke;
        if (!stroke) return;

        if (stroke.length > 0) this.currentSlideDrawings().push(stroke);
        this.activeDrawingStroke = null;
        this.redrawCurrentSlideDrawing();
    }

    private cancelActiveDrawingStroke() {
        this.activeDrawingStroke = null;
        this.redrawCurrentSlideDrawing();
    }

    private undoCurrentSlideDrawing() {
        this.cancelActiveDrawingStroke();
        const drawings = this.currentSlideDrawings();
        if (!drawings.length) return;

        drawings.pop();
        this.redrawCurrentSlideDrawing();
    }

    private queueDrawingCanvasRedraw() {
        if (this.drawingRedrawFrame !== null) window.cancelAnimationFrame(this.drawingRedrawFrame);
        this.drawingRedrawFrame = window.requestAnimationFrame(() => {
            this.drawingRedrawFrame = null;
            this.redrawCurrentSlideDrawing();
        });
    }

    private cancelDrawingRedraw() {
        if (this.drawingRedrawFrame === null) return;
        window.cancelAnimationFrame(this.drawingRedrawFrame);
        this.drawingRedrawFrame = null;
    }

    private clearDrawingCanvas() {
        const canvas = this.drawingCanvas();
        if (!canvas) return;

        const context = canvas.getContext("2d");
        if (!context) return;

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);
    }

    private redrawCurrentSlideDrawing(activeStroke: DrawingStroke | null = null) {
        const canvas = this.drawingCanvas();
        if (!canvas) return;

        const context = this.prepareDrawingCanvas(canvas);
        if (!context) return;

        for (const stroke of this.currentSlideDrawings()) {
            this.drawStroke(context, stroke, canvas);
        }
        if (activeStroke) this.drawStroke(context, activeStroke, canvas);
    }

    private prepareDrawingCanvas(canvas: HTMLCanvasElement) {
        const rect = canvas.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return null;

        const pixelRatio = window.devicePixelRatio || 1;
        const width = Math.max(1, Math.round(rect.width * pixelRatio));
        const height = Math.max(1, Math.round(rect.height * pixelRatio));

        if (canvas.width !== width) canvas.width = width;
        if (canvas.height !== height) canvas.height = height;

        const context = canvas.getContext("2d");
        if (!context) return null;

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.lineCap = "round";
        context.lineJoin = "round";
        context.lineWidth = DRAWING_LINE_WIDTH;
        context.strokeStyle = DRAWING_COLOR;
        context.fillStyle = DRAWING_COLOR;

        return context;
    }

    private drawStroke(context: CanvasRenderingContext2D, stroke: DrawingStroke, canvas: HTMLCanvasElement) {
        if (!stroke.length) return;

        const rect = canvas.getBoundingClientRect();
        const first = stroke[0];
        const firstX = first.x * rect.width;
        const firstY = first.y * rect.height;

        if (stroke.length === 1) {
            context.beginPath();
            context.arc(firstX, firstY, DRAWING_LINE_WIDTH / 2, 0, Math.PI * 2);
            context.fill();
            return;
        }

        context.beginPath();
        context.moveTo(firstX, firstY);
        for (let index = 1; index < stroke.length; index++) {
            const point = stroke[index];
            context.lineTo(point.x * rect.width, point.y * rect.height);
        }
        context.stroke();
    }

    private clampRatio(value: number) {
        return Math.max(0, Math.min(1, value));
    }

    public get slideCount() {
        return this.currentSlides.length;
    }

    public get currentSlides() {
        return this.isIntegratedReport ? this.integratedSlides : this.slides;
    }

    public get reportPdfDownload() {
        return REPORT_PDF_DOWNLOADS[this.analysisSetId] || null;
    }

    private ensureSlideIndexInRange() {
        const maxIndex = Math.max(0, this.slideCount - 1);
        if (this.currentSlideIndex > maxIndex) this.currentSlideIndex = maxIndex;
        if (this.currentSlideIndex < 0) this.currentSlideIndex = 0;
    }

    public slideNumber(index: number) {
        return String(index + 1);
    }

    public async goToSlide(index: number) {
        const nextIndex = Math.max(0, Math.min(index, this.slideCount - 1));
        if (nextIndex === this.currentSlideIndex) return;
        this.commitActiveDrawingStroke();
        this.currentSlideIndex = nextIndex;
        this.clearDrawingCanvas();
        await this.service.render();
        this.queueDrawingCanvasRedraw();
        if (this.isIntegratedReport) {
            this.scheduleIntegratedReportWarmup();
            return;
        }
        this.preloadSampleImages(this.selectedSampleId).catch(() => { });
        this.preloadNeighborSamples(this.selectedSampleId);
    }

    public async previousSlide() {
        await this.goToSlide(this.currentSlideIndex - 1);
    }

    public async nextSlide() {
        await this.goToSlide(this.currentSlideIndex + 1);
    }

    public slideClass(index: number) {
        return index === this.currentSlideIndex ? "is-active" : "is-hidden";
    }

    public shouldRenderSlide(index: number) {
        return this.isPdfDownloadPreparing ? this.isPrintableSlideIndex(index) : index === this.currentSlideIndex;
    }

    public slideNavClass(index: number) {
        return index === this.currentSlideIndex ? "slide-tab is-active" : "slide-tab";
    }

    @HostListener("document:fullscreenchange")
    public async handleFullscreenChange() {
        if (!this.fullscreenElement() && this.isPresentationMode) {
            this.isPresentationMode = false;
            this.isDrawingMode = false;
            this.cancelActiveDrawingStroke();
            this.clearPresentationShell();
            await this.service.render();
        }
    }

    @HostListener("document:keydown", ["$event"])
    public async handleDeckKey(event: KeyboardEvent) {
        if (event.key === "Escape") {
            if (this.isPresentationMode || this.hasPresentationFullscreen()) {
                event.preventDefault();
                event.stopPropagation();
                await this.exitPresentationMode();
                return;
            }
            if (this.imageModal) {
                event.preventDefault();
                await this.closeImageModal();
                return;
            }
        }

        if (this.imageModal || this.loading || !this.analysis) return;
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (this.isTypingTarget(event)) return;

        if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            event.preventDefault();
            event.stopPropagation();
            await this.previousSlide();
            return;
        }
        if (event.key === "ArrowRight" || event.key === "ArrowDown" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            event.stopPropagation();
            await this.nextSlide();
        }
    }

    private isTypingTarget(event: KeyboardEvent) {
        const target = event.target as HTMLElement | null;
        if (!target) return false;
        const tagName = target.tagName?.toLowerCase();
        return target.isContentEditable || tagName === "input" || tagName === "textarea" || tagName === "select";
    }

    public sampleCase(sample: any, caseId: string) {
        return sample?.cases?.find((row: any) => row.caseId === caseId) || null;
    }

    public caseSummaryById(caseId: string) {
        return this.caseSummary.find((row: any) => row.caseId === caseId) || null;
    }

    public methodSummary(methodId: string) {
        return this.blurMethodSummary.find((row: any) => row.methodId === methodId) || null;
    }

    public selectedMethodRow(methodId: string) {
        return this.selectedSampleBlurAnalysis?.methods?.find((row: any) => row.methodId === methodId) || null;
    }

    public samplePillClass(sampleId: string) {
        if (this.selectedSampleId === sampleId) {
            return "rounded-md border border-gray-900 bg-gray-900 px-3 py-1.5 text-[12px] font-semibold text-white";
        }
        return "rounded-md border border-gray-200 bg-white px-3 py-1.5 text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public stepPanelClass(tone: string) {
        const classes: any = {
            emerald: "border-emerald-200 bg-emerald-50/70",
            blue: "border-blue-200 bg-blue-50/70",
            rose: "border-rose-200 bg-rose-50/70",
            slate: "border-gray-300 bg-gray-50",
        };
        return `rounded-lg border p-4 ${classes[tone] || classes.slate}`;
    }

    public stepBadgeClass(tone: string) {
        const classes: any = {
            emerald: "bg-emerald-600 text-white",
            blue: "bg-blue-600 text-white",
            rose: "bg-rose-600 text-white",
            slate: "bg-gray-900 text-white",
        };
        return `inline-flex h-7 min-w-7 items-center justify-center rounded-md px-2 text-[11px] font-bold ${classes[tone] || classes.slate}`;
    }

    public pipelineStepClass(step: any) {
        const active = step?.caseId === this.selectedPipelineCaseId ? " is-active" : "";
        return `pipeline-card ${step?.tone || "slate"}${active}`;
    }

    public conclusionCardClass(card: any) {
        const active = card?.caseId && card.caseId === this.selectedConclusionCaseId ? " is-active" : "";
        const actionable = card?.caseId ? " is-actionable" : "";
        return `conclusion-summary-card ${card?.tone || "slate"}${active}${actionable}`;
    }

    public pipelineLegendClass(step: any) {
        const active = step?.caseId === this.selectedPipelineCaseId ? " is-active" : "";
        return `legend-pill ${step?.tone || "slate"}${active}`;
    }

    public pipelineStageColumnClass(stage: any) {
        const direction = stage?.delta > 0 ? "positive" : stage?.delta < 0 ? "negative" : "neutral";
        const selected = stage?.selected ? " is-selected" : "";
        return `stage-column ${stage?.tone || "slate"} ${direction}${selected}`;
    }

    public pipelineStageColumnStyle(stage: any) {
        const height = Number(stage?.columnHeight);
        return { height: `${Number.isFinite(height) && height > 0 ? Math.max(2, height * 0.46) : 0}%` };
    }

    public pipelineStageColumnTitle(group: any, stage: any) {
        const digits = group?.digits || 2;
        return `${stage?.title || "-"} ${group?.label || ""}: ${this.format(group?.originalValue, digits)} to ${this.format(stage?.targetValue, digits)} (${this.signed(stage?.deltaPercent, 1)}%)`;
    }

    public metricColumnBarClass(column: any) {
        return `metric-column-bar ${column?.key || "target"}`;
    }

    public metricColumnBarStyle(column: any) {
        const height = Number(column?.height);
        return { height: `${Number.isFinite(height) ? height : 0}%` };
    }

    public metricColumnTitle(group: any, column: any) {
        return `${group?.label || ""} ${column?.label || ""}: ${this.format(column?.value, group?.digits || 2)}`;
    }

    public metricSelectorClass(metricKey: string) {
        return metricKey === this.selectedBackgroundMetricKey ? "metric-chip is-active" : "metric-chip";
    }

    public sampleCarouselDotClass(sampleId: string) {
        return sampleId === this.selectedSampleId ? "sample-carousel-dot is-active" : "sample-carousel-dot";
    }

    public sampleResultButtonClass(sampleId: string) {
        return sampleId === this.selectedSampleId ? "sample-result-button is-active" : "sample-result-button";
    }

    public sampleButtonLabel(sample: any = this.selectedSample) {
        const filename = String(sample?.filename || "").trim();
        const baseName = filename.replace(/\.[^.]+$/, "");
        return baseName || sample?.name || "-";
    }

    public deltaClass(value: any) {
        if (value > 0) return "text-red-600";
        if (value < 0) return "text-blue-700";
        return "text-gray-500";
    }

    public signed(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        const numberValue = Number(value);
        const prefix = numberValue > 0 ? "+" : "";
        return `${prefix}${this.format(numberValue, digits)}`;
    }

    public format(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        return Number(value).toLocaleString("ko-KR", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    public formatPValue(value: any) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return "-";
        if (numeric === 0) return "< 1e-323";
        if (numeric < 0.001) return numeric.toExponential(2);
        return this.format(numeric, 3);
    }

    public percentOfOriginal(caseId: string) {
        const original = this.caseSummaryById("original");
        const target = this.caseSummaryById(caseId);
        if (!original?.totalCount || !target) return null;
        return (target.deltaCount / original.totalCount) * 100;
    }

    public summaryDelta(caseId: string, key: string) {
        const original = this.caseSummaryById("original");
        const target = this.caseSummaryById(caseId);
        if (!original || !target || original[key] === undefined || target[key] === undefined) return null;
        return Number(target[key]) - Number(original[key]);
    }

    public metricValue(row: any, key: string) {
        const value = row?.metrics?.[key];
        if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
        return Number(value);
    }

    public comparisonValue(row: any, caseRow: any) {
        if (!row || !caseRow) return null;
        if (row.source === "metrics") return this.metricValue(caseRow, row.key);
        if (row.source === "derived" && row.key === "I3") return this.i3Value(caseRow);
        return caseRow[row.key];
    }

    public i3Value(row: any) {
        if (!row) return null;
        if (row.methodId) return this.i3ForMethod(row.methodId);
        return this.i3ForCase(row.caseId || "original");
    }

    private i3ForCase(caseId: string) {
        const asc = this.groupAverageCspForCase(caseId, "ASC");
        const vehicle = this.groupAverageCspForCase(caseId, "vehicle");
        return this.ratioPercent(asc, vehicle);
    }

    private i3ForMethod(methodId: string) {
        const asc = this.groupAverageCspForMethod(methodId, "ASC");
        const vehicle = this.groupAverageCspForMethod(methodId, "vehicle");
        return this.ratioPercent(asc, vehicle);
    }

    private groupAverageCspForCase(caseId: string, group: string) {
        return this.average(this.samples
            .filter((sample: any) => this.sampleGroup(sample) === group)
            .map((sample: any) => this.metricValue(this.sampleCase(sample, caseId), "CSP")));
    }

    private groupAverageCspForMethod(methodId: string, group: string) {
        const values = (this.blurMethodAnalysis?.samples || [])
            .filter((sampleAnalysis: any) => this.sampleGroupById(sampleAnalysis.sampleId) === group)
            .map((sampleAnalysis: any) => {
                const method = sampleAnalysis.methods?.find((row: any) => row.methodId === methodId);
                return this.metricValue(method, "CSP");
            });
        return this.average(values);
    }

    private sampleGroup(sample: any) {
        return sample?.group || "";
    }

    private sampleGroupById(sampleId: string) {
        return this.sampleGroup(this.samples.find((sample: any) => sample.id === sampleId));
    }

    private ratioPercent(numerator: any, denominator: any) {
        if (!numerator || !denominator) return null;
        return (Number(numerator) / Number(denominator)) * 100;
    }

    public deltaAgainstOriginal(row: any, targetCase: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const targetValue = this.comparisonValue(row, targetCase);
        if (baseValue === null || baseValue === undefined || targetValue === null || targetValue === undefined) return null;
        return Number(targetValue) - Number(baseValue);
    }

    public deltaPercentAgainstOriginal(row: any, targetCase: any) {
        const baseValue = this.comparisonValue(row, this.originalCase);
        const delta = this.deltaAgainstOriginal(row, targetCase);
        if (!baseValue || delta === null || delta === undefined) return null;
        return (delta / Number(baseValue)) * 100;
    }

    public methodMetricDelta(method: any, key: string) {
        return method?.metricDeltas?.[key] || {};
    }

    public summaryMetric(method: any, key: string) {
        return method?.metricSummary?.[key] || {};
    }

    public metricBarClass(row: any) {
        if (row?.delta > 0) return "bg-red-500";
        if (row?.delta < 0) return "bg-blue-500";
        return "bg-gray-300";
    }

    public metricBarStyle(row: any) {
        return { width: `${row?.barWidth || 0}%` };
    }

    public barWidthStyle(value: any) {
        const numeric = Number(value);
        return { width: `${Number.isFinite(numeric) ? numeric : 0}%` };
    }

    public dumbbellPointStyle(position: any) {
        const numeric = Number(position);
        return { left: `${Number.isFinite(numeric) ? numeric : 50}%` };
    }

    public dumbbellLinkStyle(row: any) {
        const original = Number(row?.originalPosition);
        const background = Number(row?.backgroundPosition);
        if (!Number.isFinite(original) || !Number.isFinite(background)) return { left: "50%", width: "0%" };
        const left = Math.min(original, background);
        const width = Math.abs(background - original);
        return { left: `${left}%`, width: `${width}%` };
    }

    public dumbbellLinkClass(row: any) {
        if (row?.delta > 0) return "dumbbell-link positive";
        if (row?.delta < 0) return "dumbbell-link negative";
        return "dumbbell-link neutral";
    }

    public dumbbellPointTitle(row: any, type: string) {
        const isOriginal = type === "original";
        const value = isOriginal ? row?.originalValue : row?.backgroundValue;
        const label = isOriginal ? "원본" : "BG";
        return `${row?.sample?.name || "-"} ${label} ${row?.metric?.label || ""}: ${this.format(value, row?.metric?.digits || 2)}`;
    }

    public isTrustedNative(sample: any = this.selectedSample) {
        return sample?.nativeVerified === true;
    }

    public caseImage(row: any) {
        const fullImage = row?.fullImage || (row?.caseId === "original" ? this.selectedSample?.originalFullImage : "");
        const downloadImage = row?.downloadImage || (row?.caseId === "original" ? this.selectedSample?.originalDownloadImage : "");
        return this.imageRef(
            row?.preview,
            fullImage,
            downloadImage,
            fullImage ? (row?.nativeWidth || this.selectedSample?.width) : null,
            fullImage ? (row?.nativeHeight || this.selectedSample?.height) : null,
            this.isTrustedNative(),
        );
    }

    public heatmapImage(key: string) {
        const fullKey = `${key}Full`;
        const downloadKey = `${key}Download`;
        return this.imageRef(
            this.selectedBackgroundVisual?.[key],
            this.selectedBackgroundVisual?.[fullKey],
            this.selectedBackgroundVisual?.[downloadKey],
            this.selectedBackgroundVisual?.nativeWidth || this.selectedSample?.width,
            this.selectedBackgroundVisual?.nativeHeight || this.selectedSample?.height,
            this.isTrustedNative(),
        );
    }

    public visualImage(visual: any, key: string) {
        const fullKey = `${key}Full`;
        const downloadKey = `${key}Download`;
        return this.imageRef(
            visual?.[key],
            visual?.[fullKey],
            visual?.[downloadKey],
            visual?.[fullKey] && visual?.[fullKey] !== visual?.[key] ? visual?.nativeWidth : null,
            visual?.[fullKey] && visual?.[fullKey] !== visual?.[key] ? visual?.nativeHeight : null,
            this.isTrustedNative(),
        );
    }

    public noiseReferenceImageRef(image: any) {
        return this.imageRef(
            image?.src,
            image?.src,
            image?.src,
            image?.width,
            image?.height,
            true,
        );
    }

    public evidenceImageRef(image: any) {
        return this.imageRef(
            image?.src,
            image?.full || image?.src,
            image?.download || image?.full || image?.src,
            image?.width,
            image?.height,
            image?.trustedNative === true,
        );
    }

    public displayImage(input: any) {
        const image = this.resolveImageInput(input);
        return image.preview || image.fullImage || EMPTY_IMAGE;
    }

    public handleImageError(event: Event) {
        const target = event?.target as HTMLImageElement;
        if (!target || target.dataset.fallbackApplied === "true") return;
        target.dataset.fallbackApplied = "true";
        target.classList.add("image-load-failed");
        target.src = EMPTY_IMAGE;
    }

    private scheduleIntegratedReportWarmup() {
        if (!this.isIntegratedReport || !this.integratedReport) return;
        const run = () => {
            this.preloadIntegratedSlideImages([
                this.currentSlideIndex,
                this.currentSlideIndex + 1,
                this.currentSlideIndex + 2,
            ]).catch(() => { });
        };
        if ((window as any).requestIdleCallback) {
            (window as any).requestIdleCallback(run, { timeout: 900 });
            return;
        }
        window.setTimeout(run, 0);
    }

    private preloadIntegratedSampleSelectionImages(setId: string) {
        const slideIndex = setId === "260612" ? 2 : setId === "260619" ? 3 : -1;
        if (slideIndex < 0) return;
        this.preloadIntegratedSlideImages([slideIndex]).catch(() => { });
    }

    private async preloadIntegratedSlideImages(slideIndexes: number[]) {
        const urls = new Set<string>();
        Array.from(new Set(slideIndexes))
            .filter((index: number) => index >= 0 && index < this.slideCount)
            .forEach((index: number) => {
                this.integratedSlideImageUrls(index).forEach((url: string) => this.addImageUrl(urls, url));
            });
        await this.preloadUrls(Array.from(urls));
    }

    private integratedSlideImageUrls(slideIndex: number) {
        const urls = new Set<string>();
        const addResolvedImage = (input: any) => {
            const image = this.resolveImageInput(input);
            this.addImageUrl(urls, image.preview || image.fullImage);
        };

        if (slideIndex === 1) {
            [
                ...this.backgroundEvidenceImages,
                ...this.blurEvidenceImages,
                ...this.mmdEvidenceImages,
            ].forEach((image: any) => {
                this.addImageUrl(urls, image?.src);
                this.addImageUrl(urls, image?.full);
            });
        }
        if (slideIndex === 2) {
            this.integratedSampleResultView("260612")?.imageCards?.forEach((card: any) => addResolvedImage(card.image));
        }
        if (slideIndex === 3) {
            this.integratedSampleResultView("260619")?.imageCards?.forEach((card: any) => addResolvedImage(card.image));
        }

        return Array.from(urls);
    }

    private imageRef(preview: string, fullImage: string = "", downloadImage: string = "", nativeWidth: any = null, nativeHeight: any = null, trustedNative: boolean = false) {
        const resolvedPreview = preview || fullImage || downloadImage || "";
        const useNative = trustedNative && !!fullImage && !!nativeWidth && !!nativeHeight;
        const resolvedFull = useNative ? fullImage : resolvedPreview;
        const resolvedDownload = useNative ? (downloadImage || resolvedFull) : "";
        return {
            preview: resolvedPreview,
            fullImage: resolvedFull,
            downloadImage: resolvedDownload,
            nativeWidth: useNative ? nativeWidth : null,
            nativeHeight: useNative ? nativeHeight : null,
            nativeTrusted: useNative,
        };
    }

    private async preloadInitialImages() {
        await this.preloadSampleImages(this.selectedSampleId);
        this.preloadAllDisplayImages();
        this.preloadNeighborSamples(this.selectedSampleId);
    }

    private preloadAllDisplayImages() {
        const urls = new Set<string>();
        this.samples.forEach((sample: any) => {
            this.sampleDisplayImages(sample).forEach((url: string) => urls.add(url));
        });
        [
            ...this.backgroundEvidenceImages,
            ...this.blurEvidenceImages,
            ...this.mmdEvidenceImages,
        ].forEach((image: any) => {
            this.addImageUrl(urls, image?.src);
            this.addImageUrl(urls, image?.full);
        });
        this.preloadUrls(Array.from(urls)).catch(() => { });
    }

    private preloadNeighborSamples(sampleId: string) {
        const samples = this.imageCarouselSamples;
        const index = samples.findIndex((sample: any) => sample.id === sampleId);
        if (index < 0 || samples.length <= 1) return;
        const next = samples[(index + 1) % samples.length];
        const previous = samples[(index - 1 + samples.length) % samples.length];
        this.preloadUrls([
            ...this.sampleDisplayImages(next),
            ...this.sampleDisplayImages(previous),
        ]).catch(() => { });
    }

    private async preloadSampleImages(sampleId: string) {
        const sample = this.samples.find((row: any) => row.id === sampleId) || this.selectedSample;
        await this.preloadUrls(this.sampleDisplayImages(sample));
    }

    private sampleDisplayImages(sample: any) {
        const urls = new Set<string>();
        (sample?.cases || []).forEach((row: any) => {
            this.addImageUrl(urls, row?.preview || row?.fullImage);
        });
        this.addImageUrl(urls, sample?.source || sample?.originalImage || sample?.originalFullImage);

        const heatmap = sample?.visuals?.backgroundHeatmap;
        this.addImageUrl(urls, heatmap?.original || heatmap?.originalFull);
        this.addImageUrl(urls, heatmap?.corrected || heatmap?.correctedFull);

        const blurVisual = sample?.visuals?.blurVisual;
        this.addImageUrl(urls, blurVisual?.original || blurVisual?.originalFull);
        this.addImageUrl(urls, blurVisual?.blurred || blurVisual?.blurredFull);

        return Array.from(urls);
    }

    private addImageUrl(urls: Set<string>, url: any) {
        const normalized = this.normalizeImageUrl(url);
        if (normalized) urls.add(normalized);
    }

    private normalizeImageUrl(url: any) {
        return typeof url === "string" ? url.trim() : "";
    }

    private async preloadUrls(urls: any[]) {
        const uniqueUrls = Array.from(new Set(urls.map((url: any) => this.normalizeImageUrl(url)).filter((url: string) => !!url)));
        await Promise.all(uniqueUrls.map((url: string) => this.preloadImage(url)));
    }

    private preloadImage(url: string) {
        const normalized = this.normalizeImageUrl(url);
        if (!normalized || normalized.startsWith("data:")) return Promise.resolve(true);
        if (this.imageLoadPromises[normalized]) return this.imageLoadPromises[normalized];

        const promise = new Promise<boolean>((resolve) => {
            const image = new Image();
            let finished = false;
            const finish = (loaded: boolean) => {
                if (finished) return;
                finished = true;
                window.clearTimeout(timer);
                resolve(loaded);
            };
            const timer = window.setTimeout(() => finish(false), IMAGE_PRELOAD_TIMEOUT_MS);
            image.onload = () => finish(true);
            image.onerror = () => finish(false);
            image.decoding = "async";
            image.src = normalized;
            if (image.complete) finish(image.naturalWidth > 0);
        }).then((loaded: boolean) => {
            if (!loaded) delete this.imageLoadPromises[normalized];
            return loaded;
        });

        this.imageLoadPromises[normalized] = promise;
        return promise;
    }

    private resolveImageInput(input: any) {
        if (typeof input === "string") return this.imageRef(input);
        return this.imageRef(
            input?.preview || input?.src || input?.source || "",
            input?.fullImage || input?.full || input?.sourceFull || "",
            input?.downloadImage || input?.download || input?.sourceDownload || "",
            input?.nativeWidth || null,
            input?.nativeHeight || null,
            input?.nativeTrusted === true,
        );
    }

    private modalFileName(title: string, src: string) {
        const ext = (src || "").split("?")[0].split(".").pop() || "jpg";
        const safeTitle = (title || "cellytics-image")
            .replace(/[^0-9A-Za-z._-]+/g, "_")
            .replace(/^_+|_+$/g, "") || "cellytics-image";
        return safeTitle.endsWith(`.${ext}`) ? safeTitle : `${safeTitle}.${ext}`;
    }

    public async openImageModal(input: any, title: string, caption: string = "") {
        const image = this.resolveImageInput(input);
        const src = image.fullImage || image.preview;
        this.imageModal = {
            src,
            preview: image.preview,
            download: image.downloadImage || "",
            filename: this.modalFileName(title, src),
            nativeWidth: image.nativeWidth,
            nativeHeight: image.nativeHeight,
            usingNative: !!image.nativeWidth && !!image.nativeHeight,
            title,
            caption,
        };
        await this.service.render();
    }

    public async closeImageModal() {
        this.imageModal = null;
        await this.service.render();
    }

    private buildAnalytics() {
        return {
            mmdWsm: this.buildSingleCellCorrelation("MMD_SD", "WSM_SD", "MMD_STD", "WSM_STD"),
            mmdCsp: this.buildSingleCellCorrelation("MMD_SD", "CSP", "MMD_STD", "CSP"),
        };
    }

    private emptyCorrelation(xLabel: string, yLabel: string) {
        return {
            coefficient: null,
            pValue: null,
            rSquared: null,
            n: 0,
            strength: "데이터 부족",
            significance: "데이터 부족",
            interpretation: "상관관계를 해석할 수 있는 cell 데이터가 부족합니다.",
            points: [],
            xTicks: [],
            yTicks: [],
            trendLine: null,
            svg: { width: 640, height: 340, left: 72, right: 24, top: 28, bottom: 58 },
            xLabel,
            yLabel,
        };
    }

    private buildSingleCellCorrelation(xMetric: string, yMetric: string, xLabel: string, yLabel: string) {
        const rawPoints = this.samples
            .flatMap((sample: any) => {
                const original = this.sampleCase(sample, "original");
                return (original?.cellMetrics || []).map((cell: any) => ({
                    sampleName: sample.name,
                    cellIndex: cell.index,
                    xValue: this.numberValue(cell[xMetric]),
                    yValue: this.numberValue(cell[yMetric]),
                    csp: this.numberValue(cell.CSP),
                }));
            })
            .filter((row: any) => row.xValue !== null && row.yValue !== null)
            .map((row: any) => ({ ...row, xValue: Number(row.xValue), yValue: Number(row.yValue) }));

        if (!rawPoints.length) return this.emptyCorrelation(xLabel, yLabel);

        const svg = { width: 640, height: 340, left: 72, right: 24, top: 28, bottom: 58 };
        const xValues: number[] = rawPoints.map((row: any) => row.xValue);
        const yValues: number[] = rawPoints.map((row: any) => row.yValue);
        const xDomain = this.paddedDomain(xValues);
        const yDomain = this.paddedDomain(yValues);
        const xMin = xDomain.min;
        const xMax = xDomain.max;
        const yMin = yDomain.min;
        const yMax = yDomain.max;
        const coefficient = this.pearson(rawPoints.map((row: any) => [row.xValue, row.yValue]));
        const pValue = this.pearsonPValue(coefficient, rawPoints.length);
        const rSquared = coefficient === null ? null : coefficient * coefficient;
        const regression = this.linearRegression(rawPoints.map((row: any) => [row.xValue, row.yValue]));
        const xTicks = this.buildTicks(xMin, xMax, 5).map((value: number) => ({ value, x: this.scaleSvgX(value, xMin, xMax, svg) }));
        const yTicks = this.buildTicks(yMin, yMax, 5).map((value: number) => ({ value, y: this.scaleSvgY(value, yMin, yMax, svg) }));
        const points = rawPoints.map((row: any) => ({
            ...row,
            x: this.scaleSvgX(row.xValue, xMin, xMax, svg),
            y: this.scaleSvgY(row.yValue, yMin, yMax, svg),
            label: `${row.sampleName} #${row.cellIndex} / ${xLabel} ${this.format(row.xValue, 2)} / ${yLabel} ${this.format(row.yValue, 2)} / CSP ${this.format(row.csp, 2)}`,
        }));
        const trendLine = regression ? {
            x1: this.scaleSvgX(xMin, xMin, xMax, svg),
            y1: this.scaleSvgY(regression.slope * xMin + regression.intercept, yMin, yMax, svg),
            x2: this.scaleSvgX(xMax, xMin, xMax, svg),
            y2: this.scaleSvgY(regression.slope * xMax + regression.intercept, yMin, yMax, svg),
        } : null;

        return {
            coefficient,
            pValue,
            rSquared,
            n: rawPoints.length,
            strength: this.describeCorrelation(coefficient),
            significance: this.describePValue(pValue),
            interpretation: this.describeCorrelationInterpretation(yLabel, coefficient, pValue, rSquared),
            points,
            xTicks,
            yTicks,
            trendLine,
            svg,
            xLabel,
            yLabel,
        };
    }

    private numberValue(value: any) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
        return Number(value);
    }

    private average(values: any[]) {
        const validValues = values.filter((value: any) => value !== null && value !== undefined && !Number.isNaN(Number(value))).map((value: any) => Number(value));
        if (!validValues.length) return null;
        return validValues.reduce((sum: number, value: number) => sum + value, 0) / validValues.length;
    }

    private barPercent(value: any, maxValue: number) {
        const numeric = Math.abs(Number(value) || 0);
        if (!numeric || !maxValue) return 0;
        return Math.max(4, Math.min(100, (numeric / maxValue) * 100));
    }

    private niceAxisMax(value: any) {
        const numeric = Math.abs(Number(value) || 0);
        if (!numeric) return 1;
        const magnitude = Math.pow(10, Math.floor(Math.log10(numeric)));
        const normalized = numeric / magnitude;
        const nice = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
        return nice * magnitude;
    }

    private metricAxisMax(row: any, values: any[] = []) {
        const fixedMax = FIXED_METRIC_AXIS_MAX[row?.key];
        if (Number.isFinite(fixedMax) && fixedMax > 0) return fixedMax;
        const maxValue = values.reduce((max: number, value: any) => Math.max(max, Math.abs(Number(value) || 0)), 0);
        return this.niceAxisMax(maxValue);
    }

    private metricAxisTicks(axisMax: number, metricDigits: number = 2) {
        const digits = this.axisTickDigits(axisMax, metricDigits);
        return [axisMax, axisMax / 2, 0].map((value: number) => ({ value, digits }));
    }

    private axisTickDigits(axisMax: number, metricDigits: number) {
        if (axisMax >= 100) return 0;
        if (axisMax >= 10) return 1;
        return Math.min(2, Math.max(1, metricDigits || 0));
    }

    private valueColumnPercent(value: any, axisMax: number) {
        const numeric = Math.max(0, Number(value) || 0);
        if (!numeric || !axisMax) return 0;
        return Math.max(4, Math.min(100, (numeric / axisMax) * 100));
    }

    private valuePositionPercent(value: any, domain: any) {
        const numeric = Number(value);
        const min = Number(domain?.min);
        const max = Number(domain?.max);
        if (!Number.isFinite(numeric) || !Number.isFinite(min) || !Number.isFinite(max) || min === max) return 50;
        return Math.max(0, Math.min(100, ((numeric - min) / (max - min)) * 100));
    }

    private pearson(points: any[]) {
        if (points.length < 2) return null;
        const xAverage = this.average(points.map((point: any) => point[0]));
        const yAverage = this.average(points.map((point: any) => point[1]));
        if (xAverage === null || yAverage === null) return null;
        let numerator = 0;
        let xSum = 0;
        let ySum = 0;
        for (const [x, y] of points) {
            numerator += (x - xAverage) * (y - yAverage);
            xSum += Math.pow(x - xAverage, 2);
            ySum += Math.pow(y - yAverage, 2);
        }
        if (!xSum || !ySum) return null;
        return numerator / Math.sqrt(xSum * ySum);
    }

    private describeCorrelation(value: number | null) {
        if (value === null || value === undefined) return "데이터 부족";
        const absolute = Math.abs(value);
        if (absolute < 0.2) return "뚜렷한 상관 낮음";
        const direction = value >= 0 ? "양의" : "음의";
        if (absolute >= 0.7) return `강한 ${direction} 상관`;
        if (absolute >= 0.4) return `중간 수준 ${direction} 상관`;
        return `약한 ${direction} 상관`;
    }

    private describePValue(value: number | null) {
        if (value === null || value === undefined) return "p-value 계산 불가";
        if (value < 0.001) return "통계적으로 매우 유의";
        if (value < 0.05) return "통계적으로 유의";
        return "통계적으로 유의하지 않음";
    }

    private describeCorrelationInterpretation(yLabel: string, coefficient: number | null, pValue: number | null, rSquared: number | null) {
        if (coefficient === null || coefficient === undefined || pValue === null || pValue === undefined) {
            return "상관관계를 해석할 수 있는 cell 데이터가 부족합니다.";
        }
        const significance = pValue < 0.05 ? "통계적으로 유의합니다" : "통계적으로 유의하지 않습니다";
        const explained = rSquared === null || rSquared === undefined ? "" : ` 설명력은 약 ${this.format(rSquared * 100, 1)}%입니다.`;
        return `MMD_STD와 ${yLabel}는 ${this.describeCorrelation(coefficient)}이며 ${significance}.${explained}`;
    }

    private paddedDomain(values: number[]) {
        const extent = this.numericExtent(values);
        if (!extent) return { min: 0, max: 1 };
        const min = extent.min;
        const max = extent.max;
        const range = max - min;
        const pad = range ? range * 0.16 : Math.max(Math.abs(max) * 0.08, 1);
        return { min: min - pad, max: max + pad };
    }

    private buildTicks(min: number, max: number, count: number) {
        if (count <= 1) return [min];
        const step = (max - min) / (count - 1);
        return Array.from({ length: count }, (_: any, index: number) => min + step * index);
    }

    private scaleSvgX(value: number, min: number, max: number, svg: any) {
        const width = svg.width - svg.left - svg.right;
        if (min === max) return svg.left + width / 2;
        return svg.left + ((value - min) / (max - min)) * width;
    }

    private scaleSvgY(value: number, min: number, max: number, svg: any) {
        const height = svg.height - svg.top - svg.bottom;
        if (min === max) return svg.top + height / 2;
        return svg.top + (1 - ((value - min) / (max - min))) * height;
    }

    private linearRegression(points: any[]) {
        if (points.length < 2) return null;
        const xAverage = this.average(points.map((point: any) => point[0]));
        const yAverage = this.average(points.map((point: any) => point[1]));
        if (xAverage === null || yAverage === null) return null;
        let numerator = 0;
        let denominator = 0;
        for (const [x, y] of points) {
            numerator += (x - xAverage) * (y - yAverage);
            denominator += Math.pow(x - xAverage, 2);
        }
        if (!denominator) return null;
        const slope = numerator / denominator;
        return { slope, intercept: yAverage - slope * xAverage };
    }

    private pearsonPValue(coefficient: number | null, count: number) {
        if (coefficient === null || count < 3) return null;
        const absolute = Math.abs(coefficient);
        if (absolute >= 1) return Number.MIN_VALUE;
        const df = count - 2;
        const t = absolute * Math.sqrt(df / ((1 - absolute) * (1 + absolute)));
        const x = df / (df + t * t);
        return Math.max(0, Math.min(1, this.regularizedIncompleteBeta(x, df / 2, 0.5)));
    }

    private regularizedIncompleteBeta(x: number, a: number, b: number) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        const logBetaTerm = this.logGamma(a + b) - this.logGamma(a) - this.logGamma(b)
            + a * Math.log(x) + b * Math.log1p(-x);
        const betaTerm = Math.exp(logBetaTerm);
        if (x < (a + 1) / (a + b + 2)) {
            return (betaTerm * this.betaContinuedFraction(a, b, x)) / a;
        }
        return 1 - (betaTerm * this.betaContinuedFraction(b, a, 1 - x)) / b;
    }

    private betaContinuedFraction(a: number, b: number, x: number) {
        const maxIterations = 200;
        const epsilon = 3e-14;
        const minFloat = 1e-300;
        const qab = a + b;
        const qap = a + 1;
        const qam = a - 1;
        let c = 1;
        let d = 1 - (qab * x) / qap;
        if (Math.abs(d) < minFloat) d = minFloat;
        d = 1 / d;
        let h = d;

        for (let index = 1; index <= maxIterations; index++) {
            const doubled = 2 * index;
            let aa = (index * (b - index) * x) / ((qam + doubled) * (a + doubled));
            d = 1 + aa * d;
            if (Math.abs(d) < minFloat) d = minFloat;
            c = 1 + aa / c;
            if (Math.abs(c) < minFloat) c = minFloat;
            d = 1 / d;
            h *= d * c;

            aa = -((a + index) * (qab + index) * x) / ((a + doubled) * (qap + doubled));
            d = 1 + aa * d;
            if (Math.abs(d) < minFloat) d = minFloat;
            c = 1 + aa / c;
            if (Math.abs(c) < minFloat) c = minFloat;
            d = 1 / d;
            const delta = d * c;
            h *= delta;
            if (Math.abs(delta - 1) < epsilon) break;
        }

        return h;
    }

    private logGamma(value: number): number {
        const coefficients = [
            676.5203681218851,
            -1259.1392167224028,
            771.32342877765313,
            -176.61502916214059,
            12.507343278686905,
            -0.13857109526572012,
            9.9843695780195716e-6,
            1.5056327351493116e-7,
        ];
        if (value < 0.5) return Math.log(Math.PI) - Math.log(Math.sin(Math.PI * value)) - this.logGamma(1 - value);
        let x = 0.99999999999980993;
        const adjusted = value - 1;
        for (let index = 0; index < coefficients.length; index++) {
            x += coefficients[index] / (adjusted + index + 1);
        }
        const t = adjusted + coefficients.length - 0.5;
        return 0.5 * Math.log(2 * Math.PI) + (adjusted + 0.5) * Math.log(t) - t + Math.log(x);
    }
}

export default PageReportComponent;